[
  {
    "codigoIbge": 1100015,
    "nome": "Alta Floresta D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100031,
    "nome": "Cabixi",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100056,
    "nome": "Cerejeiras",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100064,
    "nome": "Colorado do Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100072,
    "nome": "Corumbiara",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100080,
    "nome": "Costa Marques",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100098,
    "nome": "Espigão D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100106,
    "nome": "Guajará-Mirim",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100114,
    "nome": "Jaru",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100130,
    "nome": "Machadinho D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100148,
    "nome": "Nova Brasilândia D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100155,
    "nome": "Ouro Preto do Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100189,
    "nome": "Pimenta Bueno",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100254,
    "nome": "Presidente Médici",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100262,
    "nome": "Rio Crespo",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100288,
    "nome": "Rolim de Moura",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100296,
    "nome": "Santa Luzia D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100320,
    "nome": "São Miguel do Guaporé",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100338,
    "nome": "Nova Mamoré",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100346,
    "nome": "Alvorada D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100379,
    "nome": "Alto Alegre dos Parecis",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100403,
    "nome": "Alto Paraíso",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100452,
    "nome": "Buritis",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100502,
    "nome": "Novo Horizonte do Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100601,
    "nome": "Cacaulândia",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100700,
    "nome": "Campo Novo de Rondônia",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100809,
    "nome": "Candeias do Jamari",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100908,
    "nome": "Castanheiras",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100924,
    "nome": "Chupinguaia",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1100940,
    "nome": "Cujubim",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101005,
    "nome": "Governador Jorge Teixeira",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101104,
    "nome": "Itapuã do Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101203,
    "nome": "Ministro Andreazza",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101302,
    "nome": "Mirante da Serra",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101401,
    "nome": "Monte Negro",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101435,
    "nome": "Nova União",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101450,
    "nome": "Parecis",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101468,
    "nome": "Pimenteiras do Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101476,
    "nome": "Primavera de Rondônia",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101484,
    "nome": "São Felipe D'Oeste",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101492,
    "nome": "São Francisco do Guaporé",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101500,
    "nome": "Seringueiras",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101559,
    "nome": "Teixeirópolis",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101609,
    "nome": "Theobroma",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101708,
    "nome": "Urupá",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101757,
    "nome": "Vale do Anari",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1101807,
    "nome": "Vale do Paraíso",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200013,
    "nome": "Acrelândia",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200054,
    "nome": "Assis Brasil",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200104,
    "nome": "Brasiléia",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200138,
    "nome": "Bujari",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200179,
    "nome": "Capixaba",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200203,
    "nome": "Cruzeiro do Sul",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200252,
    "nome": "Epitaciolândia",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200302,
    "nome": "Feijó",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200328,
    "nome": "Jordão",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200336,
    "nome": "Mâncio Lima",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200344,
    "nome": "Manoel Urbano",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200351,
    "nome": "Marechal Thaumaturgo",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200385,
    "nome": "Plácido de Castro",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200393,
    "nome": "Porto Walter",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200427,
    "nome": "Rodrigues Alves",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200435,
    "nome": "Santa Rosa do Purus",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200450,
    "nome": "Senador Guiomard",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200500,
    "nome": "Sena Madureira",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200609,
    "nome": "Tarauacá",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200708,
    "nome": "Xapuri",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1200807,
    "nome": "Porto Acre",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300029,
    "nome": "Alvarães",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300060,
    "nome": "Amaturá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300086,
    "nome": "Anamã",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300102,
    "nome": "Anori",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300144,
    "nome": "Apuí",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300201,
    "nome": "Atalaia do Norte",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300300,
    "nome": "Autazes",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300409,
    "nome": "Barcelos",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300508,
    "nome": "Barreirinha",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300607,
    "nome": "Benjamin Constant",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300631,
    "nome": "Beruri",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300680,
    "nome": "Boa Vista do Ramos",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300706,
    "nome": "Boca do Acre",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300805,
    "nome": "Borba",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300839,
    "nome": "Caapiranga",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1300904,
    "nome": "Canutama",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301001,
    "nome": "Carauari",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301100,
    "nome": "Careiro",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301159,
    "nome": "Careiro da Várzea",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301308,
    "nome": "Codajás",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301407,
    "nome": "Eirunepé",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301506,
    "nome": "Envira",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301605,
    "nome": "Fonte Boa",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301654,
    "nome": "Guajará",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301704,
    "nome": "Humaitá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301803,
    "nome": "Ipixuna",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301852,
    "nome": "Iranduba",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301902,
    "nome": "Itacoatiara",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1301951,
    "nome": "Itamarati",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302009,
    "nome": "Itapiranga",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302108,
    "nome": "Japurá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302207,
    "nome": "Juruá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302306,
    "nome": "Jutaí",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302405,
    "nome": "Lábrea",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302504,
    "nome": "Manacapuru",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302553,
    "nome": "Manaquiri",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302702,
    "nome": "Manicoré",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302801,
    "nome": "Maraã",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1302900,
    "nome": "Maués",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303007,
    "nome": "Nhamundá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303106,
    "nome": "Nova Olinda do Norte",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303205,
    "nome": "Novo Airão",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303304,
    "nome": "Novo Aripuanã",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303403,
    "nome": "Parintins",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303502,
    "nome": "Pauini",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303536,
    "nome": "Presidente Figueiredo",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303569,
    "nome": "Rio Preto da Eva",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303601,
    "nome": "Santa Isabel do Rio Negro",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303700,
    "nome": "Santo Antônio do Içá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303809,
    "nome": "São Gabriel da Cachoeira",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303908,
    "nome": "São Paulo de Olivença",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1303957,
    "nome": "São Sebastião do Uatumã",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304005,
    "nome": "Silves",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304062,
    "nome": "Tabatinga",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304104,
    "nome": "Tapauá",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304203,
    "nome": "Tefé",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304237,
    "nome": "Tonantins",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304260,
    "nome": "Uarini",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304302,
    "nome": "Urucará",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1304401,
    "nome": "Urucurituba",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400027,
    "nome": "Amajari",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400050,
    "nome": "Alto Alegre",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400159,
    "nome": "Bonfim",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400175,
    "nome": "Cantá",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400209,
    "nome": "Caracaraí",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400233,
    "nome": "Caroebe",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400282,
    "nome": "Iracema",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400308,
    "nome": "Mucajaí",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400407,
    "nome": "Normandia",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400456,
    "nome": "Pacaraima",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400472,
    "nome": "Rorainópolis",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400506,
    "nome": "São João da Baliza",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400605,
    "nome": "São Luiz do Anauá",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1400704,
    "nome": "Uiramutã",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500107,
    "nome": "Abaetetuba",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500131,
    "nome": "Abel Figueiredo",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500206,
    "nome": "Acará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500305,
    "nome": "Afuá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500347,
    "nome": "Água Azul do Norte",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500404,
    "nome": "Alenquer",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500503,
    "nome": "Almeirim",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500701,
    "nome": "Anajás",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500859,
    "nome": "Anapu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500909,
    "nome": "Augusto Corrêa",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1500958,
    "nome": "Aurora do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501006,
    "nome": "Aveiro",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501105,
    "nome": "Bagre",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501204,
    "nome": "Baião",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501253,
    "nome": "Bannach",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501451,
    "nome": "Belterra",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501501,
    "nome": "Benevides",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501576,
    "nome": "Bom Jesus do Tocantins",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501600,
    "nome": "Bonito",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501709,
    "nome": "Bragança",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501725,
    "nome": "Brasil Novo",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501758,
    "nome": "Brejo Grande do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501782,
    "nome": "Breu Branco",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501808,
    "nome": "Breves",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501907,
    "nome": "Bujaru",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1501956,
    "nome": "Cachoeira do Piriá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502004,
    "nome": "Cachoeira do Arari",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502103,
    "nome": "Cametá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502202,
    "nome": "Capanema",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502301,
    "nome": "Capitão Poço",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502509,
    "nome": "Chaves",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502608,
    "nome": "Colares",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502707,
    "nome": "Conceição do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502756,
    "nome": "Concórdia do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502764,
    "nome": "Cumaru do Norte",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502772,
    "nome": "Curionópolis",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502806,
    "nome": "Curralinho",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502855,
    "nome": "Curuá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502905,
    "nome": "Curuçá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502939,
    "nome": "Dom Eliseu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1502954,
    "nome": "Eldorado do Carajás",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503002,
    "nome": "Faro",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503044,
    "nome": "Floresta do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503077,
    "nome": "Garrafão do Norte",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503093,
    "nome": "Goianésia do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503101,
    "nome": "Gurupá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503200,
    "nome": "Igarapé-Açu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503309,
    "nome": "Igarapé-Miri",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503408,
    "nome": "Inhangapi",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503457,
    "nome": "Ipixuna do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503507,
    "nome": "Irituia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503705,
    "nome": "Itupiranga",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503754,
    "nome": "Jacareacanga",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503804,
    "nome": "Jacundá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1503903,
    "nome": "Juruti",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504000,
    "nome": "Limoeiro do Ajuru",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504059,
    "nome": "Mãe do Rio",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504109,
    "nome": "Magalhães Barata",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504307,
    "nome": "Maracanã",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504406,
    "nome": "Marapanim",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504422,
    "nome": "Marituba",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504455,
    "nome": "Medicilândia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504505,
    "nome": "Melgaço",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504604,
    "nome": "Mocajuba",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504703,
    "nome": "Moju",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504752,
    "nome": "Mojuí dos Campos",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504802,
    "nome": "Monte Alegre",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504901,
    "nome": "Muaná",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504950,
    "nome": "Nova Esperança do Piriá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1504976,
    "nome": "Nova Ipixuna",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505007,
    "nome": "Nova Timboteua",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505031,
    "nome": "Novo Progresso",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505064,
    "nome": "Novo Repartimento",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505106,
    "nome": "Óbidos",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505205,
    "nome": "Oeiras do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505304,
    "nome": "Oriximiná",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505403,
    "nome": "Ourém",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505437,
    "nome": "Ourilândia do Norte",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505486,
    "nome": "Pacajá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505494,
    "nome": "Palestina do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505551,
    "nome": "Pau D'Arco",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505601,
    "nome": "Peixe-Boi",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505635,
    "nome": "Piçarra",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505650,
    "nome": "Placas",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505700,
    "nome": "Ponta de Pedras",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505809,
    "nome": "Portel",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1505908,
    "nome": "Porto de Moz",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506005,
    "nome": "Prainha",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506104,
    "nome": "Primavera",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506112,
    "nome": "Quatipuru",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506161,
    "nome": "Rio Maria",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506187,
    "nome": "Rondon do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506195,
    "nome": "Rurópolis",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506203,
    "nome": "Salinópolis",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506302,
    "nome": "Salvaterra",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506351,
    "nome": "Santa Bárbara do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506401,
    "nome": "Santa Cruz do Arari",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506500,
    "nome": "Santa Izabel do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506559,
    "nome": "Santa Luzia do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506583,
    "nome": "Santa Maria das Barreiras",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506609,
    "nome": "Santa Maria do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506708,
    "nome": "Santana do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1506906,
    "nome": "Santarém Novo",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507003,
    "nome": "Santo Antônio do Tauá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507102,
    "nome": "São Caetano de Odivelas",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507151,
    "nome": "São Domingos do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507201,
    "nome": "São Domingos do Capim",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507300,
    "nome": "São Félix do Xingu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507409,
    "nome": "São Francisco do Pará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507458,
    "nome": "São Geraldo do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507466,
    "nome": "São João da Ponta",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507474,
    "nome": "São João de Pirabas",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507508,
    "nome": "São João do Araguaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507607,
    "nome": "São Miguel do Guamá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507706,
    "nome": "São Sebastião da Boa Vista",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507755,
    "nome": "Sapucaia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507805,
    "nome": "Senador José Porfírio",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507904,
    "nome": "Soure",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507953,
    "nome": "Tailândia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507961,
    "nome": "Terra Alta",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1507979,
    "nome": "Terra Santa",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508001,
    "nome": "Tomé-Açu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508035,
    "nome": "Tracuateua",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508050,
    "nome": "Trairão",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508084,
    "nome": "Tucumã",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508126,
    "nome": "Ulianópolis",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508159,
    "nome": "Uruará",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508209,
    "nome": "Vigia",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508308,
    "nome": "Viseu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1508407,
    "nome": "Xinguara",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600055,
    "nome": "Serra do Navio",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600105,
    "nome": "Amapá",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600154,
    "nome": "Pedra Branca do Amapari",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600204,
    "nome": "Calçoene",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600212,
    "nome": "Cutias",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600238,
    "nome": "Ferreira Gomes",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600253,
    "nome": "Itaubal",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600279,
    "nome": "Laranjal do Jari",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600402,
    "nome": "Mazagão",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600501,
    "nome": "Oiapoque",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600535,
    "nome": "Porto Grande",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600550,
    "nome": "Pracuúba",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600709,
    "nome": "Tartarugalzinho",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1600808,
    "nome": "Vitória do Jari",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1700251,
    "nome": "Abreulândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1700301,
    "nome": "Aguiarnópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1700350,
    "nome": "Aliança do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1700400,
    "nome": "Almas",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1700707,
    "nome": "Alvorada",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1701002,
    "nome": "Ananás",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1701051,
    "nome": "Angico",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1701101,
    "nome": "Aparecida do Rio Negro",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1701309,
    "nome": "Aragominas",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1701903,
    "nome": "Araguacema",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702000,
    "nome": "Araguaçu",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702158,
    "nome": "Araguanã",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702208,
    "nome": "Araguatins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702307,
    "nome": "Arapoema",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702406,
    "nome": "Arraias",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702554,
    "nome": "Augustinópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702703,
    "nome": "Aurora do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1702901,
    "nome": "Axixá do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703008,
    "nome": "Babaçulândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703057,
    "nome": "Bandeirantes do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703073,
    "nome": "Barra do Ouro",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703107,
    "nome": "Barrolândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703206,
    "nome": "Bernardo Sayão",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703305,
    "nome": "Bom Jesus do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703602,
    "nome": "Brasilândia do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703701,
    "nome": "Brejinho de Nazaré",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703800,
    "nome": "Buriti do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703826,
    "nome": "Cachoeirinha",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703842,
    "nome": "Campos Lindos",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703867,
    "nome": "Cariri do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703883,
    "nome": "Carmolândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703891,
    "nome": "Carrasco Bonito",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1703909,
    "nome": "Caseara",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1704105,
    "nome": "Centenário",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1704600,
    "nome": "Chapada de Areia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1705102,
    "nome": "Chapada da Natividade",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1705508,
    "nome": "Colinas do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1705557,
    "nome": "Combinado",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1705607,
    "nome": "Conceição do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1706001,
    "nome": "Couto Magalhães",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1706100,
    "nome": "Cristalândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1706258,
    "nome": "Crixás do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1706506,
    "nome": "Darcinópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707009,
    "nome": "Dianópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707108,
    "nome": "Divinópolis do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707207,
    "nome": "Dois Irmãos do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707306,
    "nome": "Dueré",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707405,
    "nome": "Esperantina",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707553,
    "nome": "Fátima",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707652,
    "nome": "Figueirópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1707702,
    "nome": "Filadélfia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1708205,
    "nome": "Formoso do Araguaia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1708254,
    "nome": "Tabocão",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1708304,
    "nome": "Goianorte",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1709005,
    "nome": "Goiatins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1709302,
    "nome": "Guaraí",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1709807,
    "nome": "Ipueiras",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1710508,
    "nome": "Itacajá",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1710706,
    "nome": "Itaguatins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1710904,
    "nome": "Itapiratins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1711100,
    "nome": "Itaporã do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1711506,
    "nome": "Jaú do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1711803,
    "nome": "Juarina",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1711902,
    "nome": "Lagoa da Confusão",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1711951,
    "nome": "Lagoa do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712009,
    "nome": "Lajeado",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712157,
    "nome": "Lavandeira",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712405,
    "nome": "Lizarda",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712454,
    "nome": "Luzinópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712504,
    "nome": "Marianópolis do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712702,
    "nome": "Mateiros",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1712801,
    "nome": "Maurilândia do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1713205,
    "nome": "Miracema do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1713304,
    "nome": "Miranorte",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1713601,
    "nome": "Monte do Carmo",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1713700,
    "nome": "Monte Santo do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1713809,
    "nome": "Palmeiras do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1713957,
    "nome": "Muricilândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1714203,
    "nome": "Natividade",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1714302,
    "nome": "Nazaré",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1714880,
    "nome": "Nova Olinda",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715002,
    "nome": "Nova Rosalândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715101,
    "nome": "Novo Acordo",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715150,
    "nome": "Novo Alegre",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715259,
    "nome": "Novo Jardim",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715507,
    "nome": "Oliveira de Fátima",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715705,
    "nome": "Palmeirante",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1715754,
    "nome": "Palmeirópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716109,
    "nome": "Paraíso do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716208,
    "nome": "Paranã",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716307,
    "nome": "Pau D'Arco",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716505,
    "nome": "Pedro Afonso",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716604,
    "nome": "Peixe",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716653,
    "nome": "Pequizeiro",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1716703,
    "nome": "Colméia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1717008,
    "nome": "Pindorama do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1717206,
    "nome": "Piraquê",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1717503,
    "nome": "Pium",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1717800,
    "nome": "Ponte Alta do Bom Jesus",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1717909,
    "nome": "Ponte Alta do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718006,
    "nome": "Porto Alegre do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718303,
    "nome": "Praia Norte",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718402,
    "nome": "Presidente Kennedy",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718451,
    "nome": "Pugmil",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718501,
    "nome": "Recursolândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718550,
    "nome": "Riachinho",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718659,
    "nome": "Rio da Conceição",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718709,
    "nome": "Rio dos Bois",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718758,
    "nome": "Rio Sono",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718808,
    "nome": "Sampaio",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718840,
    "nome": "Sandolândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718865,
    "nome": "Santa Fé do Araguaia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718881,
    "nome": "Santa Maria do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718899,
    "nome": "Santa Rita do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1718907,
    "nome": "Santa Rosa do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1719004,
    "nome": "Santa Tereza do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720002,
    "nome": "Santa Terezinha do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720101,
    "nome": "São Bento do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720150,
    "nome": "São Félix do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720200,
    "nome": "São Miguel do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720259,
    "nome": "São Salvador do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720309,
    "nome": "São Sebastião do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720499,
    "nome": "São Valério",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720655,
    "nome": "Silvanópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720804,
    "nome": "Sítio Novo do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720853,
    "nome": "Sucupira",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720903,
    "nome": "Taguatinga",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720937,
    "nome": "Taipas do Tocantins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1720978,
    "nome": "Talismã",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1721109,
    "nome": "Tocantínia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1721208,
    "nome": "Tocantinópolis",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1721257,
    "nome": "Tupirama",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1721307,
    "nome": "Tupiratins",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1722081,
    "nome": "Wanderlândia",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 1722107,
    "nome": "Xambioá",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100105,
    "nome": "Afonso Cunha",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100154,
    "nome": "Água Doce do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100204,
    "nome": "Alcântara",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100303,
    "nome": "Aldeias Altas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100402,
    "nome": "Altamira do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100436,
    "nome": "Alto Alegre do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100477,
    "nome": "Alto Alegre do Pindaré",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100501,
    "nome": "Alto Parnaíba",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100550,
    "nome": "Amapá do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100600,
    "nome": "Amarante do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100709,
    "nome": "Anajatuba",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100808,
    "nome": "Anapurus",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100832,
    "nome": "Apicum-Açu",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100873,
    "nome": "Araguanã",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100907,
    "nome": "Araioses",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2100956,
    "nome": "Arame",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101004,
    "nome": "Arari",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101103,
    "nome": "Axixá",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101202,
    "nome": "Bacabal",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101251,
    "nome": "Bacabeira",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101301,
    "nome": "Bacuri",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101350,
    "nome": "Bacurituba",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101509,
    "nome": "Barão de Grajaú",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101608,
    "nome": "Barra do Corda",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101707,
    "nome": "Barreirinhas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101731,
    "nome": "Belágua",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101772,
    "nome": "Bela Vista do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101806,
    "nome": "Benedito Leite",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101905,
    "nome": "Bequimão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101939,
    "nome": "Bernardo do Mearim",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2101970,
    "nome": "Boa Vista do Gurupi",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102002,
    "nome": "Bom Jardim",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102036,
    "nome": "Bom Jesus das Selvas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102077,
    "nome": "Bom Lugar",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102101,
    "nome": "Brejo",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102150,
    "nome": "Brejo de Areia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102200,
    "nome": "Buriti",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102309,
    "nome": "Buriti Bravo",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102325,
    "nome": "Buriticupu",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102358,
    "nome": "Buritirana",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102374,
    "nome": "Cachoeira Grande",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102408,
    "nome": "Cajapió",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102507,
    "nome": "Cajari",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102556,
    "nome": "Campestre do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102606,
    "nome": "Cândido Mendes",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102705,
    "nome": "Cantanhede",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102754,
    "nome": "Capinzal do Norte",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102804,
    "nome": "Carolina",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2102903,
    "nome": "Carutapera",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103000,
    "nome": "Caxias",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103109,
    "nome": "Cedral",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103125,
    "nome": "Central do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103158,
    "nome": "Centro do Guilherme",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103174,
    "nome": "Centro Novo do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103208,
    "nome": "Chapadinha",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103257,
    "nome": "Cidelândia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103307,
    "nome": "Codó",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103406,
    "nome": "Coelho Neto",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103505,
    "nome": "Colinas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103554,
    "nome": "Conceição do Lago-Açu",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103604,
    "nome": "Coroatá",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103703,
    "nome": "Cururupu",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103752,
    "nome": "Davinópolis",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103802,
    "nome": "Dom Pedro",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2103901,
    "nome": "Duque Bacelar",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104008,
    "nome": "Esperantinópolis",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104057,
    "nome": "Estreito",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104073,
    "nome": "Feira Nova do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104081,
    "nome": "Fernando Falcão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104099,
    "nome": "Formosa da Serra Negra",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104107,
    "nome": "Fortaleza dos Nogueiras",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104206,
    "nome": "Fortuna",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104305,
    "nome": "Godofredo Viana",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104404,
    "nome": "Gonçalves Dias",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104503,
    "nome": "Governador Archer",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104552,
    "nome": "Governador Edison Lobão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104602,
    "nome": "Governador Eugênio Barros",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104628,
    "nome": "Governador Luiz Rocha",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104651,
    "nome": "Governador Newton Bello",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104677,
    "nome": "Governador Nunes Freire",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104701,
    "nome": "Graça Aranha",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104800,
    "nome": "Grajaú",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2104909,
    "nome": "Guimarães",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105005,
    "nome": "Humberto de Campos",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105104,
    "nome": "Icatu",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105153,
    "nome": "Igarapé do Meio",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105203,
    "nome": "Igarapé Grande",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105351,
    "nome": "Itaipava do Grajaú",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105401,
    "nome": "Itapecuru Mirim",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105427,
    "nome": "Itinga do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105450,
    "nome": "Jatobá",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105476,
    "nome": "Jenipapo dos Vieiras",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105500,
    "nome": "João Lisboa",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105609,
    "nome": "Joselândia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105658,
    "nome": "Junco do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105708,
    "nome": "Lago da Pedra",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105807,
    "nome": "Lago do Junco",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105906,
    "nome": "Lago Verde",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105922,
    "nome": "Lagoa do Mato",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105948,
    "nome": "Lago dos Rodrigues",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105963,
    "nome": "Lagoa Grande do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2105989,
    "nome": "Lajeado Novo",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106003,
    "nome": "Lima Campos",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106102,
    "nome": "Loreto",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106201,
    "nome": "Luís Domingues",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106300,
    "nome": "Magalhães de Almeida",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106326,
    "nome": "Maracaçumé",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106359,
    "nome": "Marajá do Sena",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106375,
    "nome": "Maranhãozinho",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106409,
    "nome": "Mata Roma",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106508,
    "nome": "Matinha",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106607,
    "nome": "Matões",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106631,
    "nome": "Matões do Norte",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106672,
    "nome": "Milagres do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106706,
    "nome": "Mirador",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106755,
    "nome": "Miranda do Norte",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106805,
    "nome": "Mirinzal",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2106904,
    "nome": "Monção",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107001,
    "nome": "Montes Altos",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107100,
    "nome": "Morros",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107209,
    "nome": "Nina Rodrigues",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107258,
    "nome": "Nova Colinas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107308,
    "nome": "Nova Iorque",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107357,
    "nome": "Nova Olinda do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107407,
    "nome": "Olho d'Água das Cunhãs",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107456,
    "nome": "Olinda Nova do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107506,
    "nome": "Paço do Lumiar",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107605,
    "nome": "Palmeirândia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107704,
    "nome": "Paraibano",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107803,
    "nome": "Parnarama",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2107902,
    "nome": "Passagem Franca",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108009,
    "nome": "Pastos Bons",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108058,
    "nome": "Paulino Neves",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108108,
    "nome": "Paulo Ramos",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108207,
    "nome": "Pedreiras",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108256,
    "nome": "Pedro do Rosário",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108306,
    "nome": "Penalva",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108405,
    "nome": "Peri Mirim",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108454,
    "nome": "Peritoró",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108504,
    "nome": "Pindaré-Mirim",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108603,
    "nome": "Pinheiro",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108702,
    "nome": "Pio XII",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108801,
    "nome": "Pirapemas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2108900,
    "nome": "Poção de Pedras",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109007,
    "nome": "Porto Franco",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109056,
    "nome": "Porto Rico do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109106,
    "nome": "Presidente Dutra",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109205,
    "nome": "Presidente Juscelino",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109239,
    "nome": "Presidente Médici",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109270,
    "nome": "Presidente Sarney",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109304,
    "nome": "Presidente Vargas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109403,
    "nome": "Primeira Cruz",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109452,
    "nome": "Raposa",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109502,
    "nome": "Riachão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109551,
    "nome": "Ribamar Fiquene",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109601,
    "nome": "Rosário",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109700,
    "nome": "Sambaíba",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109759,
    "nome": "Santa Filomena do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109809,
    "nome": "Santa Helena",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2109908,
    "nome": "Santa Inês",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110005,
    "nome": "Santa Luzia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110039,
    "nome": "Santa Luzia do Paruá",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110104,
    "nome": "Santa Quitéria do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110203,
    "nome": "Santa Rita",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110237,
    "nome": "Santana do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110278,
    "nome": "Santo Amaro do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110401,
    "nome": "São Benedito do Rio Preto",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110500,
    "nome": "São Bento",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110609,
    "nome": "São Bernardo",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110658,
    "nome": "São Domingos do Azeitão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110708,
    "nome": "São Domingos do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110807,
    "nome": "São Félix de Balsas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110856,
    "nome": "São Francisco do Brejão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2110906,
    "nome": "São Francisco do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111003,
    "nome": "São João Batista",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111029,
    "nome": "São João do Carú",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111052,
    "nome": "São João do Paraíso",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111078,
    "nome": "São João do Soter",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111102,
    "nome": "São João dos Patos",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111250,
    "nome": "São José dos Basílios",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111409,
    "nome": "São Luís Gonzaga do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111508,
    "nome": "São Mateus do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111532,
    "nome": "São Pedro da Água Branca",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111573,
    "nome": "São Pedro dos Crentes",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111607,
    "nome": "São Raimundo das Mangabeiras",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111631,
    "nome": "São Raimundo do Doca Bezerra",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111672,
    "nome": "São Roberto",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111706,
    "nome": "São Vicente Ferrer",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111722,
    "nome": "Satubinha",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111748,
    "nome": "Senador Alexandre Costa",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111763,
    "nome": "Senador La Rocque",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111789,
    "nome": "Serrano do Maranhão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111805,
    "nome": "Sítio Novo",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111904,
    "nome": "Sucupira do Norte",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2111953,
    "nome": "Sucupira do Riachão",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112100,
    "nome": "Timbiras",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112209,
    "nome": "Timon",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112233,
    "nome": "Trizidela do Vale",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112274,
    "nome": "Tufilândia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112308,
    "nome": "Tuntum",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112407,
    "nome": "Turiaçu",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112456,
    "nome": "Turilândia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112506,
    "nome": "Tutóia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112605,
    "nome": "Urbano Santos",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112704,
    "nome": "Vargem Grande",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112803,
    "nome": "Viana",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112852,
    "nome": "Vila Nova dos Martírios",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2112902,
    "nome": "Vitória do Mearim",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2113009,
    "nome": "Vitorino Freire",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2114007,
    "nome": "Zé Doca",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200053,
    "nome": "Acauã",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200103,
    "nome": "Agricolândia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200202,
    "nome": "Água Branca",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200251,
    "nome": "Alagoinha do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200277,
    "nome": "Alegrete do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200301,
    "nome": "Alto Longá",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200400,
    "nome": "Altos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200459,
    "nome": "Alvorada do Gurguéia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200509,
    "nome": "Amarante",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200608,
    "nome": "Angical do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200707,
    "nome": "Anísio de Abreu",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200806,
    "nome": "Antônio Almeida",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200905,
    "nome": "Aroazes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2200954,
    "nome": "Aroeiras do Itaim",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201002,
    "nome": "Arraial",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201051,
    "nome": "Assunção do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201101,
    "nome": "Avelino Lopes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201150,
    "nome": "Baixa Grande do Ribeiro",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201176,
    "nome": "Barra D'Alcântara",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201200,
    "nome": "Barras",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201309,
    "nome": "Barreiras do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201408,
    "nome": "Barro Duro",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201507,
    "nome": "Batalha",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201556,
    "nome": "Bela Vista do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201572,
    "nome": "Belém do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201606,
    "nome": "Beneditinos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201705,
    "nome": "Bertolínia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201739,
    "nome": "Betânia do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201770,
    "nome": "Boa Hora",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201804,
    "nome": "Bocaina",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201903,
    "nome": "Bom Jesus",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201919,
    "nome": "Bom Princípio do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201929,
    "nome": "Bonfim do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201945,
    "nome": "Boqueirão do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201960,
    "nome": "Brasileira",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2201988,
    "nome": "Brejo do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202000,
    "nome": "Buriti dos Lopes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202026,
    "nome": "Buriti dos Montes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202059,
    "nome": "Cabeceiras do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202075,
    "nome": "Cajazeiras do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202083,
    "nome": "Cajueiro da Praia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202091,
    "nome": "Caldeirão Grande do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202109,
    "nome": "Campinas do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202117,
    "nome": "Campo Alegre do Fidalgo",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202133,
    "nome": "Campo Grande do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202174,
    "nome": "Campo Largo do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202208,
    "nome": "Campo Maior",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202251,
    "nome": "Canavieira",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202307,
    "nome": "Canto do Buriti",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202406,
    "nome": "Capitão de Campos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202455,
    "nome": "Capitão Gervásio Oliveira",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202505,
    "nome": "Caracol",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202539,
    "nome": "Caraúbas do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202554,
    "nome": "Caridade do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202604,
    "nome": "Castelo do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202653,
    "nome": "Caxingó",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202703,
    "nome": "Cocal",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202711,
    "nome": "Cocal de Telha",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202729,
    "nome": "Cocal dos Alves",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202737,
    "nome": "Coivaras",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202752,
    "nome": "Colônia do Gurguéia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202778,
    "nome": "Colônia do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202802,
    "nome": "Conceição do Canindé",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202851,
    "nome": "Coronel José Dias",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2202901,
    "nome": "Corrente",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203008,
    "nome": "Cristalândia do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203107,
    "nome": "Cristino Castro",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203206,
    "nome": "Curimatá",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203230,
    "nome": "Currais",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203255,
    "nome": "Curralinhos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203271,
    "nome": "Curral Novo do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203305,
    "nome": "Demerval Lobão",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203354,
    "nome": "Dirceu Arcoverde",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203404,
    "nome": "Dom Expedito Lopes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203420,
    "nome": "Domingos Mourão",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203453,
    "nome": "Dom Inocêncio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203503,
    "nome": "Elesbão Veloso",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203602,
    "nome": "Eliseu Martins",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203701,
    "nome": "Esperantina",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203750,
    "nome": "Fartura do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203800,
    "nome": "Flores do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203859,
    "nome": "Floresta do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2203909,
    "nome": "Floriano",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204006,
    "nome": "Francinópolis",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204105,
    "nome": "Francisco Ayres",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204154,
    "nome": "Francisco Macedo",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204204,
    "nome": "Francisco Santos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204303,
    "nome": "Fronteiras",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204352,
    "nome": "Geminiano",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204402,
    "nome": "Gilbués",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204501,
    "nome": "Guadalupe",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204550,
    "nome": "Guaribas",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204600,
    "nome": "Hugo Napoleão",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204659,
    "nome": "Ilha Grande",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204709,
    "nome": "Inhuma",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204808,
    "nome": "Ipiranga do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2204907,
    "nome": "Isaías Coelho",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205003,
    "nome": "Itainópolis",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205102,
    "nome": "Itaueira",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205151,
    "nome": "Jacobina do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205201,
    "nome": "Jaicós",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205250,
    "nome": "Jardim do Mulato",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205276,
    "nome": "Jatobá do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205300,
    "nome": "Jerumenha",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205359,
    "nome": "João Costa",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205409,
    "nome": "Joaquim Pires",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205458,
    "nome": "Joca Marques",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205508,
    "nome": "José de Freitas",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205516,
    "nome": "Juazeiro do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205524,
    "nome": "Júlio Borges",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205532,
    "nome": "Jurema",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205540,
    "nome": "Lagoinha do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205557,
    "nome": "Lagoa Alegre",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205565,
    "nome": "Lagoa do Barro do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205573,
    "nome": "Lagoa de São Francisco",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205581,
    "nome": "Lagoa do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205599,
    "nome": "Lagoa do Sítio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205607,
    "nome": "Landri Sales",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205706,
    "nome": "Luís Correia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205805,
    "nome": "Luzilândia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205854,
    "nome": "Madeiro",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205904,
    "nome": "Manoel Emídio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2205953,
    "nome": "Marcolândia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206001,
    "nome": "Marcos Parente",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206050,
    "nome": "Massapê do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206100,
    "nome": "Matias Olímpio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206209,
    "nome": "Miguel Alves",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206308,
    "nome": "Miguel Leão",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206357,
    "nome": "Milton Brandão",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206407,
    "nome": "Monsenhor Gil",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206506,
    "nome": "Monsenhor Hipólito",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206605,
    "nome": "Monte Alegre do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206654,
    "nome": "Morro Cabeça no Tempo",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206670,
    "nome": "Morro do Chapéu do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206696,
    "nome": "Murici dos Portelas",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206704,
    "nome": "Nazaré do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206720,
    "nome": "Nazária",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206753,
    "nome": "Nossa Senhora de Nazaré",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206803,
    "nome": "Nossa Senhora dos Remédios",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206902,
    "nome": "Novo Oriente do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2206951,
    "nome": "Novo Santo Antônio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207009,
    "nome": "Oeiras",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207108,
    "nome": "Olho D'Água do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207207,
    "nome": "Padre Marcos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207306,
    "nome": "Paes Landim",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207355,
    "nome": "Pajeú do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207405,
    "nome": "Palmeira do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207504,
    "nome": "Palmeirais",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207553,
    "nome": "Paquetá",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207603,
    "nome": "Parnaguá",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207751,
    "nome": "Passagem Franca do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207777,
    "nome": "Patos do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207793,
    "nome": "Pau D'Arco do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207801,
    "nome": "Paulistana",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207850,
    "nome": "Pavussu",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207900,
    "nome": "Pedro II",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207934,
    "nome": "Pedro Laurentino",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2207959,
    "nome": "Nova Santa Rita",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208007,
    "nome": "Picos",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208106,
    "nome": "Pimenteiras",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208205,
    "nome": "Pio IX",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208304,
    "nome": "Piracuruca",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208403,
    "nome": "Piripiri",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208502,
    "nome": "Porto",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208551,
    "nome": "Porto Alegre do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208601,
    "nome": "Prata do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208650,
    "nome": "Queimada Nova",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208700,
    "nome": "Redenção do Gurguéia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208809,
    "nome": "Regeneração",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208858,
    "nome": "Riacho Frio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208874,
    "nome": "Ribeira do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2208908,
    "nome": "Ribeiro Gonçalves",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209005,
    "nome": "Rio Grande do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209104,
    "nome": "Santa Cruz do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209153,
    "nome": "Santa Cruz dos Milagres",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209203,
    "nome": "Santa Filomena",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209302,
    "nome": "Santa Luz",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209351,
    "nome": "Santana do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209377,
    "nome": "Santa Rosa do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209401,
    "nome": "Santo Antônio de Lisboa",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209450,
    "nome": "Santo Antônio dos Milagres",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209500,
    "nome": "Santo Inácio do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209559,
    "nome": "São Braz do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209609,
    "nome": "São Félix do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209658,
    "nome": "São Francisco de Assis do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209708,
    "nome": "São Francisco do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209757,
    "nome": "São Gonçalo do Gurguéia",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209807,
    "nome": "São Gonçalo do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209856,
    "nome": "São João da Canabrava",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209872,
    "nome": "São João da Fronteira",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209906,
    "nome": "São João da Serra",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209955,
    "nome": "São João da Varjota",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2209971,
    "nome": "São João do Arraial",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210003,
    "nome": "São João do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210052,
    "nome": "São José do Divino",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210102,
    "nome": "São José do Peixe",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210201,
    "nome": "São José do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210300,
    "nome": "São Julião",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210359,
    "nome": "São Lourenço do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210375,
    "nome": "São Luis do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210383,
    "nome": "São Miguel da Baixa Grande",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210391,
    "nome": "São Miguel do Fidalgo",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210409,
    "nome": "São Miguel do Tapuio",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210508,
    "nome": "São Pedro do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210607,
    "nome": "São Raimundo Nonato",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210623,
    "nome": "Sebastião Barros",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210631,
    "nome": "Sebastião Leal",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210656,
    "nome": "Sigefredo Pacheco",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210706,
    "nome": "Simões",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210805,
    "nome": "Simplício Mendes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210904,
    "nome": "Socorro do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210938,
    "nome": "Sussuapara",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210953,
    "nome": "Tamboril do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2210979,
    "nome": "Tanque do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211100,
    "nome": "União",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211308,
    "nome": "Valença do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211357,
    "nome": "Várzea Branca",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211407,
    "nome": "Várzea Grande",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211506,
    "nome": "Vera Mendes",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211605,
    "nome": "Vila Nova do Piauí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2211704,
    "nome": "Wall Ferraz",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300101,
    "nome": "Abaiara",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300150,
    "nome": "Acarape",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300200,
    "nome": "Acaraú",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300309,
    "nome": "Acopiara",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300408,
    "nome": "Aiuaba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300507,
    "nome": "Alcântaras",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300606,
    "nome": "Altaneira",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300705,
    "nome": "Alto Santo",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300754,
    "nome": "Amontada",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300804,
    "nome": "Antonina do Norte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2300903,
    "nome": "Apuiarés",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301109,
    "nome": "Aracati",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301208,
    "nome": "Aracoiaba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301257,
    "nome": "Ararendá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301307,
    "nome": "Araripe",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301406,
    "nome": "Aratuba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301505,
    "nome": "Arneiroz",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301604,
    "nome": "Assaré",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301703,
    "nome": "Aurora",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301802,
    "nome": "Baixio",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301851,
    "nome": "Banabuiú",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301901,
    "nome": "Barbalha",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2301950,
    "nome": "Barreira",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302008,
    "nome": "Barro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302057,
    "nome": "Barroquinha",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302107,
    "nome": "Baturité",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302206,
    "nome": "Beberibe",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302305,
    "nome": "Bela Cruz",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302404,
    "nome": "Boa Viagem",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302503,
    "nome": "Brejo Santo",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302602,
    "nome": "Camocim",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302701,
    "nome": "Campos Sales",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302800,
    "nome": "Canindé",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2302909,
    "nome": "Capistrano",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303006,
    "nome": "Caridade",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303105,
    "nome": "Cariré",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303204,
    "nome": "Caririaçu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303303,
    "nome": "Cariús",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303402,
    "nome": "Carnaubal",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303501,
    "nome": "Cascavel",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303600,
    "nome": "Catarina",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303659,
    "nome": "Catunda",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303808,
    "nome": "Cedro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303907,
    "nome": "Chaval",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303931,
    "nome": "Choró",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2303956,
    "nome": "Chorozinho",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304004,
    "nome": "Coreaú",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304103,
    "nome": "Crateús",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304202,
    "nome": "Crato",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304236,
    "nome": "Croatá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304251,
    "nome": "Cruz",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304269,
    "nome": "Deputado Irapuan Pinheiro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304277,
    "nome": "Ereré",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304301,
    "nome": "Farias Brito",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304350,
    "nome": "Forquilha",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304459,
    "nome": "Fortim",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304509,
    "nome": "Frecheirinha",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304608,
    "nome": "General Sampaio",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304657,
    "nome": "Graça",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304707,
    "nome": "Granja",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304806,
    "nome": "Granjeiro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304905,
    "nome": "Groaíras",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2304954,
    "nome": "Guaiúba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305001,
    "nome": "Guaraciaba do Norte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305100,
    "nome": "Guaramiranga",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305209,
    "nome": "Hidrolândia",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305233,
    "nome": "Horizonte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305266,
    "nome": "Ibaretama",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305308,
    "nome": "Ibiapina",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305332,
    "nome": "Ibicuitinga",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305357,
    "nome": "Icapuí",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305407,
    "nome": "Icó",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305506,
    "nome": "Iguatu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305605,
    "nome": "Independência",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305654,
    "nome": "Ipaporanga",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305704,
    "nome": "Ipaumirim",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305803,
    "nome": "Ipu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2305902,
    "nome": "Ipueiras",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306009,
    "nome": "Iracema",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306108,
    "nome": "Irauçuba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306207,
    "nome": "Itaiçaba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306256,
    "nome": "Itaitinga",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306306,
    "nome": "Itapajé",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306405,
    "nome": "Itapipoca",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306504,
    "nome": "Itapiúna",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306553,
    "nome": "Itarema",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306603,
    "nome": "Itatira",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306702,
    "nome": "Jaguaretama",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306801,
    "nome": "Jaguaribara",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2306900,
    "nome": "Jaguaribe",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307007,
    "nome": "Jaguaruana",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307106,
    "nome": "Jardim",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307205,
    "nome": "Jati",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307254,
    "nome": "Jijoca de Jericoacoara",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307403,
    "nome": "Jucás",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307502,
    "nome": "Lavras da Mangabeira",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307601,
    "nome": "Limoeiro do Norte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307635,
    "nome": "Madalena",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307700,
    "nome": "Maranguape",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307809,
    "nome": "Marco",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2307908,
    "nome": "Martinópole",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308005,
    "nome": "Massapê",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308104,
    "nome": "Mauriti",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308203,
    "nome": "Meruoca",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308302,
    "nome": "Milagres",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308351,
    "nome": "Milhã",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308377,
    "nome": "Miraíma",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308401,
    "nome": "Missão Velha",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308500,
    "nome": "Mombaça",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308609,
    "nome": "Monsenhor Tabosa",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308708,
    "nome": "Morada Nova",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308807,
    "nome": "Moraújo",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2308906,
    "nome": "Morrinhos",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309003,
    "nome": "Mucambo",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309102,
    "nome": "Mulungu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309201,
    "nome": "Nova Olinda",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309300,
    "nome": "Nova Russas",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309409,
    "nome": "Novo Oriente",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309458,
    "nome": "Ocara",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309508,
    "nome": "Orós",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309607,
    "nome": "Pacajus",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309706,
    "nome": "Pacatuba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309805,
    "nome": "Pacoti",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2309904,
    "nome": "Pacujá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310001,
    "nome": "Palhano",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310100,
    "nome": "Palmácia",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310209,
    "nome": "Paracuru",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310258,
    "nome": "Paraipaba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310308,
    "nome": "Parambu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310407,
    "nome": "Paramoti",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310506,
    "nome": "Pedra Branca",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310605,
    "nome": "Penaforte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310704,
    "nome": "Pentecoste",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310803,
    "nome": "Pereiro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310852,
    "nome": "Pindoretama",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310902,
    "nome": "Piquet Carneiro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2310951,
    "nome": "Pires Ferreira",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311009,
    "nome": "Poranga",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311108,
    "nome": "Porteiras",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311207,
    "nome": "Potengi",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311231,
    "nome": "Potiretama",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311264,
    "nome": "Quiterianópolis",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311306,
    "nome": "Quixadá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311355,
    "nome": "Quixelô",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311405,
    "nome": "Quixeramobim",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311504,
    "nome": "Quixeré",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311603,
    "nome": "Redenção",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311702,
    "nome": "Reriutaba",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311801,
    "nome": "Russas",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311900,
    "nome": "Saboeiro",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2311959,
    "nome": "Salitre",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312007,
    "nome": "Santana do Acaraú",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312106,
    "nome": "Santana do Cariri",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312205,
    "nome": "Santa Quitéria",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312304,
    "nome": "São Benedito",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312502,
    "nome": "São João do Jaguaribe",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312601,
    "nome": "São Luís do Curu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312700,
    "nome": "Senador Pompeu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2312809,
    "nome": "Senador Sá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313005,
    "nome": "Solonópole",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313104,
    "nome": "Tabuleiro do Norte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313203,
    "nome": "Tamboril",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313252,
    "nome": "Tarrafas",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313302,
    "nome": "Tauá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313351,
    "nome": "Tejuçuoca",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313401,
    "nome": "Tianguá",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313500,
    "nome": "Trairi",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313559,
    "nome": "Tururu",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313609,
    "nome": "Ubajara",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313708,
    "nome": "Umari",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313757,
    "nome": "Umirim",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313807,
    "nome": "Uruburetama",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313906,
    "nome": "Uruoca",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2313955,
    "nome": "Varjota",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2314003,
    "nome": "Várzea Alegre",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2314102,
    "nome": "Viçosa do Ceará",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400109,
    "nome": "Acari",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400208,
    "nome": "Assú",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400307,
    "nome": "Afonso Bezerra",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400406,
    "nome": "Água Nova",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400505,
    "nome": "Alexandria",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400604,
    "nome": "Almino Afonso",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400703,
    "nome": "Alto do Rodrigues",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400802,
    "nome": "Angicos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2400901,
    "nome": "Antônio Martins",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401008,
    "nome": "Apodi",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401107,
    "nome": "Areia Branca",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401206,
    "nome": "Arez",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401305,
    "nome": "Campo Grande",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401404,
    "nome": "Baía Formosa",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401453,
    "nome": "Baraúna",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401503,
    "nome": "Barcelona",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401602,
    "nome": "Bento Fernandes",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401651,
    "nome": "Bodó",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401701,
    "nome": "Bom Jesus",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401800,
    "nome": "Brejinho",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401859,
    "nome": "Caiçara do Norte",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2401909,
    "nome": "Caiçara do Rio do Vento",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402006,
    "nome": "Caicó",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402105,
    "nome": "Campo Redondo",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402204,
    "nome": "Canguaretama",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402303,
    "nome": "Caraúbas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402402,
    "nome": "Carnaúba dos Dantas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402501,
    "nome": "Carnaubais",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402600,
    "nome": "Ceará-Mirim",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402709,
    "nome": "Cerro Corá",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402808,
    "nome": "Coronel Ezequiel",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2402907,
    "nome": "Coronel João Pessoa",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403004,
    "nome": "Cruzeta",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403103,
    "nome": "Currais Novos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403202,
    "nome": "Doutor Severiano",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403301,
    "nome": "Encanto",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403400,
    "nome": "Equador",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403509,
    "nome": "Espírito Santo",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403608,
    "nome": "Extremoz",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403707,
    "nome": "Felipe Guerra",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403756,
    "nome": "Fernando Pedroza",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403806,
    "nome": "Florânia",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2403905,
    "nome": "Francisco Dantas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404002,
    "nome": "Frutuoso Gomes",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404101,
    "nome": "Galinhos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404200,
    "nome": "Goianinha",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404309,
    "nome": "Governador Dix-Sept Rosado",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404408,
    "nome": "Grossos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404507,
    "nome": "Guamaré",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404606,
    "nome": "Ielmo Marinho",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404705,
    "nome": "Ipanguaçu",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404804,
    "nome": "Ipueira",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404853,
    "nome": "Itajá",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2404903,
    "nome": "Itaú",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405009,
    "nome": "Jaçanã",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405108,
    "nome": "Jandaíra",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405207,
    "nome": "Janduís",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405306,
    "nome": "Januário Cicco",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405405,
    "nome": "Japi",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405504,
    "nome": "Jardim de Angicos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405603,
    "nome": "Jardim de Piranhas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405702,
    "nome": "Jardim do Seridó",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405801,
    "nome": "João Câmara",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2405900,
    "nome": "João Dias",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406007,
    "nome": "José da Penha",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406106,
    "nome": "Jucurutu",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406155,
    "nome": "Jundiá",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406205,
    "nome": "Lagoa d'Anta",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406304,
    "nome": "Lagoa de Pedras",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406403,
    "nome": "Lagoa de Velhos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406502,
    "nome": "Lagoa Nova",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406601,
    "nome": "Lagoa Salgada",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406700,
    "nome": "Lajes",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406809,
    "nome": "Lajes Pintadas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2406908,
    "nome": "Lucrécia",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407005,
    "nome": "Luís Gomes",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407104,
    "nome": "Macaíba",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407203,
    "nome": "Macau",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407252,
    "nome": "Major Sales",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407302,
    "nome": "Marcelino Vieira",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407401,
    "nome": "Martins",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407500,
    "nome": "Maxaranguape",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407609,
    "nome": "Messias Targino",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407708,
    "nome": "Montanhas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407807,
    "nome": "Monte Alegre",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2407906,
    "nome": "Monte das Gameleiras",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408201,
    "nome": "Nísia Floresta",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408300,
    "nome": "Nova Cruz",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408409,
    "nome": "Olho d'Água do Borges",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408508,
    "nome": "Ouro Branco",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408607,
    "nome": "Paraná",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408706,
    "nome": "Paraú",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408805,
    "nome": "Parazinho",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408904,
    "nome": "Parelhas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2408953,
    "nome": "Rio do Fogo",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409100,
    "nome": "Passa e Fica",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409209,
    "nome": "Passagem",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409308,
    "nome": "Patu",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409332,
    "nome": "Santa Maria",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409407,
    "nome": "Pau dos Ferros",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409506,
    "nome": "Pedra Grande",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409605,
    "nome": "Pedra Preta",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409704,
    "nome": "Pedro Avelino",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409803,
    "nome": "Pedro Velho",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2409902,
    "nome": "Pendências",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410009,
    "nome": "Pilões",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410108,
    "nome": "Poço Branco",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410207,
    "nome": "Portalegre",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410256,
    "nome": "Porto do Mangue",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410306,
    "nome": "Serra Caiada",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410405,
    "nome": "Pureza",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410504,
    "nome": "Rafael Fernandes",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410603,
    "nome": "Rafael Godeiro",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410702,
    "nome": "Riacho da Cruz",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410801,
    "nome": "Riacho de Santana",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2410900,
    "nome": "Riachuelo",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411007,
    "nome": "Rodolfo Fernandes",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411056,
    "nome": "Tibau",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411106,
    "nome": "Ruy Barbosa",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411205,
    "nome": "Santa Cruz",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411403,
    "nome": "Santana do Matos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411429,
    "nome": "Santana do Seridó",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411502,
    "nome": "Santo Antônio",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411601,
    "nome": "São Bento do Norte",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411700,
    "nome": "São Bento do Trairí",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411809,
    "nome": "São Fernando",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2411908,
    "nome": "São Francisco do Oeste",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412005,
    "nome": "São Gonçalo do Amarante",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412104,
    "nome": "São João do Sabugi",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412203,
    "nome": "São José de Mipibu",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412302,
    "nome": "São José do Campestre",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412401,
    "nome": "São José do Seridó",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412500,
    "nome": "São Miguel",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412559,
    "nome": "São Miguel do Gostoso",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412609,
    "nome": "São Paulo do Potengi",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412708,
    "nome": "São Pedro",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412807,
    "nome": "São Rafael",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2412906,
    "nome": "São Tomé",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413003,
    "nome": "São Vicente",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413102,
    "nome": "Senador Elói de Souza",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413201,
    "nome": "Senador Georgino Avelino",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413300,
    "nome": "Serra de São Bento",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413359,
    "nome": "Serra do Mel",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413409,
    "nome": "Serra Negra do Norte",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413508,
    "nome": "Serrinha",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413557,
    "nome": "Serrinha dos Pintos",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413607,
    "nome": "Severiano Melo",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413706,
    "nome": "Sítio Novo",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413805,
    "nome": "Taboleiro Grande",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2413904,
    "nome": "Taipu",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414001,
    "nome": "Tangará",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414100,
    "nome": "Tenente Ananias",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414159,
    "nome": "Tenente Laurentino Cruz",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414209,
    "nome": "Tibau do Sul",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414308,
    "nome": "Timbaúba dos Batistas",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414407,
    "nome": "Touros",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414456,
    "nome": "Triunfo Potiguar",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414506,
    "nome": "Umarizal",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414605,
    "nome": "Upanema",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414704,
    "nome": "Várzea",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414753,
    "nome": "Venha-Ver",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414803,
    "nome": "Vera Cruz",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2414902,
    "nome": "Viçosa",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2415008,
    "nome": "Vila Flor",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500106,
    "nome": "Água Branca",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500205,
    "nome": "Aguiar",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500304,
    "nome": "Alagoa Grande",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500403,
    "nome": "Alagoa Nova",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500502,
    "nome": "Alagoinha",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500536,
    "nome": "Alcantil",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500577,
    "nome": "Algodão de Jandaíra",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500700,
    "nome": "São João do Rio do Peixe",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500734,
    "nome": "Amparo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500775,
    "nome": "Aparecida",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500809,
    "nome": "Araçagi",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2500908,
    "nome": "Arara",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501005,
    "nome": "Araruna",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501104,
    "nome": "Areia",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501153,
    "nome": "Areia de Baraúnas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501203,
    "nome": "Areial",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501302,
    "nome": "Aroeiras",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501351,
    "nome": "Assunção",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501401,
    "nome": "Baía da Traição",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501500,
    "nome": "Bananeiras",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501534,
    "nome": "Baraúna",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501575,
    "nome": "Barra de Santana",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501609,
    "nome": "Barra de Santa Rosa",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501708,
    "nome": "Barra de São Miguel",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501807,
    "nome": "Bayeux",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2501906,
    "nome": "Belém",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502003,
    "nome": "Belém do Brejo do Cruz",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502052,
    "nome": "Bernardino Batista",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502102,
    "nome": "Boa Ventura",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502151,
    "nome": "Boa Vista",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502201,
    "nome": "Bom Jesus",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502300,
    "nome": "Bom Sucesso",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502409,
    "nome": "Bonito de Santa Fé",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502508,
    "nome": "Boqueirão",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502607,
    "nome": "Igaracy",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502706,
    "nome": "Borborema",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502805,
    "nome": "Brejo do Cruz",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2502904,
    "nome": "Brejo dos Santos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503001,
    "nome": "Caaporã",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503100,
    "nome": "Cabaceiras",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503308,
    "nome": "Cachoeira dos Índios",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503407,
    "nome": "Cacimba de Areia",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503506,
    "nome": "Cacimba de Dentro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503555,
    "nome": "Cacimbas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503605,
    "nome": "Caiçara",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503704,
    "nome": "Cajazeiras",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503753,
    "nome": "Cajazeirinhas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503803,
    "nome": "Caldas Brandão",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2503902,
    "nome": "Camalaú",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504033,
    "nome": "Capim",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504074,
    "nome": "Caraúbas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504108,
    "nome": "Carrapateira",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504157,
    "nome": "Casserengue",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504207,
    "nome": "Catingueira",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504306,
    "nome": "Catolé do Rocha",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504355,
    "nome": "Caturité",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504405,
    "nome": "Conceição",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504504,
    "nome": "Condado",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504603,
    "nome": "Conde",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504702,
    "nome": "Congo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504801,
    "nome": "Coremas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504850,
    "nome": "Coxixola",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2504900,
    "nome": "Cruz do Espírito Santo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505006,
    "nome": "Cubati",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505105,
    "nome": "Cuité",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505204,
    "nome": "Cuitegi",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505238,
    "nome": "Cuité de Mamanguape",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505279,
    "nome": "Curral de Cima",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505303,
    "nome": "Curral Velho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505352,
    "nome": "Damião",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505402,
    "nome": "Desterro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505501,
    "nome": "Vista Serrana",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505600,
    "nome": "Diamante",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505709,
    "nome": "Dona Inês",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505808,
    "nome": "Duas Estradas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2505907,
    "nome": "Emas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506004,
    "nome": "Esperança",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506103,
    "nome": "Fagundes",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506202,
    "nome": "Frei Martinho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506251,
    "nome": "Gado Bravo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506301,
    "nome": "Guarabira",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506400,
    "nome": "Gurinhém",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506509,
    "nome": "Gurjão",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506608,
    "nome": "Ibiara",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506707,
    "nome": "Imaculada",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506806,
    "nome": "Ingá",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2506905,
    "nome": "Itabaiana",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507002,
    "nome": "Itaporanga",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507101,
    "nome": "Itapororoca",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507200,
    "nome": "Itatuba",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507309,
    "nome": "Jacaraú",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507408,
    "nome": "Jericó",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507606,
    "nome": "Juarez Távora",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507705,
    "nome": "Juazeirinho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507804,
    "nome": "Junco do Seridó",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2507903,
    "nome": "Juripiranga",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508000,
    "nome": "Juru",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508109,
    "nome": "Lagoa",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508208,
    "nome": "Lagoa de Dentro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508307,
    "nome": "Lagoa Seca",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508406,
    "nome": "Lastro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508505,
    "nome": "Livramento",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508554,
    "nome": "Logradouro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508604,
    "nome": "Lucena",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508703,
    "nome": "Mãe d'Água",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508802,
    "nome": "Malta",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2508901,
    "nome": "Mamanguape",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509008,
    "nome": "Manaíra",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509057,
    "nome": "Marcação",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509107,
    "nome": "Mari",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509156,
    "nome": "Marizópolis",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509206,
    "nome": "Massaranduba",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509305,
    "nome": "Mataraca",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509339,
    "nome": "Matinhas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509370,
    "nome": "Mato Grosso",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509396,
    "nome": "Maturéia",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509404,
    "nome": "Mogeiro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509503,
    "nome": "Montadas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509602,
    "nome": "Monte Horebe",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509701,
    "nome": "Monteiro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509800,
    "nome": "Mulungu",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2509909,
    "nome": "Natuba",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510006,
    "nome": "Nazarezinho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510105,
    "nome": "Nova Floresta",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510204,
    "nome": "Nova Olinda",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510303,
    "nome": "Nova Palmeira",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510402,
    "nome": "Olho d'Água",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510501,
    "nome": "Olivedos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510600,
    "nome": "Ouro Velho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510659,
    "nome": "Parari",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510709,
    "nome": "Passagem",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510808,
    "nome": "Patos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2510907,
    "nome": "Paulista",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511004,
    "nome": "Pedra Branca",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511103,
    "nome": "Pedra Lavrada",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511202,
    "nome": "Pedras de Fogo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511301,
    "nome": "Piancó",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511400,
    "nome": "Picuí",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511509,
    "nome": "Pilar",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511608,
    "nome": "Pilões",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511707,
    "nome": "Pilõezinhos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511806,
    "nome": "Pirpirituba",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2511905,
    "nome": "Pitimbu",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512002,
    "nome": "Pocinhos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512036,
    "nome": "Poço Dantas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512077,
    "nome": "Poço de José de Moura",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512101,
    "nome": "Pombal",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512200,
    "nome": "Prata",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512309,
    "nome": "Princesa Isabel",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512408,
    "nome": "Puxinanã",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512507,
    "nome": "Queimadas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512606,
    "nome": "Quixaba",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512705,
    "nome": "Remígio",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512721,
    "nome": "Pedro Régis",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512747,
    "nome": "Riachão",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512754,
    "nome": "Riachão do Bacamarte",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512762,
    "nome": "Riachão do Poço",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512788,
    "nome": "Riacho de Santo Antônio",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512804,
    "nome": "Riacho dos Cavalos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2512903,
    "nome": "Rio Tinto",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513000,
    "nome": "Salgadinho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513109,
    "nome": "Salgado de São Félix",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513158,
    "nome": "Santa Cecília",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513208,
    "nome": "Santa Cruz",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513307,
    "nome": "Santa Helena",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513356,
    "nome": "Santa Inês",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513406,
    "nome": "Santa Luzia",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513505,
    "nome": "Santana de Mangueira",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513604,
    "nome": "Santana dos Garrotes",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513653,
    "nome": "Joca Claudino",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513802,
    "nome": "Santa Teresinha",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513851,
    "nome": "Santo André",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513901,
    "nome": "São Bento",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513927,
    "nome": "São Bentinho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513943,
    "nome": "São Domingos do Cariri",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513968,
    "nome": "São Domingos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2513984,
    "nome": "São Francisco",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514008,
    "nome": "São João do Cariri",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514107,
    "nome": "São João do Tigre",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514206,
    "nome": "São José da Lagoa Tapada",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514305,
    "nome": "São José de Caiana",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514404,
    "nome": "São José de Espinharas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514453,
    "nome": "São José dos Ramos",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514503,
    "nome": "São José de Piranhas",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514552,
    "nome": "São José de Princesa",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514602,
    "nome": "São José do Bonfim",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514651,
    "nome": "São José do Brejo do Cruz",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514701,
    "nome": "São José do Sabugi",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514800,
    "nome": "São José dos Cordeiros",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2514909,
    "nome": "São Mamede",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515005,
    "nome": "São Miguel de Taipu",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515104,
    "nome": "São Sebastião de Lagoa de Roça",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515203,
    "nome": "São Sebastião do Umbuzeiro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515302,
    "nome": "Sapé",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515401,
    "nome": "São Vicente do Seridó",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515500,
    "nome": "Serra Branca",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515609,
    "nome": "Serra da Raiz",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515708,
    "nome": "Serra Grande",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515807,
    "nome": "Serra Redonda",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515906,
    "nome": "Serraria",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515930,
    "nome": "Sertãozinho",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2515971,
    "nome": "Sobrado",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516003,
    "nome": "Solânea",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516102,
    "nome": "Soledade",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516151,
    "nome": "Sossêgo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516201,
    "nome": "Sousa",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516300,
    "nome": "Sumé",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516409,
    "nome": "Tacima",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516508,
    "nome": "Taperoá",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516607,
    "nome": "Tavares",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516706,
    "nome": "Teixeira",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516755,
    "nome": "Tenório",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516805,
    "nome": "Triunfo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2516904,
    "nome": "Uiraúna",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2517001,
    "nome": "Umbuzeiro",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2517100,
    "nome": "Várzea",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2517209,
    "nome": "Vieirópolis",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2517407,
    "nome": "Zabelê",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600054,
    "nome": "Abreu e Lima",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600104,
    "nome": "Afogados da Ingazeira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600203,
    "nome": "Afrânio",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600302,
    "nome": "Agrestina",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600401,
    "nome": "Água Preta",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600500,
    "nome": "Águas Belas",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600609,
    "nome": "Alagoinha",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600708,
    "nome": "Aliança",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600807,
    "nome": "Altinho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2600906,
    "nome": "Amaraji",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601003,
    "nome": "Angelim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601052,
    "nome": "Araçoiaba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601102,
    "nome": "Araripina",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601201,
    "nome": "Arcoverde",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601300,
    "nome": "Barra de Guabiraba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601409,
    "nome": "Barreiros",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601508,
    "nome": "Belém de Maria",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601607,
    "nome": "Belém do São Francisco",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601805,
    "nome": "Betânia",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2601904,
    "nome": "Bezerros",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602001,
    "nome": "Bodocó",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602100,
    "nome": "Bom Conselho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602209,
    "nome": "Bom Jardim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602308,
    "nome": "Bonito",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602407,
    "nome": "Brejão",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602506,
    "nome": "Brejinho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602605,
    "nome": "Brejo da Madre de Deus",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602704,
    "nome": "Buenos Aires",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2602803,
    "nome": "Buíque",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603009,
    "nome": "Cabrobó",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603108,
    "nome": "Cachoeirinha",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603207,
    "nome": "Caetés",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603306,
    "nome": "Calçado",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603405,
    "nome": "Calumbi",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603454,
    "nome": "Camaragibe",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603504,
    "nome": "Camocim de São Félix",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603603,
    "nome": "Camutanga",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603702,
    "nome": "Canhotinho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603801,
    "nome": "Capoeiras",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603900,
    "nome": "Carnaíba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2603926,
    "nome": "Carnaubeira da Penha",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604007,
    "nome": "Carpina",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604155,
    "nome": "Casinhas",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604205,
    "nome": "Catende",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604304,
    "nome": "Cedro",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604403,
    "nome": "Chã de Alegria",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604502,
    "nome": "Chã Grande",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604601,
    "nome": "Condado",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604700,
    "nome": "Correntes",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604809,
    "nome": "Cortês",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2604908,
    "nome": "Cumaru",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605004,
    "nome": "Cupira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605103,
    "nome": "Custódia",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605152,
    "nome": "Dormentes",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605202,
    "nome": "Escada",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605301,
    "nome": "Exu",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605400,
    "nome": "Feira Nova",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605459,
    "nome": "Fernando de Noronha",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605509,
    "nome": "Ferreiros",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605608,
    "nome": "Flores",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605707,
    "nome": "Floresta",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605806,
    "nome": "Frei Miguelinho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2605905,
    "nome": "Gameleira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606101,
    "nome": "Glória do Goitá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606309,
    "nome": "Granito",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606408,
    "nome": "Gravatá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606507,
    "nome": "Iati",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606606,
    "nome": "Ibimirim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606705,
    "nome": "Ibirajuba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2606903,
    "nome": "Iguaracy",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607000,
    "nome": "Inajá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607109,
    "nome": "Ingazeira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607307,
    "nome": "Ipubi",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607406,
    "nome": "Itacuruba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607505,
    "nome": "Itaíba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607604,
    "nome": "Ilha de Itamaracá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607653,
    "nome": "Itambé",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607703,
    "nome": "Itapetim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607752,
    "nome": "Itapissuma",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607802,
    "nome": "Itaquitinga",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2607950,
    "nome": "Jaqueira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608008,
    "nome": "Jataúba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608057,
    "nome": "Jatobá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608107,
    "nome": "João Alfredo",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608206,
    "nome": "Joaquim Nabuco",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608255,
    "nome": "Jucati",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608305,
    "nome": "Jupi",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608404,
    "nome": "Jurema",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608453,
    "nome": "Lagoa do Carro",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608503,
    "nome": "Lagoa de Itaenga",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608602,
    "nome": "Lagoa do Ouro",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608701,
    "nome": "Lagoa dos Gatos",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608750,
    "nome": "Lagoa Grande",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608800,
    "nome": "Lajedo",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2608909,
    "nome": "Limoeiro",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609006,
    "nome": "Macaparana",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609105,
    "nome": "Machados",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609154,
    "nome": "Manari",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609204,
    "nome": "Maraial",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609303,
    "nome": "Mirandiba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609402,
    "nome": "Moreno",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609501,
    "nome": "Nazaré da Mata",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609709,
    "nome": "Orobó",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609808,
    "nome": "Orocó",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2609907,
    "nome": "Ouricuri",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610004,
    "nome": "Palmares",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610103,
    "nome": "Palmeirina",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610202,
    "nome": "Panelas",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610301,
    "nome": "Paranatama",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610400,
    "nome": "Parnamirim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610509,
    "nome": "Passira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610608,
    "nome": "Paudalho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610806,
    "nome": "Pedra",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2610905,
    "nome": "Pesqueira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611002,
    "nome": "Petrolândia",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611200,
    "nome": "Poção",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611309,
    "nome": "Pombos",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611408,
    "nome": "Primavera",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611507,
    "nome": "Quipapá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611533,
    "nome": "Quixaba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611705,
    "nome": "Riacho das Almas",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611804,
    "nome": "Ribeirão",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2611903,
    "nome": "Rio Formoso",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612000,
    "nome": "Sairé",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612109,
    "nome": "Salgadinho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612208,
    "nome": "Salgueiro",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612307,
    "nome": "Saloá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612406,
    "nome": "Sanharó",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612455,
    "nome": "Santa Cruz",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612471,
    "nome": "Santa Cruz da Baixa Verde",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612505,
    "nome": "Santa Cruz do Capibaribe",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612554,
    "nome": "Santa Filomena",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612604,
    "nome": "Santa Maria da Boa Vista",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612703,
    "nome": "Santa Maria do Cambucá",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612802,
    "nome": "Santa Terezinha",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2612901,
    "nome": "São Benedito do Sul",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613008,
    "nome": "São Bento do Una",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613107,
    "nome": "São Caitano",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613206,
    "nome": "São João",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613305,
    "nome": "São Joaquim do Monte",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613404,
    "nome": "São José da Coroa Grande",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613503,
    "nome": "São José do Belmonte",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613602,
    "nome": "São José do Egito",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613701,
    "nome": "São Lourenço da Mata",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613800,
    "nome": "São Vicente Férrer",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2613909,
    "nome": "Serra Talhada",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614006,
    "nome": "Serrita",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614105,
    "nome": "Sertânia",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614204,
    "nome": "Sirinhaém",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614303,
    "nome": "Moreilândia",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614402,
    "nome": "Solidão",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614501,
    "nome": "Surubim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614600,
    "nome": "Tabira",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614709,
    "nome": "Tacaimbó",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614808,
    "nome": "Tacaratu",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2614857,
    "nome": "Tamandaré",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615003,
    "nome": "Taquaritinga do Norte",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615102,
    "nome": "Terezinha",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615201,
    "nome": "Terra Nova",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615300,
    "nome": "Timbaúba",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615409,
    "nome": "Toritama",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615508,
    "nome": "Tracunhaém",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615607,
    "nome": "Trindade",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615706,
    "nome": "Triunfo",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615805,
    "nome": "Tupanatinga",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2615904,
    "nome": "Tuparetama",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2616001,
    "nome": "Venturosa",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2616100,
    "nome": "Verdejante",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2616183,
    "nome": "Vertente do Lério",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2616209,
    "nome": "Vertentes",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2616308,
    "nome": "Vicência",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2616506,
    "nome": "Xexéu",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700102,
    "nome": "Água Branca",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700201,
    "nome": "Anadia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700409,
    "nome": "Atalaia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700508,
    "nome": "Barra de Santo Antônio",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700607,
    "nome": "Barra de São Miguel",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700706,
    "nome": "Batalha",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700805,
    "nome": "Belém",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2700904,
    "nome": "Belo Monte",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701001,
    "nome": "Boca da Mata",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701100,
    "nome": "Branquinha",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701209,
    "nome": "Cacimbinhas",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701308,
    "nome": "Cajueiro",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701357,
    "nome": "Campestre",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701407,
    "nome": "Campo Alegre",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701506,
    "nome": "Campo Grande",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701605,
    "nome": "Canapi",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701704,
    "nome": "Capela",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701803,
    "nome": "Carneiros",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2701902,
    "nome": "Chã Preta",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702009,
    "nome": "Coité do Nóia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702108,
    "nome": "Colônia Leopoldina",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702207,
    "nome": "Coqueiro Seco",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702306,
    "nome": "Coruripe",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702355,
    "nome": "Craíbas",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702405,
    "nome": "Delmiro Gouveia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702504,
    "nome": "Dois Riachos",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702553,
    "nome": "Estrela de Alagoas",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702603,
    "nome": "Feira Grande",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702702,
    "nome": "Feliz Deserto",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702801,
    "nome": "Flexeiras",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2702900,
    "nome": "Girau do Ponciano",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703007,
    "nome": "Ibateguara",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703106,
    "nome": "Igaci",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703205,
    "nome": "Igreja Nova",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703304,
    "nome": "Inhapi",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703403,
    "nome": "Jacaré dos Homens",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703502,
    "nome": "Jacuípe",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703601,
    "nome": "Japaratinga",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703700,
    "nome": "Jaramataia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703759,
    "nome": "Jequiá da Praia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703809,
    "nome": "Joaquim Gomes",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2703908,
    "nome": "Jundiá",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704005,
    "nome": "Junqueiro",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704104,
    "nome": "Lagoa da Canoa",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704203,
    "nome": "Limoeiro de Anadia",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704401,
    "nome": "Major Isidoro",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704500,
    "nome": "Maragogi",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704609,
    "nome": "Maravilha",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704807,
    "nome": "Maribondo",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2704906,
    "nome": "Mar Vermelho",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705002,
    "nome": "Mata Grande",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705101,
    "nome": "Matriz de Camaragibe",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705200,
    "nome": "Messias",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705309,
    "nome": "Minador do Negrão",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705408,
    "nome": "Monteirópolis",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705507,
    "nome": "Murici",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705606,
    "nome": "Novo Lino",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705705,
    "nome": "Olho d'Água das Flores",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705804,
    "nome": "Olho d'Água do Casado",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2705903,
    "nome": "Olho d'Água Grande",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706000,
    "nome": "Olivença",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706109,
    "nome": "Ouro Branco",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706208,
    "nome": "Palestina",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706307,
    "nome": "Palmeira dos Índios",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706406,
    "nome": "Pão de Açúcar",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706422,
    "nome": "Pariconha",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706448,
    "nome": "Paripueira",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706505,
    "nome": "Passo de Camaragibe",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706604,
    "nome": "Paulo Jacinto",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706703,
    "nome": "Penedo",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706802,
    "nome": "Piaçabuçu",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2706901,
    "nome": "Pilar",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707008,
    "nome": "Pindoba",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707107,
    "nome": "Piranhas",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707206,
    "nome": "Poço das Trincheiras",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707305,
    "nome": "Porto Calvo",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707404,
    "nome": "Porto de Pedras",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707503,
    "nome": "Porto Real do Colégio",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707602,
    "nome": "Quebrangulo",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707701,
    "nome": "Rio Largo",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707800,
    "nome": "Roteiro",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2707909,
    "nome": "Santa Luzia do Norte",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708006,
    "nome": "Santana do Ipanema",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708105,
    "nome": "Santana do Mundaú",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708204,
    "nome": "São Brás",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708303,
    "nome": "São José da Laje",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708402,
    "nome": "São José da Tapera",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708501,
    "nome": "São Luís do Quitunde",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708600,
    "nome": "São Miguel dos Campos",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708709,
    "nome": "São Miguel dos Milagres",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708808,
    "nome": "São Sebastião",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708907,
    "nome": "Satuba",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2708956,
    "nome": "Senador Rui Palmeira",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2709004,
    "nome": "Tanque d'Arca",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2709103,
    "nome": "Taquarana",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2709152,
    "nome": "Teotônio Vilela",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2709202,
    "nome": "Traipu",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2709301,
    "nome": "União dos Palmares",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2709400,
    "nome": "Viçosa",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800100,
    "nome": "Amparo do São Francisco",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800209,
    "nome": "Aquidabã",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800407,
    "nome": "Arauá",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800506,
    "nome": "Areia Branca",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800605,
    "nome": "Barra dos Coqueiros",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800670,
    "nome": "Boquim",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2800704,
    "nome": "Brejo Grande",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801009,
    "nome": "Campo do Brito",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801108,
    "nome": "Canhoba",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801306,
    "nome": "Capela",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801405,
    "nome": "Carira",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801504,
    "nome": "Carmópolis",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801603,
    "nome": "Cedro de São João",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801702,
    "nome": "Cristinápolis",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2801900,
    "nome": "Cumbe",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802007,
    "nome": "Divina Pastora",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802106,
    "nome": "Estância",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802205,
    "nome": "Feira Nova",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802304,
    "nome": "Frei Paulo",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802403,
    "nome": "Gararu",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802502,
    "nome": "General Maynard",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802601,
    "nome": "Graccho Cardoso",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802700,
    "nome": "Ilha das Flores",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802809,
    "nome": "Indiaroba",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2802908,
    "nome": "Itabaiana",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803005,
    "nome": "Itabaianinha",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803104,
    "nome": "Itabi",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803203,
    "nome": "Itaporanga d'Ajuda",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803302,
    "nome": "Japaratuba",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803401,
    "nome": "Japoatã",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803500,
    "nome": "Lagarto",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803609,
    "nome": "Laranjeiras",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803708,
    "nome": "Macambira",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803807,
    "nome": "Malhada dos Bois",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2803906,
    "nome": "Malhador",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804003,
    "nome": "Maruim",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804102,
    "nome": "Moita Bonita",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804201,
    "nome": "Monte Alegre de Sergipe",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804300,
    "nome": "Muribeca",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804409,
    "nome": "Neópolis",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804458,
    "nome": "Nossa Senhora Aparecida",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804508,
    "nome": "Nossa Senhora da Glória",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804607,
    "nome": "Nossa Senhora das Dores",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804706,
    "nome": "Nossa Senhora de Lourdes",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2804904,
    "nome": "Pacatuba",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805000,
    "nome": "Pedra Mole",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805109,
    "nome": "Pedrinhas",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805208,
    "nome": "Pinhão",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805307,
    "nome": "Pirambu",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805406,
    "nome": "Poço Redondo",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805505,
    "nome": "Poço Verde",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805604,
    "nome": "Porto da Folha",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805703,
    "nome": "Propriá",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805802,
    "nome": "Riachão do Dantas",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2805901,
    "nome": "Riachuelo",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806008,
    "nome": "Ribeirópolis",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806107,
    "nome": "Rosário do Catete",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806206,
    "nome": "Salgado",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806305,
    "nome": "Santa Luzia do Itanhy",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806404,
    "nome": "Santana do São Francisco",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806503,
    "nome": "Santa Rosa de Lima",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806602,
    "nome": "Santo Amaro das Brotas",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806701,
    "nome": "São Cristóvão",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806800,
    "nome": "São Domingos",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2806909,
    "nome": "São Francisco",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807006,
    "nome": "São Miguel do Aleixo",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807105,
    "nome": "Simão Dias",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807204,
    "nome": "Siriri",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807303,
    "nome": "Telha",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807402,
    "nome": "Tobias Barreto",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807501,
    "nome": "Tomar do Geru",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2807600,
    "nome": "Umbaúba",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900108,
    "nome": "Abaíra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900207,
    "nome": "Abaré",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900306,
    "nome": "Acajutiba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900355,
    "nome": "Adustina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900405,
    "nome": "Água Fria",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900504,
    "nome": "Érico Cardoso",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900603,
    "nome": "Aiquara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900801,
    "nome": "Alcobaça",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2900900,
    "nome": "Almadina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901007,
    "nome": "Amargosa",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901106,
    "nome": "Amélia Rodrigues",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901155,
    "nome": "América Dourada",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901205,
    "nome": "Anagé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901304,
    "nome": "Andaraí",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901353,
    "nome": "Andorinha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901403,
    "nome": "Angical",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901502,
    "nome": "Anguera",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901601,
    "nome": "Antas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901700,
    "nome": "Antônio Cardoso",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901809,
    "nome": "Antônio Gonçalves",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901908,
    "nome": "Aporá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2901957,
    "nome": "Apuarema",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902005,
    "nome": "Aracatu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902054,
    "nome": "Araçás",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902104,
    "nome": "Araci",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902203,
    "nome": "Aramari",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902252,
    "nome": "Arataca",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902302,
    "nome": "Aratuípe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902401,
    "nome": "Aurelino Leal",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902500,
    "nome": "Baianópolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902609,
    "nome": "Baixa Grande",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902658,
    "nome": "Banzaê",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902708,
    "nome": "Barra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902807,
    "nome": "Barra da Estiva",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2902906,
    "nome": "Barra do Choça",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903003,
    "nome": "Barra do Mendes",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903102,
    "nome": "Barra do Rocha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903235,
    "nome": "Barro Alto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903276,
    "nome": "Barrocas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903300,
    "nome": "Barro Preto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903409,
    "nome": "Belmonte",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903508,
    "nome": "Belo Campo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903607,
    "nome": "Biritinga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903706,
    "nome": "Boa Nova",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903805,
    "nome": "Boa Vista do Tupim",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903904,
    "nome": "Bom Jesus da Lapa",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2903953,
    "nome": "Bom Jesus da Serra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904001,
    "nome": "Boninal",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904050,
    "nome": "Bonito",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904100,
    "nome": "Boquira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904209,
    "nome": "Botuporã",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904308,
    "nome": "Brejões",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904407,
    "nome": "Brejolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904506,
    "nome": "Brotas de Macaúbas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904605,
    "nome": "Brumado",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904704,
    "nome": "Buerarema",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904753,
    "nome": "Buritirama",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904803,
    "nome": "Caatiba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904852,
    "nome": "Cabaceiras do Paraguaçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2904902,
    "nome": "Cachoeira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905008,
    "nome": "Caculé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905107,
    "nome": "Caém",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905156,
    "nome": "Caetanos",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905206,
    "nome": "Caetité",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905305,
    "nome": "Cafarnaum",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905404,
    "nome": "Cairu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905503,
    "nome": "Caldeirão Grande",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905602,
    "nome": "Camacan",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905800,
    "nome": "Camamu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2905909,
    "nome": "Campo Alegre de Lourdes",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906006,
    "nome": "Campo Formoso",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906105,
    "nome": "Canápolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906204,
    "nome": "Canarana",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906303,
    "nome": "Canavieiras",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906402,
    "nome": "Candeal",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906600,
    "nome": "Candiba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906709,
    "nome": "Cândido Sales",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906808,
    "nome": "Cansanção",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906824,
    "nome": "Canudos",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906857,
    "nome": "Capela do Alto Alegre",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906873,
    "nome": "Capim Grosso",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906899,
    "nome": "Caraíbas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2906907,
    "nome": "Caravelas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907004,
    "nome": "Cardeal da Silva",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907103,
    "nome": "Carinhanha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907202,
    "nome": "Casa Nova",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907301,
    "nome": "Castro Alves",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907400,
    "nome": "Catolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907509,
    "nome": "Catu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907558,
    "nome": "Caturama",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907608,
    "nome": "Central",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907707,
    "nome": "Chorrochó",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907806,
    "nome": "Cícero Dantas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2907905,
    "nome": "Cipó",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908002,
    "nome": "Coaraci",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908101,
    "nome": "Cocos",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908200,
    "nome": "Conceição da Feira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908309,
    "nome": "Conceição do Almeida",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908408,
    "nome": "Conceição do Coité",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908606,
    "nome": "Conde",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908705,
    "nome": "Condeúba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908804,
    "nome": "Contendas do Sincorá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2908903,
    "nome": "Coração de Maria",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909000,
    "nome": "Cordeiros",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909109,
    "nome": "Coribe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909208,
    "nome": "Coronel João Sá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909406,
    "nome": "Cotegipe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909505,
    "nome": "Cravolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909604,
    "nome": "Crisópolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909703,
    "nome": "Cristópolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909802,
    "nome": "Cruz das Almas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2909901,
    "nome": "Curaçá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910008,
    "nome": "Dário Meira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910057,
    "nome": "Dias d'Ávila",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910107,
    "nome": "Dom Basílio",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910206,
    "nome": "Dom Macedo Costa",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910305,
    "nome": "Elísio Medrado",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910404,
    "nome": "Encruzilhada",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910503,
    "nome": "Entre Rios",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910602,
    "nome": "Esplanada",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910701,
    "nome": "Euclides da Cunha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910750,
    "nome": "Fátima",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910776,
    "nome": "Feira da Mata",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910859,
    "nome": "Filadélfia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2910909,
    "nome": "Firmino Alves",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911006,
    "nome": "Floresta Azul",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911204,
    "nome": "Gandu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911253,
    "nome": "Gavião",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911303,
    "nome": "Gentio do Ouro",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911402,
    "nome": "Glória",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911501,
    "nome": "Gongogi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911600,
    "nome": "Governador Mangabeira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911659,
    "nome": "Guajeru",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911709,
    "nome": "Guanambi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911808,
    "nome": "Guaratinga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911857,
    "nome": "Heliópolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2911907,
    "nome": "Iaçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912004,
    "nome": "Ibiassucê",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912103,
    "nome": "Ibicaraí",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912202,
    "nome": "Ibicoara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912301,
    "nome": "Ibicuí",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912400,
    "nome": "Ibipeba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912509,
    "nome": "Ibipitanga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912608,
    "nome": "Ibiquera",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912707,
    "nome": "Ibirapitanga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912806,
    "nome": "Ibirapuã",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2912905,
    "nome": "Ibirataia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913002,
    "nome": "Ibitiara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913101,
    "nome": "Ibititá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913200,
    "nome": "Ibotirama",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913309,
    "nome": "Ichu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913408,
    "nome": "Igaporã",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913457,
    "nome": "Igrapiúna",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913507,
    "nome": "Iguaí",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913705,
    "nome": "Inhambupe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913804,
    "nome": "Ipecaetá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2913903,
    "nome": "Ipiaú",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914000,
    "nome": "Ipirá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914109,
    "nome": "Ipupiara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914208,
    "nome": "Irajuba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914307,
    "nome": "Iramaia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914406,
    "nome": "Iraquara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914505,
    "nome": "Irará",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914604,
    "nome": "Irecê",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914653,
    "nome": "Itabela",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914703,
    "nome": "Itaberaba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2914901,
    "nome": "Itacaré",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915007,
    "nome": "Itaeté",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915106,
    "nome": "Itagi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915205,
    "nome": "Itagibá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915304,
    "nome": "Itagimirim",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915353,
    "nome": "Itaguaçu da Bahia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915403,
    "nome": "Itaju do Colônia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915502,
    "nome": "Itajuípe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915601,
    "nome": "Itamaraju",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915700,
    "nome": "Itamari",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915809,
    "nome": "Itambé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2915908,
    "nome": "Itanagra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916005,
    "nome": "Itanhém",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916104,
    "nome": "Itaparica",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916203,
    "nome": "Itapé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916302,
    "nome": "Itapebi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916401,
    "nome": "Itapetinga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916500,
    "nome": "Itapicuru",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916609,
    "nome": "Itapitanga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916708,
    "nome": "Itaquara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916807,
    "nome": "Itarantim",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916856,
    "nome": "Itatim",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2916906,
    "nome": "Itiruçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917003,
    "nome": "Itiúba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917102,
    "nome": "Itororó",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917201,
    "nome": "Ituaçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917300,
    "nome": "Ituberá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917334,
    "nome": "Iuiu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917359,
    "nome": "Jaborandi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917409,
    "nome": "Jacaraci",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917508,
    "nome": "Jacobina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917607,
    "nome": "Jaguaquara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917706,
    "nome": "Jaguarari",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917805,
    "nome": "Jaguaripe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2917904,
    "nome": "Jandaíra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918100,
    "nome": "Jeremoabo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918209,
    "nome": "Jiquiriçá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918308,
    "nome": "Jitaúna",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918357,
    "nome": "João Dourado",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918456,
    "nome": "Jucuruçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918506,
    "nome": "Jussara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918555,
    "nome": "Jussari",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918605,
    "nome": "Jussiape",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918704,
    "nome": "Lafaiete Coutinho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918753,
    "nome": "Lagoa Real",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918803,
    "nome": "Laje",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2918902,
    "nome": "Lajedão",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919009,
    "nome": "Lajedinho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919058,
    "nome": "Lajedo do Tabocal",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919108,
    "nome": "Lamarão",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919157,
    "nome": "Lapão",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919306,
    "nome": "Lençóis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919405,
    "nome": "Licínio de Almeida",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919504,
    "nome": "Livramento de Nossa Senhora",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919603,
    "nome": "Macajuba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919702,
    "nome": "Macarani",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919801,
    "nome": "Macaúbas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919900,
    "nome": "Macururé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919926,
    "nome": "Madre de Deus",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2919959,
    "nome": "Maetinga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920007,
    "nome": "Maiquinique",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920106,
    "nome": "Mairi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920205,
    "nome": "Malhada",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920304,
    "nome": "Malhada de Pedras",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920403,
    "nome": "Manoel Vitorino",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920452,
    "nome": "Mansidão",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920502,
    "nome": "Maracás",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920601,
    "nome": "Maragogipe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920700,
    "nome": "Maraú",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920809,
    "nome": "Marcionílio Souza",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2920908,
    "nome": "Mascote",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921005,
    "nome": "Mata de São João",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921054,
    "nome": "Matina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921104,
    "nome": "Medeiros Neto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921203,
    "nome": "Miguel Calmon",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921302,
    "nome": "Milagres",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921401,
    "nome": "Mirangaba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921450,
    "nome": "Mirante",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921500,
    "nome": "Monte Santo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921609,
    "nome": "Morpará",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921708,
    "nome": "Morro do Chapéu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921807,
    "nome": "Mortugaba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2921906,
    "nome": "Mucugê",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922052,
    "nome": "Mulungu do Morro",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922102,
    "nome": "Mundo Novo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922201,
    "nome": "Muniz Ferreira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922250,
    "nome": "Muquém do São Francisco",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922300,
    "nome": "Muritiba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922409,
    "nome": "Mutuípe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922508,
    "nome": "Nazaré",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922607,
    "nome": "Nilo Peçanha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922656,
    "nome": "Nordestina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922706,
    "nome": "Nova Canaã",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922730,
    "nome": "Nova Fátima",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922755,
    "nome": "Nova Ibiá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922805,
    "nome": "Nova Itarana",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922854,
    "nome": "Nova Redenção",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2922904,
    "nome": "Nova Soure",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923001,
    "nome": "Nova Viçosa",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923035,
    "nome": "Novo Horizonte",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923050,
    "nome": "Novo Triunfo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923100,
    "nome": "Olindina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923209,
    "nome": "Oliveira dos Brejinhos",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923308,
    "nome": "Ouriçangas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923357,
    "nome": "Ourolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923407,
    "nome": "Palmas de Monte Alto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923506,
    "nome": "Palmeiras",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923605,
    "nome": "Paramirim",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923704,
    "nome": "Paratinga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923803,
    "nome": "Paripiranga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2923902,
    "nome": "Pau Brasil",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924058,
    "nome": "Pé de Serra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924108,
    "nome": "Pedrão",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924207,
    "nome": "Pedro Alexandre",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924306,
    "nome": "Piatã",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924405,
    "nome": "Pilão Arcado",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924504,
    "nome": "Pindaí",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924603,
    "nome": "Pindobaçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924652,
    "nome": "Pintadas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924678,
    "nome": "Piraí do Norte",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924702,
    "nome": "Piripá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924801,
    "nome": "Piritiba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2924900,
    "nome": "Planaltino",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925006,
    "nome": "Planalto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925105,
    "nome": "Poções",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925253,
    "nome": "Ponto Novo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925402,
    "nome": "Potiraguá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925501,
    "nome": "Prado",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925600,
    "nome": "Presidente Dutra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925709,
    "nome": "Presidente Jânio Quadros",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925758,
    "nome": "Presidente Tancredo Neves",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925808,
    "nome": "Queimadas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925907,
    "nome": "Quijingue",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925931,
    "nome": "Quixabeira",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2925956,
    "nome": "Rafael Jambeiro",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926004,
    "nome": "Remanso",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926103,
    "nome": "Retirolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926202,
    "nome": "Riachão das Neves",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926301,
    "nome": "Riachão do Jacuípe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926400,
    "nome": "Riacho de Santana",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926509,
    "nome": "Ribeira do Amparo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926608,
    "nome": "Ribeira do Pombal",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926657,
    "nome": "Ribeirão do Largo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926707,
    "nome": "Rio de Contas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926806,
    "nome": "Rio do Antônio",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2926905,
    "nome": "Rio do Pires",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927002,
    "nome": "Rio Real",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927101,
    "nome": "Rodelas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927200,
    "nome": "Ruy Barbosa",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927309,
    "nome": "Salinas da Margarida",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927507,
    "nome": "Santa Bárbara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927606,
    "nome": "Santa Brígida",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927705,
    "nome": "Santa Cruz Cabrália",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927804,
    "nome": "Santa Cruz da Vitória",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2927903,
    "nome": "Santa Inês",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928000,
    "nome": "Santaluz",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928059,
    "nome": "Santa Luzia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928109,
    "nome": "Santa Maria da Vitória",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928208,
    "nome": "Santana",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928307,
    "nome": "Santanópolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928406,
    "nome": "Santa Rita de Cássia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928505,
    "nome": "Santa Terezinha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928604,
    "nome": "Santo Amaro",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928703,
    "nome": "Santo Antônio de Jesus",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928802,
    "nome": "Santo Estêvão",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2928950,
    "nome": "São Domingos",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929008,
    "nome": "São Félix",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929057,
    "nome": "São Félix do Coribe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929107,
    "nome": "São Felipe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929255,
    "nome": "São Gabriel",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929305,
    "nome": "São Gonçalo dos Campos",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929354,
    "nome": "São José da Vitória",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929370,
    "nome": "São José do Jacuípe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929404,
    "nome": "São Miguel das Matas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929503,
    "nome": "São Sebastião do Passé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929602,
    "nome": "Sapeaçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929701,
    "nome": "Sátiro Dias",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929750,
    "nome": "Saubara",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929800,
    "nome": "Saúde",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2929909,
    "nome": "Seabra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930006,
    "nome": "Sebastião Laranjeiras",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930105,
    "nome": "Senhor do Bonfim",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930154,
    "nome": "Serra do Ramalho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930204,
    "nome": "Sento Sé",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930303,
    "nome": "Serra Dourada",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930402,
    "nome": "Serra Preta",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930501,
    "nome": "Serrinha",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930600,
    "nome": "Serrolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930758,
    "nome": "Sítio do Mato",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930766,
    "nome": "Sítio do Quinto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930774,
    "nome": "Sobradinho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930808,
    "nome": "Souto Soares",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2930907,
    "nome": "Tabocas do Brejo Velho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931004,
    "nome": "Tanhaçu",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931053,
    "nome": "Tanque Novo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931103,
    "nome": "Tanquinho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931202,
    "nome": "Taperoá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931301,
    "nome": "Tapiramutá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931400,
    "nome": "Teodoro Sampaio",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931509,
    "nome": "Teofilândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931608,
    "nome": "Teolândia",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931707,
    "nome": "Terra Nova",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931806,
    "nome": "Tremedal",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2931905,
    "nome": "Tucano",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932002,
    "nome": "Uauá",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932101,
    "nome": "Ubaíra",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932200,
    "nome": "Ubaitaba",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932309,
    "nome": "Ubatã",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932408,
    "nome": "Uibaí",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932457,
    "nome": "Umburanas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932507,
    "nome": "Una",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932606,
    "nome": "Urandi",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932705,
    "nome": "Uruçuca",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932804,
    "nome": "Utinga",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2932903,
    "nome": "Valença",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933000,
    "nome": "Valente",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933059,
    "nome": "Várzea da Roça",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933109,
    "nome": "Várzea do Poço",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933158,
    "nome": "Várzea Nova",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933174,
    "nome": "Varzedo",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933208,
    "nome": "Vera Cruz",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933257,
    "nome": "Vereda",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933406,
    "nome": "Wagner",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933455,
    "nome": "Wanderley",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933505,
    "nome": "Wenceslau Guimarães",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 2933604,
    "nome": "Xique-Xique",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100104,
    "nome": "Abadia dos Dourados",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100203,
    "nome": "Abaeté",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100302,
    "nome": "Abre Campo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100401,
    "nome": "Acaiaca",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100500,
    "nome": "Açucena",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100609,
    "nome": "Água Boa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100708,
    "nome": "Água Comprida",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100807,
    "nome": "Aguanil",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3100906,
    "nome": "Águas Formosas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101003,
    "nome": "Águas Vermelhas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101102,
    "nome": "Aimorés",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101201,
    "nome": "Aiuruoca",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101300,
    "nome": "Alagoa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101409,
    "nome": "Albertina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101508,
    "nome": "Além Paraíba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101631,
    "nome": "Alfredo Vasconcelos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101706,
    "nome": "Almenara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101805,
    "nome": "Alpercata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3101904,
    "nome": "Alpinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102001,
    "nome": "Alterosa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102050,
    "nome": "Alto Caparaó",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102100,
    "nome": "Alto Rio Doce",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102209,
    "nome": "Alvarenga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102308,
    "nome": "Alvinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102407,
    "nome": "Alvorada de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102506,
    "nome": "Amparo do Serra",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102605,
    "nome": "Andradas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102704,
    "nome": "Cachoeira de Pajeú",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102803,
    "nome": "Andrelândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102852,
    "nome": "Angelândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3102902,
    "nome": "Antônio Carlos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103009,
    "nome": "Antônio Dias",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103108,
    "nome": "Antônio Prado de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103207,
    "nome": "Araçaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103306,
    "nome": "Aracitaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103405,
    "nome": "Araçuaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103603,
    "nome": "Arantina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103702,
    "nome": "Araponga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103751,
    "nome": "Araporã",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103801,
    "nome": "Arapuá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3103900,
    "nome": "Araújos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104106,
    "nome": "Arceburgo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104205,
    "nome": "Arcos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104304,
    "nome": "Areado",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104403,
    "nome": "Argirita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104452,
    "nome": "Aricanduva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104502,
    "nome": "Arinos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104601,
    "nome": "Astolfo Dutra",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104700,
    "nome": "Ataléia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104809,
    "nome": "Augusto de Lima",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3104908,
    "nome": "Baependi",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105004,
    "nome": "Baldim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105103,
    "nome": "Bambuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105202,
    "nome": "Bandeira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105301,
    "nome": "Bandeira do Sul",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105400,
    "nome": "Barão de Cocais",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105509,
    "nome": "Barão do Monte Alto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105707,
    "nome": "Barra Longa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3105905,
    "nome": "Barroso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106002,
    "nome": "Bela Vista de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106101,
    "nome": "Belmiro Braga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106309,
    "nome": "Belo Oriente",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106408,
    "nome": "Belo Vale",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106507,
    "nome": "Berilo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106606,
    "nome": "Bertópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106655,
    "nome": "Berizal",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106804,
    "nome": "Bias Fortes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3106903,
    "nome": "Bicas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107000,
    "nome": "Biquinhas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107109,
    "nome": "Boa Esperança",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107208,
    "nome": "Bocaina de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107307,
    "nome": "Bocaiúva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107406,
    "nome": "Bom Despacho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107505,
    "nome": "Bom Jardim de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107604,
    "nome": "Bom Jesus da Penha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107703,
    "nome": "Bom Jesus do Amparo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107802,
    "nome": "Bom Jesus do Galho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3107901,
    "nome": "Bom Repouso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108008,
    "nome": "Bom Sucesso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108107,
    "nome": "Bonfim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108206,
    "nome": "Bonfinópolis de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108255,
    "nome": "Bonito de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108305,
    "nome": "Borda da Mata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108404,
    "nome": "Botelhos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108503,
    "nome": "Botumirim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108552,
    "nome": "Brasilândia de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108602,
    "nome": "Brasília de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108701,
    "nome": "Brás Pires",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108800,
    "nome": "Braúnas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3108909,
    "nome": "Brazópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109006,
    "nome": "Brumadinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109105,
    "nome": "Bueno Brandão",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109204,
    "nome": "Buenópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109253,
    "nome": "Bugre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109303,
    "nome": "Buritis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109402,
    "nome": "Buritizeiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109451,
    "nome": "Cabeceira Grande",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109501,
    "nome": "Cabo Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109600,
    "nome": "Cachoeira da Prata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109709,
    "nome": "Cachoeira de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109808,
    "nome": "Cachoeira Dourada",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3109907,
    "nome": "Caetanópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110004,
    "nome": "Caeté",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110103,
    "nome": "Caiana",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110202,
    "nome": "Cajuri",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110301,
    "nome": "Caldas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110400,
    "nome": "Camacho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110509,
    "nome": "Camanducaia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110608,
    "nome": "Cambuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110707,
    "nome": "Cambuquira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110806,
    "nome": "Campanário",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3110905,
    "nome": "Campanha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111002,
    "nome": "Campestre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111101,
    "nome": "Campina Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111150,
    "nome": "Campo Azul",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111200,
    "nome": "Campo Belo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111309,
    "nome": "Campo do Meio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111408,
    "nome": "Campo Florido",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111507,
    "nome": "Campos Altos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111606,
    "nome": "Campos Gerais",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111705,
    "nome": "Canaã",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111804,
    "nome": "Canápolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3111903,
    "nome": "Cana Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112000,
    "nome": "Candeias",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112059,
    "nome": "Cantagalo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112109,
    "nome": "Caparaó",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112208,
    "nome": "Capela Nova",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112307,
    "nome": "Capelinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112406,
    "nome": "Capetinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112505,
    "nome": "Capim Branco",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112604,
    "nome": "Capinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112653,
    "nome": "Capitão Andrade",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112703,
    "nome": "Capitão Enéas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112802,
    "nome": "Capitólio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3112901,
    "nome": "Caputira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113008,
    "nome": "Caraí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113107,
    "nome": "Caranaíba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113206,
    "nome": "Carandaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113305,
    "nome": "Carangola",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113404,
    "nome": "Caratinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113503,
    "nome": "Carbonita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113602,
    "nome": "Careaçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113701,
    "nome": "Carlos Chagas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113800,
    "nome": "Carmésia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3113909,
    "nome": "Carmo da Cachoeira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114006,
    "nome": "Carmo da Mata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114105,
    "nome": "Carmo de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114204,
    "nome": "Carmo do Cajuru",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114303,
    "nome": "Carmo do Paranaíba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114402,
    "nome": "Carmo do Rio Claro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114501,
    "nome": "Carmópolis de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114550,
    "nome": "Carneirinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114600,
    "nome": "Carrancas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114709,
    "nome": "Carvalhópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114808,
    "nome": "Carvalhos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3114907,
    "nome": "Casa Grande",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115003,
    "nome": "Cascalho Rico",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115102,
    "nome": "Cássia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115201,
    "nome": "Conceição da Barra de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115300,
    "nome": "Cataguases",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115359,
    "nome": "Catas Altas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115409,
    "nome": "Catas Altas da Noruega",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115458,
    "nome": "Catuji",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115474,
    "nome": "Catuti",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115508,
    "nome": "Caxambu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115607,
    "nome": "Cedro do Abaeté",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115706,
    "nome": "Central de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115805,
    "nome": "Centralina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3115904,
    "nome": "Chácara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116001,
    "nome": "Chalé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116100,
    "nome": "Chapada do Norte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116159,
    "nome": "Chapada Gaúcha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116209,
    "nome": "Chiador",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116308,
    "nome": "Cipotânea",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116407,
    "nome": "Claraval",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116506,
    "nome": "Claro dos Poções",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116605,
    "nome": "Cláudio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116704,
    "nome": "Coimbra",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116803,
    "nome": "Coluna",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3116902,
    "nome": "Comendador Gomes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117009,
    "nome": "Comercinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117108,
    "nome": "Conceição da Aparecida",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117207,
    "nome": "Conceição das Pedras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117306,
    "nome": "Conceição das Alagoas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117405,
    "nome": "Conceição de Ipanema",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117603,
    "nome": "Conceição do Pará",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117702,
    "nome": "Conceição do Rio Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117801,
    "nome": "Conceição dos Ouros",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117836,
    "nome": "Cônego Marinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117876,
    "nome": "Confins",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3117900,
    "nome": "Congonhal",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118106,
    "nome": "Congonhas do Norte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118205,
    "nome": "Conquista",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118403,
    "nome": "Conselheiro Pena",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118502,
    "nome": "Consolação",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118700,
    "nome": "Coqueiral",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118809,
    "nome": "Coração de Jesus",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3118908,
    "nome": "Cordisburgo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119005,
    "nome": "Cordislândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119104,
    "nome": "Corinto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119203,
    "nome": "Coroaci",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119302,
    "nome": "Coromandel",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119401,
    "nome": "Coronel Fabriciano",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119500,
    "nome": "Coronel Murta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119609,
    "nome": "Coronel Pacheco",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119708,
    "nome": "Coronel Xavier Chaves",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119807,
    "nome": "Córrego Danta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119906,
    "nome": "Córrego do Bom Jesus",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3119955,
    "nome": "Córrego Fundo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120003,
    "nome": "Córrego Novo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120102,
    "nome": "Couto de Magalhães de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120151,
    "nome": "Crisólita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120201,
    "nome": "Cristais",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120300,
    "nome": "Cristália",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120409,
    "nome": "Cristiano Otoni",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120508,
    "nome": "Cristina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120607,
    "nome": "Crucilândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120706,
    "nome": "Cruzeiro da Fortaleza",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120805,
    "nome": "Cruzília",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120839,
    "nome": "Cuparaque",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120870,
    "nome": "Curral de Dentro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3120904,
    "nome": "Curvelo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121001,
    "nome": "Datas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121100,
    "nome": "Delfim Moreira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121209,
    "nome": "Delfinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121258,
    "nome": "Delta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121308,
    "nome": "Descoberto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121407,
    "nome": "Desterro de Entre Rios",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121506,
    "nome": "Desterro do Melo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121605,
    "nome": "Diamantina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121704,
    "nome": "Diogo de Vasconcelos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121803,
    "nome": "Dionísio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3121902,
    "nome": "Divinésia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122009,
    "nome": "Divino",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122108,
    "nome": "Divino das Laranjeiras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122207,
    "nome": "Divinolândia de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122355,
    "nome": "Divisa Alegre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122405,
    "nome": "Divisa Nova",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122454,
    "nome": "Divisópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122470,
    "nome": "Dom Bosco",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122504,
    "nome": "Dom Cavati",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122603,
    "nome": "Dom Joaquim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122702,
    "nome": "Dom Silvério",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122801,
    "nome": "Dom Viçoso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3122900,
    "nome": "Dona Euzébia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123007,
    "nome": "Dores de Campos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123106,
    "nome": "Dores de Guanhães",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123205,
    "nome": "Dores do Indaiá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123304,
    "nome": "Dores do Turvo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123403,
    "nome": "Doresópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123502,
    "nome": "Douradoquara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123528,
    "nome": "Durandé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123601,
    "nome": "Elói Mendes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123700,
    "nome": "Engenheiro Caldas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123809,
    "nome": "Engenheiro Navarro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123858,
    "nome": "Entre Folhas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3123908,
    "nome": "Entre Rios de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124005,
    "nome": "Ervália",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124104,
    "nome": "Esmeraldas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124203,
    "nome": "Espera Feliz",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124302,
    "nome": "Espinosa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124401,
    "nome": "Espírito Santo do Dourado",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124500,
    "nome": "Estiva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124609,
    "nome": "Estrela Dalva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124708,
    "nome": "Estrela do Indaiá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124807,
    "nome": "Estrela do Sul",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3124906,
    "nome": "Eugenópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125002,
    "nome": "Ewbank da Câmara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125200,
    "nome": "Fama",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125309,
    "nome": "Faria Lemos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125408,
    "nome": "Felício dos Santos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125507,
    "nome": "São Gonçalo do Rio Preto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125606,
    "nome": "Felisburgo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125705,
    "nome": "Felixlândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125804,
    "nome": "Fernandes Tourinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125903,
    "nome": "Ferros",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3125952,
    "nome": "Fervedouro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126000,
    "nome": "Florestal",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126109,
    "nome": "Formiga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126208,
    "nome": "Formoso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126307,
    "nome": "Fortaleza de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126406,
    "nome": "Fortuna de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126505,
    "nome": "Francisco Badaró",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126604,
    "nome": "Francisco Dumont",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126703,
    "nome": "Francisco Sá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126752,
    "nome": "Franciscópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126802,
    "nome": "Frei Gaspar",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126901,
    "nome": "Frei Inocêncio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3126950,
    "nome": "Frei Lagonegro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127008,
    "nome": "Fronteira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127057,
    "nome": "Fronteira dos Vales",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127073,
    "nome": "Fruta de Leite",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127206,
    "nome": "Funilândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127305,
    "nome": "Galiléia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127339,
    "nome": "Gameleiras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127354,
    "nome": "Glaucilândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127370,
    "nome": "Goiabeira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127388,
    "nome": "Goianá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127404,
    "nome": "Gonçalves",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127503,
    "nome": "Gonzaga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127602,
    "nome": "Gouveia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127800,
    "nome": "Grão Mogol",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3127909,
    "nome": "Grupiara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128006,
    "nome": "Guanhães",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128105,
    "nome": "Guapé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128204,
    "nome": "Guaraciaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128253,
    "nome": "Guaraciama",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128303,
    "nome": "Guaranésia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128402,
    "nome": "Guarani",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128501,
    "nome": "Guarará",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128600,
    "nome": "Guarda-Mor",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128808,
    "nome": "Guidoval",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3128907,
    "nome": "Guimarânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129004,
    "nome": "Guiricema",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129103,
    "nome": "Gurinhatã",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129202,
    "nome": "Heliodora",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129301,
    "nome": "Iapu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129400,
    "nome": "Ibertioga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129509,
    "nome": "Ibiá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129608,
    "nome": "Ibiaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129657,
    "nome": "Ibiracatu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129707,
    "nome": "Ibiraci",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3129905,
    "nome": "Ibitiúra de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130002,
    "nome": "Ibituruna",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130051,
    "nome": "Icaraí de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130101,
    "nome": "Igarapé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130200,
    "nome": "Igaratinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130309,
    "nome": "Iguatama",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130408,
    "nome": "Ijaci",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130507,
    "nome": "Ilicínea",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130556,
    "nome": "Imbé de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130606,
    "nome": "Inconfidentes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130655,
    "nome": "Indaiabira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130705,
    "nome": "Indianópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130804,
    "nome": "Ingaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3130903,
    "nome": "Inhapim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131000,
    "nome": "Inhaúma",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131109,
    "nome": "Inimutaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131158,
    "nome": "Ipaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131208,
    "nome": "Ipanema",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131406,
    "nome": "Ipiaçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131505,
    "nome": "Ipuiúna",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131604,
    "nome": "Iraí de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3131802,
    "nome": "Itabirinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132008,
    "nome": "Itacambira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132107,
    "nome": "Itacarambi",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132206,
    "nome": "Itaguara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132305,
    "nome": "Itaipé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132503,
    "nome": "Itamarandiba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132602,
    "nome": "Itamarati de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132701,
    "nome": "Itambacuri",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132800,
    "nome": "Itambé do Mato Dentro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3132909,
    "nome": "Itamogi",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133006,
    "nome": "Itamonte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133105,
    "nome": "Itanhandu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133204,
    "nome": "Itanhomi",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133303,
    "nome": "Itaobim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133402,
    "nome": "Itapagipe",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133501,
    "nome": "Itapecerica",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133600,
    "nome": "Itapeva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133758,
    "nome": "Itaú de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3133907,
    "nome": "Itaverava",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134004,
    "nome": "Itinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134103,
    "nome": "Itueta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134301,
    "nome": "Itumirim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134400,
    "nome": "Iturama",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134509,
    "nome": "Itutinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134608,
    "nome": "Jaboticatubas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134707,
    "nome": "Jacinto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134806,
    "nome": "Jacuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3134905,
    "nome": "Jacutinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135001,
    "nome": "Jaguaraçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135050,
    "nome": "Jaíba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135076,
    "nome": "Jampruca",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135100,
    "nome": "Janaúba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135209,
    "nome": "Januária",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135308,
    "nome": "Japaraíba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135357,
    "nome": "Japonvar",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135407,
    "nome": "Jeceaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135456,
    "nome": "Jenipapo de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135506,
    "nome": "Jequeri",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135605,
    "nome": "Jequitaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135704,
    "nome": "Jequitibá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135803,
    "nome": "Jequitinhonha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3135902,
    "nome": "Jesuânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136009,
    "nome": "Joaíma",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136108,
    "nome": "Joanésia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136306,
    "nome": "João Pinheiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136405,
    "nome": "Joaquim Felício",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136504,
    "nome": "Jordânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136520,
    "nome": "José Gonçalves de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136553,
    "nome": "José Raydan",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136579,
    "nome": "Josenópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136603,
    "nome": "Nova União",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136652,
    "nome": "Juatuba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136801,
    "nome": "Juramento",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136900,
    "nome": "Juruaia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3136959,
    "nome": "Juvenília",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137007,
    "nome": "Ladainha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137106,
    "nome": "Lagamar",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137205,
    "nome": "Lagoa da Prata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137304,
    "nome": "Lagoa dos Patos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137403,
    "nome": "Lagoa Dourada",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137502,
    "nome": "Lagoa Formosa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137536,
    "nome": "Lagoa Grande",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137601,
    "nome": "Lagoa Santa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137700,
    "nome": "Lajinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137809,
    "nome": "Lambari",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3137908,
    "nome": "Lamim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138005,
    "nome": "Laranjal",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138104,
    "nome": "Lassance",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138302,
    "nome": "Leandro Ferreira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138351,
    "nome": "Leme do Prado",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138401,
    "nome": "Leopoldina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138500,
    "nome": "Liberdade",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138609,
    "nome": "Lima Duarte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138625,
    "nome": "Limeira do Oeste",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138658,
    "nome": "Lontra",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138674,
    "nome": "Luisburgo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138682,
    "nome": "Luislândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138708,
    "nome": "Luminárias",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138807,
    "nome": "Luz",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3138906,
    "nome": "Machacalis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139003,
    "nome": "Machado",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139102,
    "nome": "Madre de Deus de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139201,
    "nome": "Malacacheta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139250,
    "nome": "Mamonas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139300,
    "nome": "Manga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139508,
    "nome": "Manhumirim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139607,
    "nome": "Mantena",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139706,
    "nome": "Maravilhas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139805,
    "nome": "Mar de Espanha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3139904,
    "nome": "Maria da Fé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140100,
    "nome": "Marilac",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140159,
    "nome": "Mário Campos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140209,
    "nome": "Maripá de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140308,
    "nome": "Marliéria",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140407,
    "nome": "Marmelópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140506,
    "nome": "Martinho Campos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140530,
    "nome": "Martins Soares",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140555,
    "nome": "Mata Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140605,
    "nome": "Materlândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140704,
    "nome": "Mateus Leme",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140803,
    "nome": "Matias Barbosa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140852,
    "nome": "Matias Cardoso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3140902,
    "nome": "Matipó",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141009,
    "nome": "Mato Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141108,
    "nome": "Matozinhos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141207,
    "nome": "Matutina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141306,
    "nome": "Medeiros",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141405,
    "nome": "Medina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141504,
    "nome": "Mendes Pimentel",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141603,
    "nome": "Mercês",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141702,
    "nome": "Mesquita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141801,
    "nome": "Minas Novas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3141900,
    "nome": "Minduri",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142007,
    "nome": "Mirabela",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142106,
    "nome": "Miradouro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142205,
    "nome": "Miraí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142254,
    "nome": "Miravânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142304,
    "nome": "Moeda",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142403,
    "nome": "Moema",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142502,
    "nome": "Monjolos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142601,
    "nome": "Monsenhor Paulo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142700,
    "nome": "Montalvânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142809,
    "nome": "Monte Alegre de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3142908,
    "nome": "Monte Azul",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143005,
    "nome": "Monte Belo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143104,
    "nome": "Monte Carmelo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143153,
    "nome": "Monte Formoso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143203,
    "nome": "Monte Santo de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143401,
    "nome": "Monte Sião",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143450,
    "nome": "Montezuma",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143500,
    "nome": "Morada Nova de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143609,
    "nome": "Morro da Garça",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143708,
    "nome": "Morro do Pilar",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3143807,
    "nome": "Munhoz",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144003,
    "nome": "Mutum",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144102,
    "nome": "Muzambinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144201,
    "nome": "Nacip Raydan",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144300,
    "nome": "Nanuque",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144359,
    "nome": "Naque",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144375,
    "nome": "Natalândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144409,
    "nome": "Natércia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144508,
    "nome": "Nazareno",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144607,
    "nome": "Nepomuceno",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144656,
    "nome": "Ninheira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144672,
    "nome": "Nova Belém",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144706,
    "nome": "Nova Era",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3144904,
    "nome": "Nova Módica",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145000,
    "nome": "Nova Ponte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145059,
    "nome": "Nova Porteirinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145109,
    "nome": "Nova Resende",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145307,
    "nome": "Novo Cruzeiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145356,
    "nome": "Novo Oriente de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145372,
    "nome": "Novorizonte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145406,
    "nome": "Olaria",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145455,
    "nome": "Olhos-d'Água",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145505,
    "nome": "Olímpio Noronha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145604,
    "nome": "Oliveira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145703,
    "nome": "Oliveira Fortes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145802,
    "nome": "Onça de Pitangui",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145851,
    "nome": "Oratórios",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3145877,
    "nome": "Orizânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146008,
    "nome": "Ouro Fino",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146206,
    "nome": "Ouro Verde de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146255,
    "nome": "Padre Carvalho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146305,
    "nome": "Padre Paraíso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146404,
    "nome": "Paineiras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146503,
    "nome": "Pains",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146552,
    "nome": "Pai Pedro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146602,
    "nome": "Paiva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146701,
    "nome": "Palma",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146750,
    "nome": "Palmópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3146909,
    "nome": "Papagaios",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147204,
    "nome": "Paraguaçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147303,
    "nome": "Paraisópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147402,
    "nome": "Paraopeba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147501,
    "nome": "Passabém",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147600,
    "nome": "Passa Quatro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147709,
    "nome": "Passa Tempo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147808,
    "nome": "Passa Vinte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3147956,
    "nome": "Patis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148202,
    "nome": "Patrocínio do Muriaé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148301,
    "nome": "Paula Cândido",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148400,
    "nome": "Paulistas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148509,
    "nome": "Pavão",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148608,
    "nome": "Peçanha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148707,
    "nome": "Pedra Azul",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148756,
    "nome": "Pedra Bonita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148806,
    "nome": "Pedra do Anta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3148905,
    "nome": "Pedra do Indaiá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149002,
    "nome": "Pedra Dourada",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149101,
    "nome": "Pedralva",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149150,
    "nome": "Pedras de Maria da Cruz",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149200,
    "nome": "Pedrinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149309,
    "nome": "Pedro Leopoldo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149408,
    "nome": "Pedro Teixeira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149507,
    "nome": "Pequeri",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149606,
    "nome": "Pequi",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149705,
    "nome": "Perdigão",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149804,
    "nome": "Perdizes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149903,
    "nome": "Perdões",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3149952,
    "nome": "Periquito",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150000,
    "nome": "Pescador",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150109,
    "nome": "Piau",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150158,
    "nome": "Piedade de Caratinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150208,
    "nome": "Piedade de Ponte Nova",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150307,
    "nome": "Piedade do Rio Grande",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150406,
    "nome": "Piedade dos Gerais",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150505,
    "nome": "Pimenta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150539,
    "nome": "Pingo-d'Água",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150570,
    "nome": "Pintópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150604,
    "nome": "Piracema",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150703,
    "nome": "Pirajuba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150802,
    "nome": "Piranga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3150901,
    "nome": "Piranguçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151008,
    "nome": "Piranguinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151107,
    "nome": "Pirapetinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151305,
    "nome": "Piraúba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151404,
    "nome": "Pitangui",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151503,
    "nome": "Piumhi",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151602,
    "nome": "Planura",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151701,
    "nome": "Poço Fundo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3151909,
    "nome": "Pocrane",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152006,
    "nome": "Pompéu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152105,
    "nome": "Ponte Nova",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152131,
    "nome": "Ponto Chique",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152170,
    "nome": "Ponto dos Volantes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152204,
    "nome": "Porteirinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152303,
    "nome": "Porto Firme",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152402,
    "nome": "Poté",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152600,
    "nome": "Pouso Alto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152709,
    "nome": "Prados",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152808,
    "nome": "Prata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3152907,
    "nome": "Pratápolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153004,
    "nome": "Pratinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153103,
    "nome": "Presidente Bernardes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153202,
    "nome": "Presidente Juscelino",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153301,
    "nome": "Presidente Kubitschek",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153400,
    "nome": "Presidente Olegário",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153509,
    "nome": "Alto Jequitibá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153608,
    "nome": "Prudente de Morais",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153707,
    "nome": "Quartel Geral",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153806,
    "nome": "Queluzito",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3153905,
    "nome": "Raposos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154002,
    "nome": "Raul Soares",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154101,
    "nome": "Recreio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154150,
    "nome": "Reduto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154200,
    "nome": "Resende Costa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154309,
    "nome": "Resplendor",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154408,
    "nome": "Ressaquinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154457,
    "nome": "Riachinho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154507,
    "nome": "Riacho dos Machados",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154705,
    "nome": "Ribeirão Vermelho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154804,
    "nome": "Rio Acima",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3154903,
    "nome": "Rio Casca",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155009,
    "nome": "Rio Doce",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155108,
    "nome": "Rio do Prado",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155207,
    "nome": "Rio Espera",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155306,
    "nome": "Rio Manso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155405,
    "nome": "Rio Novo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155504,
    "nome": "Rio Paranaíba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155603,
    "nome": "Rio Pardo de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155702,
    "nome": "Rio Piracicaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155801,
    "nome": "Rio Pomba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3155900,
    "nome": "Rio Preto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156007,
    "nome": "Rio Vermelho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156106,
    "nome": "Ritápolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156205,
    "nome": "Rochedo de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156304,
    "nome": "Rodeiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156403,
    "nome": "Romaria",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156452,
    "nome": "Rosário da Limeira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156502,
    "nome": "Rubelita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156601,
    "nome": "Rubim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156809,
    "nome": "Sabinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3156908,
    "nome": "Sacramento",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157005,
    "nome": "Salinas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157104,
    "nome": "Salto da Divisa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157203,
    "nome": "Santa Bárbara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157252,
    "nome": "Santa Bárbara do Leste",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157278,
    "nome": "Santa Bárbara do Monte Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157302,
    "nome": "Santa Bárbara do Tugúrio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157336,
    "nome": "Santa Cruz de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157377,
    "nome": "Santa Cruz de Salinas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157401,
    "nome": "Santa Cruz do Escalvado",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157500,
    "nome": "Santa Efigênia de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157609,
    "nome": "Santa Fé de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157658,
    "nome": "Santa Helena de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157708,
    "nome": "Santa Juliana",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3157906,
    "nome": "Santa Margarida",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158003,
    "nome": "Santa Maria de Itabira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158102,
    "nome": "Santa Maria do Salto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158201,
    "nome": "Santa Maria do Suaçuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158300,
    "nome": "Santana da Vargem",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158409,
    "nome": "Santana de Cataguases",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158508,
    "nome": "Santana de Pirapama",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158607,
    "nome": "Santana do Deserto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158706,
    "nome": "Santana do Garambéu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158805,
    "nome": "Santana do Jacaré",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158904,
    "nome": "Santana do Manhuaçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3158953,
    "nome": "Santana do Paraíso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159001,
    "nome": "Santana do Riacho",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159100,
    "nome": "Santana dos Montes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159209,
    "nome": "Santa Rita de Caldas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159308,
    "nome": "Santa Rita de Jacutinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159357,
    "nome": "Santa Rita de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159407,
    "nome": "Santa Rita de Ibitipoca",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159506,
    "nome": "Santa Rita do Itueto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159605,
    "nome": "Santa Rita do Sapucaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159704,
    "nome": "Santa Rosa da Serra",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159803,
    "nome": "Santa Vitória",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3159902,
    "nome": "Santo Antônio do Amparo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160009,
    "nome": "Santo Antônio do Aventureiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160108,
    "nome": "Santo Antônio do Grama",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160207,
    "nome": "Santo Antônio do Itambé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160306,
    "nome": "Santo Antônio do Jacinto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160405,
    "nome": "Santo Antônio do Monte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160454,
    "nome": "Santo Antônio do Retiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160504,
    "nome": "Santo Antônio do Rio Abaixo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160603,
    "nome": "Santo Hipólito",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160702,
    "nome": "Santos Dumont",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160801,
    "nome": "São Bento Abade",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160900,
    "nome": "São Brás do Suaçuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3160959,
    "nome": "São Domingos das Dores",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161007,
    "nome": "São Domingos do Prata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161056,
    "nome": "São Félix de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161106,
    "nome": "São Francisco",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161205,
    "nome": "São Francisco de Paula",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161304,
    "nome": "São Francisco de Sales",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161403,
    "nome": "São Francisco do Glória",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161502,
    "nome": "São Geraldo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161601,
    "nome": "São Geraldo da Piedade",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161650,
    "nome": "São Geraldo do Baixio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161700,
    "nome": "São Gonçalo do Abaeté",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3161809,
    "nome": "São Gonçalo do Pará",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162005,
    "nome": "São Gonçalo do Sapucaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162104,
    "nome": "São Gotardo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162203,
    "nome": "São João Batista do Glória",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162252,
    "nome": "São João da Lagoa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162302,
    "nome": "São João da Mata",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162401,
    "nome": "São João da Ponte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162450,
    "nome": "São João das Missões",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162559,
    "nome": "São João do Manhuaçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162575,
    "nome": "São João do Manteninha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162609,
    "nome": "São João do Oriente",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162658,
    "nome": "São João do Pacuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162708,
    "nome": "São João do Paraíso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162807,
    "nome": "São João Evangelista",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162906,
    "nome": "São João Nepomuceno",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162922,
    "nome": "São Joaquim de Bicas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162948,
    "nome": "São José da Barra",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3162955,
    "nome": "São José da Lapa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163003,
    "nome": "São José da Safira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163102,
    "nome": "São José da Varginha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163201,
    "nome": "São José do Alegre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163300,
    "nome": "São José do Divino",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163409,
    "nome": "São José do Goiabal",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163508,
    "nome": "São José do Jacuri",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163607,
    "nome": "São José do Mantimento",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163706,
    "nome": "São Lourenço",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163805,
    "nome": "São Miguel do Anta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3163904,
    "nome": "São Pedro da União",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164001,
    "nome": "São Pedro dos Ferros",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164100,
    "nome": "São Pedro do Suaçuí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164209,
    "nome": "São Romão",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164308,
    "nome": "São Roque de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164407,
    "nome": "São Sebastião da Bela Vista",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164431,
    "nome": "São Sebastião da Vargem Alegre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164472,
    "nome": "São Sebastião do Anta",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164506,
    "nome": "São Sebastião do Maranhão",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164605,
    "nome": "São Sebastião do Oeste",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164704,
    "nome": "São Sebastião do Paraíso",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164803,
    "nome": "São Sebastião do Rio Preto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3164902,
    "nome": "São Sebastião do Rio Verde",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165008,
    "nome": "São Tiago",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165107,
    "nome": "São Tomás de Aquino",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165206,
    "nome": "São Tomé das Letras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165305,
    "nome": "São Vicente de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165404,
    "nome": "Sapucaí-Mirim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165503,
    "nome": "Sardoá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165537,
    "nome": "Sarzedo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165552,
    "nome": "Setubinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165560,
    "nome": "Sem-Peixe",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165578,
    "nome": "Senador Amaral",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165602,
    "nome": "Senador Cortes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165701,
    "nome": "Senador Firmino",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165800,
    "nome": "Senador José Bento",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3165909,
    "nome": "Senador Modestino Gonçalves",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166006,
    "nome": "Senhora de Oliveira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166105,
    "nome": "Senhora do Porto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166204,
    "nome": "Senhora dos Remédios",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166303,
    "nome": "Sericita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166402,
    "nome": "Seritinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166501,
    "nome": "Serra Azul de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166600,
    "nome": "Serra da Saudade",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166709,
    "nome": "Serra dos Aimorés",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166808,
    "nome": "Serra do Salitre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166907,
    "nome": "Serrania",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3166956,
    "nome": "Serranópolis de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167004,
    "nome": "Serranos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167103,
    "nome": "Serro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167301,
    "nome": "Silveirânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167400,
    "nome": "Silvianópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167509,
    "nome": "Simão Pereira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167608,
    "nome": "Simonésia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167707,
    "nome": "Sobrália",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167806,
    "nome": "Soledade de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3167905,
    "nome": "Tabuleiro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168002,
    "nome": "Taiobeiras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168051,
    "nome": "Taparuba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168101,
    "nome": "Tapira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168200,
    "nome": "Tapiraí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168309,
    "nome": "Taquaraçu de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168408,
    "nome": "Tarumirim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168507,
    "nome": "Teixeiras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168804,
    "nome": "Tiradentes",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3168903,
    "nome": "Tiros",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169000,
    "nome": "Tocantins",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169059,
    "nome": "Tocos do Moji",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169109,
    "nome": "Toledo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169208,
    "nome": "Tombos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169356,
    "nome": "Três Marias",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169406,
    "nome": "Três Pontas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169505,
    "nome": "Tumiritinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169604,
    "nome": "Tupaciguara",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169703,
    "nome": "Turmalina",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3169802,
    "nome": "Turvolândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170008,
    "nome": "Ubaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170057,
    "nome": "Ubaporanga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170305,
    "nome": "Umburatiba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170438,
    "nome": "União de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170479,
    "nome": "Uruana de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170503,
    "nome": "Urucânia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170529,
    "nome": "Urucuia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170578,
    "nome": "Vargem Alegre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170602,
    "nome": "Vargem Bonita",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170651,
    "nome": "Vargem Grande do Rio Pardo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170750,
    "nome": "Varjão de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170800,
    "nome": "Várzea da Palma",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3170909,
    "nome": "Varzelândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171006,
    "nome": "Vazante",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171030,
    "nome": "Verdelândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171071,
    "nome": "Veredinha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171105,
    "nome": "Veríssimo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171154,
    "nome": "Vermelho Novo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171303,
    "nome": "Viçosa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171402,
    "nome": "Vieiras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171501,
    "nome": "Mathias Lobato",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171600,
    "nome": "Virgem da Lapa",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171709,
    "nome": "Virgínia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171808,
    "nome": "Virginópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3171907,
    "nome": "Virgolândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3172004,
    "nome": "Visconde do Rio Branco",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3172103,
    "nome": "Volta Grande",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3172202,
    "nome": "Wenceslau Braz",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200102,
    "nome": "Afonso Cláudio",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200136,
    "nome": "Águia Branca",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200169,
    "nome": "Água Doce do Norte",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200201,
    "nome": "Alegre",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200300,
    "nome": "Alfredo Chaves",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200359,
    "nome": "Alto Rio Novo",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200409,
    "nome": "Anchieta",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200508,
    "nome": "Apiacá",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200706,
    "nome": "Atílio Vivácqua",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200805,
    "nome": "Baixo Guandu",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3200904,
    "nome": "Barra de São Francisco",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201001,
    "nome": "Boa Esperança",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201100,
    "nome": "Bom Jesus do Norte",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201159,
    "nome": "Brejetuba",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201407,
    "nome": "Castelo",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201605,
    "nome": "Conceição da Barra",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201704,
    "nome": "Conceição do Castelo",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201803,
    "nome": "Divino de São Lourenço",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3201902,
    "nome": "Domingos Martins",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202009,
    "nome": "Dores do Rio Preto",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202108,
    "nome": "Ecoporanga",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202207,
    "nome": "Fundão",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202256,
    "nome": "Governador Lindenberg",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202306,
    "nome": "Guaçuí",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202454,
    "nome": "Ibatiba",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202504,
    "nome": "Ibiraçu",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202553,
    "nome": "Ibitirama",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202603,
    "nome": "Iconha",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202652,
    "nome": "Irupi",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202702,
    "nome": "Itaguaçu",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3202900,
    "nome": "Itarana",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203007,
    "nome": "Iúna",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203056,
    "nome": "Jaguaré",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203106,
    "nome": "Jerônimo Monteiro",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203130,
    "nome": "João Neiva",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203163,
    "nome": "Laranja da Terra",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203304,
    "nome": "Mantenópolis",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203346,
    "nome": "Marechal Floriano",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203353,
    "nome": "Marilândia",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203403,
    "nome": "Mimoso do Sul",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203502,
    "nome": "Montanha",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203601,
    "nome": "Mucurici",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203700,
    "nome": "Muniz Freire",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203809,
    "nome": "Muqui",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3203908,
    "nome": "Nova Venécia",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204005,
    "nome": "Pancas",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204054,
    "nome": "Pedro Canário",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204104,
    "nome": "Pinheiros",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204203,
    "nome": "Piúma",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204252,
    "nome": "Ponto Belo",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204351,
    "nome": "Rio Bananal",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204401,
    "nome": "Rio Novo do Sul",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204500,
    "nome": "Santa Leopoldina",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204559,
    "nome": "Santa Maria de Jetibá",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204609,
    "nome": "Santa Teresa",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204658,
    "nome": "São Domingos do Norte",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204708,
    "nome": "São Gabriel da Palha",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204807,
    "nome": "São José do Calçado",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3204955,
    "nome": "São Roque do Canaã",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3205010,
    "nome": "Sooretama",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3205036,
    "nome": "Vargem Alta",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3205069,
    "nome": "Venda Nova do Imigrante",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3205150,
    "nome": "Vila Pavão",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3205176,
    "nome": "Vila Valério",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300159,
    "nome": "Aperibé",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300225,
    "nome": "Areal",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300506,
    "nome": "Bom Jardim",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300605,
    "nome": "Bom Jesus do Itabapoana",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300803,
    "nome": "Cachoeiras de Macacu",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300902,
    "nome": "Cambuci",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300936,
    "nome": "Carapebus",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3300951,
    "nome": "Comendador Levy Gasparian",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301108,
    "nome": "Cantagalo",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301157,
    "nome": "Cardoso Moreira",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301207,
    "nome": "Carmo",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301405,
    "nome": "Conceição de Macabu",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301504,
    "nome": "Cordeiro",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301603,
    "nome": "Duas Barras",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301801,
    "nome": "Engenheiro Paulo de Frontin",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301850,
    "nome": "Guapimirim",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3301876,
    "nome": "Iguaba Grande",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302056,
    "nome": "Italva",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302106,
    "nome": "Itaocara",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302270,
    "nome": "Japeri",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302304,
    "nome": "Laje do Muriaé",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302452,
    "nome": "Macuco",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302809,
    "nome": "Mendes",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3302908,
    "nome": "Miguel Pereira",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3303005,
    "nome": "Miracema",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3303104,
    "nome": "Natividade",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3303609,
    "nome": "Paracambi",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3303708,
    "nome": "Paraíba do Sul",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3303856,
    "nome": "Paty do Alferes",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3303955,
    "nome": "Pinheiral",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304102,
    "nome": "Porciúncula",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304128,
    "nome": "Quatis",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304300,
    "nome": "Rio Bonito",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304409,
    "nome": "Rio Claro",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304508,
    "nome": "Rio das Flores",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304607,
    "nome": "Santa Maria Madalena",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304706,
    "nome": "Santo Antônio de Pádua",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304755,
    "nome": "São Francisco de Itabapoana",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3304805,
    "nome": "São Fidélis",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305133,
    "nome": "São José de Ubá",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305158,
    "nome": "São José do Vale do Rio Preto",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305307,
    "nome": "São Sebastião do Alto",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305406,
    "nome": "Sapucaia",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305604,
    "nome": "Silva Jardim",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305703,
    "nome": "Sumidouro",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305752,
    "nome": "Tanguá",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3305901,
    "nome": "Trajano de Moraes",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3306156,
    "nome": "Varre-Sai",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3306206,
    "nome": "Vassouras",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500105,
    "nome": "Adamantina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500204,
    "nome": "Adolfo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500303,
    "nome": "Aguaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500402,
    "nome": "Águas da Prata",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500501,
    "nome": "Águas de Lindóia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500550,
    "nome": "Águas de Santa Bárbara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500600,
    "nome": "Águas de São Pedro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500709,
    "nome": "Agudos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500758,
    "nome": "Alambari",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500808,
    "nome": "Alfredo Marcondes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3500907,
    "nome": "Altair",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501004,
    "nome": "Altinópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501103,
    "nome": "Alto Alegre",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501202,
    "nome": "Álvares Florence",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501301,
    "nome": "Álvares Machado",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501400,
    "nome": "Álvaro de Carvalho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501509,
    "nome": "Alvinlândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501707,
    "nome": "Américo Brasiliense",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3501806,
    "nome": "Américo de Campos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502002,
    "nome": "Analândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502200,
    "nome": "Angatuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502309,
    "nome": "Anhembi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502408,
    "nome": "Anhumas",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502507,
    "nome": "Aparecida",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502606,
    "nome": "Aparecida d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502705,
    "nome": "Apiaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3502903,
    "nome": "Araçoiaba da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503000,
    "nome": "Aramina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503109,
    "nome": "Arandu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503158,
    "nome": "Arapeí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503356,
    "nome": "Arco-Íris",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503406,
    "nome": "Arealva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503505,
    "nome": "Areias",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503604,
    "nome": "Areiópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503703,
    "nome": "Ariranha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503802,
    "nome": "Artur Nogueira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3503950,
    "nome": "Aspásia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504206,
    "nome": "Auriflama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504305,
    "nome": "Avaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504404,
    "nome": "Avanhandava",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504602,
    "nome": "Bady Bassitt",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504701,
    "nome": "Balbinos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504800,
    "nome": "Bálsamo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3504909,
    "nome": "Bananal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505005,
    "nome": "Barão de Antonina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505104,
    "nome": "Barbosa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505203,
    "nome": "Bariri",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505302,
    "nome": "Barra Bonita",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505351,
    "nome": "Barra do Chapéu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505401,
    "nome": "Barra do Turvo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505609,
    "nome": "Barrinha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505807,
    "nome": "Bastos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3505906,
    "nome": "Batatais",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506201,
    "nome": "Bento de Abreu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506300,
    "nome": "Bernardino de Campos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506359,
    "nome": "Bertioga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506409,
    "nome": "Bilac",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506607,
    "nome": "Biritiba Mirim",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506706,
    "nome": "Boa Esperança do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506805,
    "nome": "Bocaina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3506904,
    "nome": "Bofete",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507100,
    "nome": "Bom Jesus dos Perdões",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507159,
    "nome": "Bom Sucesso de Itararé",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507209,
    "nome": "Borá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507308,
    "nome": "Boracéia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507407,
    "nome": "Borborema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507456,
    "nome": "Borebi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507704,
    "nome": "Braúna",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507753,
    "nome": "Brejo Alegre",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507803,
    "nome": "Brodowski",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3507902,
    "nome": "Brotas",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508009,
    "nome": "Buri",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508108,
    "nome": "Buritama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508207,
    "nome": "Buritizal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508306,
    "nome": "Cabrália Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508603,
    "nome": "Cachoeira Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508702,
    "nome": "Caconde",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508801,
    "nome": "Cafelândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3508900,
    "nome": "Caiabu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509106,
    "nome": "Caiuá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509254,
    "nome": "Cajati",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509304,
    "nome": "Cajobi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509403,
    "nome": "Cajuru",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509452,
    "nome": "Campina do Monte Alegre",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509700,
    "nome": "Campos do Jordão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509809,
    "nome": "Campos Novos Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509908,
    "nome": "Cananéia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3509957,
    "nome": "Canas",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510005,
    "nome": "Cândido Mota",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510104,
    "nome": "Cândido Rodrigues",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510153,
    "nome": "Canitar",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510203,
    "nome": "Capão Bonito",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510302,
    "nome": "Capela do Alto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510708,
    "nome": "Cardoso",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510807,
    "nome": "Casa Branca",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3510906,
    "nome": "Cássia dos Coqueiros",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511003,
    "nome": "Castilho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511201,
    "nome": "Catiguá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511300,
    "nome": "Cedral",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511409,
    "nome": "Cerqueira César",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511508,
    "nome": "Cerquilho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511607,
    "nome": "Cesário Lange",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511706,
    "nome": "Charqueada",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3511904,
    "nome": "Clementina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512001,
    "nome": "Colina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512100,
    "nome": "Colômbia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512209,
    "nome": "Conchal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512308,
    "nome": "Conchas",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512506,
    "nome": "Coroados",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512605,
    "nome": "Coronel Macedo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512704,
    "nome": "Corumbataí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512803,
    "nome": "Cosmópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3512902,
    "nome": "Cosmorama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513108,
    "nome": "Cravinhos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513207,
    "nome": "Cristais Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513306,
    "nome": "Cruzália",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513603,
    "nome": "Cunha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513702,
    "nome": "Descalvado",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513850,
    "nome": "Dirce Reis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3513900,
    "nome": "Divinolândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514007,
    "nome": "Dobrada",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514106,
    "nome": "Dois Córregos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514205,
    "nome": "Dolcinópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514304,
    "nome": "Dourado",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514403,
    "nome": "Dracena",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514502,
    "nome": "Duartina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514601,
    "nome": "Dumont",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514700,
    "nome": "Echaporã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514809,
    "nome": "Eldorado",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514908,
    "nome": "Elias Fausto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514924,
    "nome": "Elisiário",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3514957,
    "nome": "Embaúba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515103,
    "nome": "Embu-Guaçu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515129,
    "nome": "Emilianópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515152,
    "nome": "Engenheiro Coelho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515186,
    "nome": "Espírito Santo do Pinhal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515194,
    "nome": "Espírito Santo do Turvo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515202,
    "nome": "Estrela d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515301,
    "nome": "Estrela do Norte",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515350,
    "nome": "Euclides da Cunha Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515400,
    "nome": "Fartura",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515509,
    "nome": "Fernandópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515608,
    "nome": "Fernando Prestes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515657,
    "nome": "Fernão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515806,
    "nome": "Flora Rica",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3515905,
    "nome": "Floreal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516002,
    "nome": "Flórida Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516101,
    "nome": "Florínea",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516309,
    "nome": "Francisco Morato",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516507,
    "nome": "Gabriel Monteiro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516606,
    "nome": "Gália",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516705,
    "nome": "Garça",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516804,
    "nome": "Gastão Vidigal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516853,
    "nome": "Gavião Peixoto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3516903,
    "nome": "General Salgado",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517000,
    "nome": "Getulina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517109,
    "nome": "Glicério",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517208,
    "nome": "Guaiçara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517307,
    "nome": "Guaimbê",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517505,
    "nome": "Guapiaçu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517604,
    "nome": "Guapiara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517703,
    "nome": "Guará",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517802,
    "nome": "Guaraçaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3517901,
    "nome": "Guaraci",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518008,
    "nome": "Guarani d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518107,
    "nome": "Guarantã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518206,
    "nome": "Guararapes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518305,
    "nome": "Guararema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518503,
    "nome": "Guareí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518602,
    "nome": "Guariba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518859,
    "nome": "Guatapará",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3518909,
    "nome": "Guzolândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519006,
    "nome": "Herculândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519055,
    "nome": "Holambra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519105,
    "nome": "Iacanga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519204,
    "nome": "Iacri",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519253,
    "nome": "Iaras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519303,
    "nome": "Ibaté",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519402,
    "nome": "Ibirá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519501,
    "nome": "Ibirarema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519600,
    "nome": "Ibitinga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519709,
    "nome": "Ibiúna",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519808,
    "nome": "Icém",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3519907,
    "nome": "Iepê",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520004,
    "nome": "Igaraçu do Tietê",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520103,
    "nome": "Igarapava",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520202,
    "nome": "Igaratá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520301,
    "nome": "Iguape",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520426,
    "nome": "Ilha Comprida",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520442,
    "nome": "Ilha Solteira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520608,
    "nome": "Indiana",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520707,
    "nome": "Indiaporã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520806,
    "nome": "Inúbia Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3520905,
    "nome": "Ipaussu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521002,
    "nome": "Iperó",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521101,
    "nome": "Ipeúna",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521150,
    "nome": "Ipiguá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521200,
    "nome": "Iporanga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521309,
    "nome": "Ipuã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521408,
    "nome": "Iracemápolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521507,
    "nome": "Irapuã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521606,
    "nome": "Irapuru",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521705,
    "nome": "Itaberá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521804,
    "nome": "Itaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3521903,
    "nome": "Itajobi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522000,
    "nome": "Itaju",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522109,
    "nome": "Itanhaém",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522158,
    "nome": "Itaoca",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522653,
    "nome": "Itapirapuã Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522703,
    "nome": "Itápolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522802,
    "nome": "Itaporanga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3522901,
    "nome": "Itapuí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523008,
    "nome": "Itapura",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523206,
    "nome": "Itararé",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523305,
    "nome": "Itariri",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523503,
    "nome": "Itatinga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523602,
    "nome": "Itirapina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523701,
    "nome": "Itirapuã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3523800,
    "nome": "Itobi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3524105,
    "nome": "Ituverava",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3524204,
    "nome": "Jaborandi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3524501,
    "nome": "Jaci",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3524600,
    "nome": "Jacupiranga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3524808,
    "nome": "Jales",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3524907,
    "nome": "Jambeiro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525102,
    "nome": "Jardinópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525409,
    "nome": "Jeriquara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525508,
    "nome": "Joanópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525607,
    "nome": "João Ramalho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525706,
    "nome": "José Bonifácio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525805,
    "nome": "Júlio Mesquita",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3525854,
    "nome": "Jumirim",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526001,
    "nome": "Junqueirópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526100,
    "nome": "Juquiá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526209,
    "nome": "Juquitiba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526308,
    "nome": "Lagoinha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526407,
    "nome": "Laranjal Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526506,
    "nome": "Lavínia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3526605,
    "nome": "Lavrinhas",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527009,
    "nome": "Lindóia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527256,
    "nome": "Lourdes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527405,
    "nome": "Lucélia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527504,
    "nome": "Lucianópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527603,
    "nome": "Luís Antônio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527702,
    "nome": "Luiziânia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527801,
    "nome": "Lupércio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3527900,
    "nome": "Lutécia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528007,
    "nome": "Macatuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528106,
    "nome": "Macaubal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528205,
    "nome": "Macedônia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528304,
    "nome": "Magda",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528403,
    "nome": "Mairinque",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528502,
    "nome": "Mairiporã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528601,
    "nome": "Manduri",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528700,
    "nome": "Marabá Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528809,
    "nome": "Maracaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528858,
    "nome": "Marapoama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3528908,
    "nome": "Mariápolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529104,
    "nome": "Marinópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529203,
    "nome": "Martinópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529500,
    "nome": "Mendonça",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529609,
    "nome": "Meridiano",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529658,
    "nome": "Mesópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529708,
    "nome": "Miguelópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529807,
    "nome": "Mineiros do Tietê",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3529906,
    "nome": "Miracatu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3530003,
    "nome": "Mira Estrela",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3530102,
    "nome": "Mirandópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3530201,
    "nome": "Mirante do Paranapanema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3530409,
    "nome": "Mirassolândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3530904,
    "nome": "Mombuca",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531001,
    "nome": "Monções",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531100,
    "nome": "Mongaguá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531209,
    "nome": "Monte Alegre do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531407,
    "nome": "Monte Aprazível",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531506,
    "nome": "Monte Azul Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531605,
    "nome": "Monte Castelo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531704,
    "nome": "Monteiro Lobato",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3531902,
    "nome": "Morro Agudo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532009,
    "nome": "Morungaba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532058,
    "nome": "Motuca",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532108,
    "nome": "Murutinga do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532157,
    "nome": "Nantes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532207,
    "nome": "Narandiba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532306,
    "nome": "Natividade da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532405,
    "nome": "Nazaré Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532504,
    "nome": "Neves Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532603,
    "nome": "Nhandeara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532702,
    "nome": "Nipoã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532801,
    "nome": "Nova Aliança",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532827,
    "nome": "Nova Campina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532843,
    "nome": "Nova Canaã Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532868,
    "nome": "Nova Castilho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3532900,
    "nome": "Nova Europa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533007,
    "nome": "Nova Granada",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533106,
    "nome": "Nova Guataporanga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533205,
    "nome": "Nova Independência",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533254,
    "nome": "Novais",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533304,
    "nome": "Nova Luzitânia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533502,
    "nome": "Novo Horizonte",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533601,
    "nome": "Nuporanga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533700,
    "nome": "Ocauçu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3533809,
    "nome": "Óleo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534005,
    "nome": "Onda Verde",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534104,
    "nome": "Oriente",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534203,
    "nome": "Orindiúva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534500,
    "nome": "Oscar Bressane",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534609,
    "nome": "Osvaldo Cruz",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534757,
    "nome": "Ouroeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534807,
    "nome": "Ouro Verde",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3534906,
    "nome": "Pacaembu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535002,
    "nome": "Palestina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535101,
    "nome": "Palmares Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535200,
    "nome": "Palmeira d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535309,
    "nome": "Palmital",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535408,
    "nome": "Panorama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535507,
    "nome": "Paraguaçu Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535606,
    "nome": "Paraibuna",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535705,
    "nome": "Paraíso",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535804,
    "nome": "Paranapanema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3535903,
    "nome": "Paranapuã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536000,
    "nome": "Parapuã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536109,
    "nome": "Pardinho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536208,
    "nome": "Pariquera-Açu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536257,
    "nome": "Parisi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536307,
    "nome": "Patrocínio Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536406,
    "nome": "Paulicéia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536570,
    "nome": "Paulistânia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536604,
    "nome": "Paulo de Faria",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536802,
    "nome": "Pedra Bela",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3536901,
    "nome": "Pedranópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537008,
    "nome": "Pedregulho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537107,
    "nome": "Pedreira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537156,
    "nome": "Pedrinhas Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537206,
    "nome": "Pedro de Toledo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537305,
    "nome": "Penápolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537404,
    "nome": "Pereira Barreto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537503,
    "nome": "Pereiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537602,
    "nome": "Peruíbe",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537701,
    "nome": "Piacatu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537800,
    "nome": "Piedade",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3537909,
    "nome": "Pilar do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538105,
    "nome": "Pindorama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538204,
    "nome": "Pinhalzinho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538303,
    "nome": "Piquerobi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538501,
    "nome": "Piquete",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538600,
    "nome": "Piracaia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538808,
    "nome": "Piraju",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3538907,
    "nome": "Pirajuí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539004,
    "nome": "Pirangi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539103,
    "nome": "Pirapora do Bom Jesus",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539202,
    "nome": "Pirapozinho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539400,
    "nome": "Piratininga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539509,
    "nome": "Pitangueiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539608,
    "nome": "Planalto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539707,
    "nome": "Platina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3539905,
    "nome": "Poloni",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540002,
    "nome": "Pompéia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540101,
    "nome": "Pongaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540200,
    "nome": "Pontal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540259,
    "nome": "Pontalinda",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540309,
    "nome": "Pontes Gestal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540408,
    "nome": "Populina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540507,
    "nome": "Porangaba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540705,
    "nome": "Porto Ferreira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540754,
    "nome": "Potim",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540804,
    "nome": "Potirendaba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540853,
    "nome": "Pracinha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3540903,
    "nome": "Pradópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541059,
    "nome": "Pratânia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541109,
    "nome": "Presidente Alves",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541208,
    "nome": "Presidente Bernardes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541307,
    "nome": "Presidente Epitácio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541505,
    "nome": "Presidente Venceslau",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541653,
    "nome": "Quadra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541703,
    "nome": "Quatá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541802,
    "nome": "Queiroz",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3541901,
    "nome": "Queluz",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542008,
    "nome": "Quintana",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542107,
    "nome": "Rafard",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542206,
    "nome": "Rancharia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542305,
    "nome": "Redenção da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542404,
    "nome": "Regente Feijó",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542503,
    "nome": "Reginópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542602,
    "nome": "Registro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542701,
    "nome": "Restinga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542800,
    "nome": "Ribeira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3542909,
    "nome": "Ribeirão Bonito",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543006,
    "nome": "Ribeirão Branco",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543105,
    "nome": "Ribeirão Corrente",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543204,
    "nome": "Ribeirão do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543238,
    "nome": "Ribeirão dos Índios",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543253,
    "nome": "Ribeirão Grande",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543501,
    "nome": "Riversul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543600,
    "nome": "Rifaina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543709,
    "nome": "Rincão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3543808,
    "nome": "Rinópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544004,
    "nome": "Rio das Pedras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544103,
    "nome": "Rio Grande da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544202,
    "nome": "Riolândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544251,
    "nome": "Rosana",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544301,
    "nome": "Roseira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544400,
    "nome": "Rubiácea",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544509,
    "nome": "Rubinéia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544608,
    "nome": "Sabino",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544707,
    "nome": "Sagres",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544806,
    "nome": "Sales",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3544905,
    "nome": "Sales Oliveira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545001,
    "nome": "Salesópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545100,
    "nome": "Salmourão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545159,
    "nome": "Saltinho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545308,
    "nome": "Salto de Pirapora",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545407,
    "nome": "Salto Grande",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545506,
    "nome": "Sandovalina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545605,
    "nome": "Santa Adélia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3545704,
    "nome": "Santa Albertina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546009,
    "nome": "Santa Branca",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546108,
    "nome": "Santa Clara d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546207,
    "nome": "Santa Cruz da Conceição",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546256,
    "nome": "Santa Cruz da Esperança",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546306,
    "nome": "Santa Cruz das Palmeiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546504,
    "nome": "Santa Ernestina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546603,
    "nome": "Santa Fé do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546801,
    "nome": "Santa Isabel",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3546900,
    "nome": "Santa Lúcia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547007,
    "nome": "Santa Maria da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547106,
    "nome": "Santa Mercedes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547205,
    "nome": "Santana da Ponte Pensa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547403,
    "nome": "Santa Rita d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547502,
    "nome": "Santa Rita do Passa Quatro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547601,
    "nome": "Santa Rosa de Viterbo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547650,
    "nome": "Santa Salete",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547700,
    "nome": "Santo Anastácio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3547908,
    "nome": "Santo Antônio da Alegria",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548005,
    "nome": "Santo Antônio de Posse",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548054,
    "nome": "Santo Antônio do Aracanguá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548104,
    "nome": "Santo Antônio do Jardim",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548203,
    "nome": "Santo Antônio do Pinhal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548302,
    "nome": "Santo Expedito",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548401,
    "nome": "Santópolis do Aguapeí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3548609,
    "nome": "São Bento do Sapucaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549003,
    "nome": "São Francisco",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549201,
    "nome": "São João das Duas Pontes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549250,
    "nome": "São João de Iracema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549300,
    "nome": "São João do Pau d'Alho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549409,
    "nome": "São Joaquim da Barra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549508,
    "nome": "São José da Bela Vista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549607,
    "nome": "São José do Barreiro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549706,
    "nome": "São José do Rio Pardo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3549953,
    "nome": "São Lourenço da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550001,
    "nome": "São Luiz do Paraitinga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550100,
    "nome": "São Manuel",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550209,
    "nome": "São Miguel Arcanjo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550407,
    "nome": "São Pedro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550506,
    "nome": "São Pedro do Turvo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550803,
    "nome": "São Sebastião da Grama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3550902,
    "nome": "São Simão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551108,
    "nome": "Sarapuí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551207,
    "nome": "Sarutaiá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551306,
    "nome": "Sebastianópolis do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551405,
    "nome": "Serra Azul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551504,
    "nome": "Serrana",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551603,
    "nome": "Serra Negra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551801,
    "nome": "Sete Barras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3551900,
    "nome": "Severínia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552007,
    "nome": "Silveiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552106,
    "nome": "Socorro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552304,
    "nome": "Sud Mennucci",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552551,
    "nome": "Suzanápolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552601,
    "nome": "Tabapuã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552700,
    "nome": "Tabatinga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3552908,
    "nome": "Taciba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553005,
    "nome": "Taguaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553104,
    "nome": "Taiaçu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553203,
    "nome": "Taiúva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553302,
    "nome": "Tambaú",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553401,
    "nome": "Tanabi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553500,
    "nome": "Tapiraí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553609,
    "nome": "Tapiratiba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553658,
    "nome": "Taquaral",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553708,
    "nome": "Taquaritinga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553807,
    "nome": "Taquarituba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553856,
    "nome": "Taquarivaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553906,
    "nome": "Tarabai",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3553955,
    "nome": "Tarumã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554201,
    "nome": "Tejupá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554300,
    "nome": "Teodoro Sampaio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554409,
    "nome": "Terra Roxa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554508,
    "nome": "Tietê",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554607,
    "nome": "Timburi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554656,
    "nome": "Torre de Pedra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554706,
    "nome": "Torrinha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554755,
    "nome": "Trabiju",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554805,
    "nome": "Tremembé",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554904,
    "nome": "Três Fronteiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3554953,
    "nome": "Tuiuti",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555000,
    "nome": "Tupã",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555109,
    "nome": "Tupi Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555208,
    "nome": "Turiúba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555307,
    "nome": "Turmalina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555356,
    "nome": "Ubarana",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555505,
    "nome": "Ubirajara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555604,
    "nome": "Uchoa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555703,
    "nome": "União Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555802,
    "nome": "Urânia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3555901,
    "nome": "Uru",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556008,
    "nome": "Urupês",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556107,
    "nome": "Valentim Gentil",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556305,
    "nome": "Valparaíso",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556354,
    "nome": "Vargem",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556404,
    "nome": "Vargem Grande do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556602,
    "nome": "Vera Cruz",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556800,
    "nome": "Viradouro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556909,
    "nome": "Vista Alegre do Alto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3556958,
    "nome": "Vitória Brasil",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3557154,
    "nome": "Zacarias",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3557204,
    "nome": "Chavantes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 3557303,
    "nome": "Estiva Gerbi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100103,
    "nome": "Abatiá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100202,
    "nome": "Adrianópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100301,
    "nome": "Agudos do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100400,
    "nome": "Almirante Tamandaré",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100459,
    "nome": "Altamira do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100509,
    "nome": "Altônia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100608,
    "nome": "Alto Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100707,
    "nome": "Alto Piquiri",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100806,
    "nome": "Alvorada do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4100905,
    "nome": "Amaporã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101002,
    "nome": "Ampére",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101051,
    "nome": "Anahy",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101101,
    "nome": "Andirá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101150,
    "nome": "Ângulo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101200,
    "nome": "Antonina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101309,
    "nome": "Antônio Olinto",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101606,
    "nome": "Arapoti",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101655,
    "nome": "Arapuã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101705,
    "nome": "Araruna",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101853,
    "nome": "Ariranha do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4101903,
    "nome": "Assaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102000,
    "nome": "Assis Chateaubriand",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102109,
    "nome": "Astorga",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102208,
    "nome": "Atalaia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102307,
    "nome": "Balsa Nova",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102406,
    "nome": "Bandeirantes",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102505,
    "nome": "Barbosa Ferraz",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102604,
    "nome": "Barracão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102703,
    "nome": "Barra do Jacaré",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102752,
    "nome": "Bela Vista da Caroba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102802,
    "nome": "Bela Vista do Paraíso",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4102901,
    "nome": "Bituruna",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103008,
    "nome": "Boa Esperança",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103024,
    "nome": "Boa Esperança do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103040,
    "nome": "Boa Ventura de São Roque",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103057,
    "nome": "Boa Vista da Aparecida",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103107,
    "nome": "Bocaiúva do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103156,
    "nome": "Bom Jesus do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103206,
    "nome": "Bom Sucesso",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103222,
    "nome": "Bom Sucesso do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103305,
    "nome": "Borrazópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103354,
    "nome": "Braganey",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103370,
    "nome": "Brasilândia do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103404,
    "nome": "Cafeara",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103453,
    "nome": "Cafelândia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103479,
    "nome": "Cafezal do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103503,
    "nome": "Califórnia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103602,
    "nome": "Cambará",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103800,
    "nome": "Cambira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103909,
    "nome": "Campina da Lagoa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4103958,
    "nome": "Campina do Simão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104006,
    "nome": "Campina Grande do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104055,
    "nome": "Campo Bonito",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104105,
    "nome": "Campo do Tenente",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104253,
    "nome": "Campo Magro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104402,
    "nome": "Cândido de Abreu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104428,
    "nome": "Candói",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104451,
    "nome": "Cantagalo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104501,
    "nome": "Capanema",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104600,
    "nome": "Capitão Leônidas Marques",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104659,
    "nome": "Carambeí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4104709,
    "nome": "Carlópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105003,
    "nome": "Catanduvas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105102,
    "nome": "Centenário do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105201,
    "nome": "Cerro Azul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105300,
    "nome": "Céu Azul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105409,
    "nome": "Chopinzinho",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105607,
    "nome": "Cidade Gaúcha",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105706,
    "nome": "Clevelândia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4105904,
    "nome": "Colorado",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106001,
    "nome": "Congonhinhas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106100,
    "nome": "Conselheiro Mairinck",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106209,
    "nome": "Contenda",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106308,
    "nome": "Corbélia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106407,
    "nome": "Cornélio Procópio",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106456,
    "nome": "Coronel Domingos Soares",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106506,
    "nome": "Coronel Vivida",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106555,
    "nome": "Corumbataí do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106571,
    "nome": "Cruzeiro do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106605,
    "nome": "Cruzeiro do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106704,
    "nome": "Cruzeiro do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106803,
    "nome": "Cruz Machado",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4106852,
    "nome": "Cruzmaltina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107009,
    "nome": "Curiúva",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107108,
    "nome": "Diamante do Norte",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107124,
    "nome": "Diamante do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107157,
    "nome": "Diamante D'Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107207,
    "nome": "Dois Vizinhos",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107256,
    "nome": "Douradina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107306,
    "nome": "Doutor Camargo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107405,
    "nome": "Enéas Marques",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107504,
    "nome": "Engenheiro Beltrão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107520,
    "nome": "Esperança Nova",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107538,
    "nome": "Entre Rios do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107546,
    "nome": "Espigão Alto do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107553,
    "nome": "Farol",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107603,
    "nome": "Faxinal",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107702,
    "nome": "Fênix",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107736,
    "nome": "Fernandes Pinheiro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107751,
    "nome": "Figueira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107801,
    "nome": "Floraí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107850,
    "nome": "Flor da Serra do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4107900,
    "nome": "Floresta",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108007,
    "nome": "Florestópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108106,
    "nome": "Flórida",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108205,
    "nome": "Formosa do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108320,
    "nome": "Francisco Alves",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108452,
    "nome": "Foz do Jordão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108502,
    "nome": "General Carneiro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108551,
    "nome": "Godoy Moreira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108601,
    "nome": "Goioerê",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108650,
    "nome": "Goioxim",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108700,
    "nome": "Grandes Rios",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108809,
    "nome": "Guaíra",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108908,
    "nome": "Guairaçá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4108957,
    "nome": "Guamiranga",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109005,
    "nome": "Guapirama",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109104,
    "nome": "Guaporema",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109203,
    "nome": "Guaraci",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109302,
    "nome": "Guaraniaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109500,
    "nome": "Guaraqueçaba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109609,
    "nome": "Guaratuba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109658,
    "nome": "Honório Serpa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109708,
    "nome": "Ibaiti",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109757,
    "nome": "Ibema",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4109906,
    "nome": "Icaraíma",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110003,
    "nome": "Iguaraçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110052,
    "nome": "Iguatu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110078,
    "nome": "Imbaú",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110102,
    "nome": "Imbituva",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110201,
    "nome": "Inácio Martins",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110300,
    "nome": "Inajá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110409,
    "nome": "Indianópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110508,
    "nome": "Ipiranga",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110607,
    "nome": "Iporã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110656,
    "nome": "Iracema do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110706,
    "nome": "Irati",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110805,
    "nome": "Iretama",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110904,
    "nome": "Itaguajé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4110953,
    "nome": "Itaipulândia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111001,
    "nome": "Itambaracá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111100,
    "nome": "Itambé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111209,
    "nome": "Itapejara d'Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111258,
    "nome": "Itaperuçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111308,
    "nome": "Itaúna do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111407,
    "nome": "Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111506,
    "nome": "Ivaiporã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111555,
    "nome": "Ivaté",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111605,
    "nome": "Ivatuba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111704,
    "nome": "Jaboti",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111803,
    "nome": "Jacarezinho",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4111902,
    "nome": "Jaguapitã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112009,
    "nome": "Jaguariaíva",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112108,
    "nome": "Jandaia do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112207,
    "nome": "Janiópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112306,
    "nome": "Japira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112405,
    "nome": "Japurá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112504,
    "nome": "Jardim Alegre",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112603,
    "nome": "Jardim Olinda",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112702,
    "nome": "Jataizinho",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112751,
    "nome": "Jesuítas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112801,
    "nome": "Joaquim Távora",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112900,
    "nome": "Jundiaí do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4112959,
    "nome": "Juranda",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113007,
    "nome": "Jussara",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113106,
    "nome": "Kaloré",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113205,
    "nome": "Lapa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113254,
    "nome": "Laranjal",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113304,
    "nome": "Laranjeiras do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113403,
    "nome": "Leópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113429,
    "nome": "Lidianópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113452,
    "nome": "Lindoeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113502,
    "nome": "Loanda",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113601,
    "nome": "Lobato",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113734,
    "nome": "Luiziana",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113759,
    "nome": "Lunardelli",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113809,
    "nome": "Lupionópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4113908,
    "nome": "Mallet",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114005,
    "nome": "Mamborê",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114104,
    "nome": "Mandaguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114203,
    "nome": "Mandaguari",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114302,
    "nome": "Mandirituba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114351,
    "nome": "Manfrinópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114401,
    "nome": "Mangueirinha",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114500,
    "nome": "Manoel Ribas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114708,
    "nome": "Maria Helena",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114807,
    "nome": "Marialva",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4114906,
    "nome": "Marilândia do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115002,
    "nome": "Marilena",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115101,
    "nome": "Mariluz",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115309,
    "nome": "Mariópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115358,
    "nome": "Maripá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115408,
    "nome": "Marmeleiro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115457,
    "nome": "Marquinho",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115507,
    "nome": "Marumbi",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115606,
    "nome": "Matelândia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115705,
    "nome": "Matinhos",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115739,
    "nome": "Mato Rico",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115754,
    "nome": "Mauá da Serra",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115804,
    "nome": "Medianeira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115853,
    "nome": "Mercedes",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4115903,
    "nome": "Mirador",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116000,
    "nome": "Miraselva",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116059,
    "nome": "Missal",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116109,
    "nome": "Moreira Sales",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116208,
    "nome": "Morretes",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116307,
    "nome": "Munhoz de Melo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116406,
    "nome": "Nossa Senhora das Graças",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116505,
    "nome": "Nova Aliança do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116604,
    "nome": "Nova América da Colina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116703,
    "nome": "Nova Aurora",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116802,
    "nome": "Nova Cantu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116901,
    "nome": "Nova Esperança",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4116950,
    "nome": "Nova Esperança do Sudoeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117008,
    "nome": "Nova Fátima",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117057,
    "nome": "Nova Laranjeiras",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117107,
    "nome": "Nova Londrina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117206,
    "nome": "Nova Olímpia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117214,
    "nome": "Nova Santa Bárbara",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117222,
    "nome": "Nova Santa Rosa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117255,
    "nome": "Nova Prata do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117271,
    "nome": "Nova Tebas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117297,
    "nome": "Novo Itacolomi",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117404,
    "nome": "Ourizona",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117453,
    "nome": "Ouro Verde do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117503,
    "nome": "Paiçandu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117602,
    "nome": "Palmas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117701,
    "nome": "Palmeira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4117800,
    "nome": "Palmital",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118006,
    "nome": "Paraíso do Norte",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118105,
    "nome": "Paranacity",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118303,
    "nome": "Paranapoema",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118451,
    "nome": "Pato Bragado",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118600,
    "nome": "Paula Freitas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118709,
    "nome": "Paulo Frontin",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118808,
    "nome": "Peabiru",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118857,
    "nome": "Perobal",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4118907,
    "nome": "Pérola",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119004,
    "nome": "Pérola d'Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119103,
    "nome": "Piên",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119202,
    "nome": "Pinhalão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119251,
    "nome": "Pinhal de São Bento",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119301,
    "nome": "Pinhão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119400,
    "nome": "Piraí do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119509,
    "nome": "Piraquara",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119608,
    "nome": "Pitanga",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119657,
    "nome": "Pitangueiras",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119707,
    "nome": "Planaltina do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119806,
    "nome": "Planalto",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4119954,
    "nome": "Pontal do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120002,
    "nome": "Porecatu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120101,
    "nome": "Porto Amazonas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120150,
    "nome": "Porto Barreiro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120200,
    "nome": "Porto Rico",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120309,
    "nome": "Porto Vitória",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120333,
    "nome": "Prado Ferreira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120358,
    "nome": "Pranchita",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120408,
    "nome": "Presidente Castelo Branco",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120507,
    "nome": "Primeiro de Maio",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120606,
    "nome": "Prudentópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120655,
    "nome": "Quarto Centenário",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120705,
    "nome": "Quatiguá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120804,
    "nome": "Quatro Barras",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120853,
    "nome": "Quatro Pontes",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4120903,
    "nome": "Quedas do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121000,
    "nome": "Querência do Norte",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121109,
    "nome": "Quinta do Sol",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121208,
    "nome": "Quitandinha",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121257,
    "nome": "Ramilândia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121307,
    "nome": "Rancho Alegre",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121356,
    "nome": "Rancho Alegre D'Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121406,
    "nome": "Realeza",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121505,
    "nome": "Rebouças",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121604,
    "nome": "Renascença",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121703,
    "nome": "Reserva",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121752,
    "nome": "Reserva do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121802,
    "nome": "Ribeirão Claro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4121901,
    "nome": "Ribeirão do Pinhal",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122008,
    "nome": "Rio Azul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122107,
    "nome": "Rio Bom",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122156,
    "nome": "Rio Bonito do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122172,
    "nome": "Rio Branco do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122206,
    "nome": "Rio Branco do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122305,
    "nome": "Rio Negro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122503,
    "nome": "Roncador",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122602,
    "nome": "Rondon",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122651,
    "nome": "Rosário do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122701,
    "nome": "Sabáudia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122800,
    "nome": "Salgado Filho",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4122909,
    "nome": "Salto do Itararé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123006,
    "nome": "Salto do Lontra",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123105,
    "nome": "Santa Amélia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123204,
    "nome": "Santa Cecília do Pavão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123303,
    "nome": "Santa Cruz de Monte Castelo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123402,
    "nome": "Santa Fé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123501,
    "nome": "Santa Helena",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123600,
    "nome": "Santa Inês",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123709,
    "nome": "Santa Isabel do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123808,
    "nome": "Santa Izabel do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123824,
    "nome": "Santa Lúcia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123857,
    "nome": "Santa Maria do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123907,
    "nome": "Santa Mariana",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4123956,
    "nome": "Santa Mônica",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124004,
    "nome": "Santana do Itararé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124020,
    "nome": "Santa Tereza do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124053,
    "nome": "Santa Terezinha de Itaipu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124103,
    "nome": "Santo Antônio da Platina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124202,
    "nome": "Santo Antônio do Caiuá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124301,
    "nome": "Santo Antônio do Paraíso",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124400,
    "nome": "Santo Antônio do Sudoeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124509,
    "nome": "Santo Inácio",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124608,
    "nome": "São Carlos do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124707,
    "nome": "São Jerônimo da Serra",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124806,
    "nome": "São João",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4124905,
    "nome": "São João do Caiuá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125001,
    "nome": "São João do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125100,
    "nome": "São João do Triunfo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125209,
    "nome": "São Jorge d'Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125308,
    "nome": "São Jorge do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125357,
    "nome": "São Jorge do Patrocínio",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125407,
    "nome": "São José da Boa Vista",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125456,
    "nome": "São José das Palmeiras",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125555,
    "nome": "São Manoel do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125605,
    "nome": "São Mateus do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125704,
    "nome": "São Miguel do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125753,
    "nome": "São Pedro do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125803,
    "nome": "São Pedro do Ivaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4125902,
    "nome": "São Pedro do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126009,
    "nome": "São Sebastião da Amoreira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126108,
    "nome": "São Tomé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126207,
    "nome": "Sapopema",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126256,
    "nome": "Sarandi",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126272,
    "nome": "Saudade do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126306,
    "nome": "Sengés",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126355,
    "nome": "Serranópolis do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126405,
    "nome": "Sertaneja",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126504,
    "nome": "Sertanópolis",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126603,
    "nome": "Siqueira Campos",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126652,
    "nome": "Sulina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126678,
    "nome": "Tamarana",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126702,
    "nome": "Tamboara",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126801,
    "nome": "Tapejara",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4126900,
    "nome": "Tapira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127007,
    "nome": "Teixeira Soares",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127205,
    "nome": "Terra Boa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127304,
    "nome": "Terra Rica",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127403,
    "nome": "Terra Roxa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127502,
    "nome": "Tibagi",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127601,
    "nome": "Tijucas do Sul",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127809,
    "nome": "Tomazina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127858,
    "nome": "Três Barras do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127882,
    "nome": "Tunas do Paraná",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127908,
    "nome": "Tuneiras do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127957,
    "nome": "Tupãssi",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4127965,
    "nome": "Turvo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128005,
    "nome": "Ubiratã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128203,
    "nome": "União da Vitória",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128302,
    "nome": "Uniflor",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128401,
    "nome": "Uraí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128500,
    "nome": "Wenceslau Braz",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128534,
    "nome": "Ventania",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128559,
    "nome": "Vera Cruz do Oeste",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128609,
    "nome": "Verê",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128625,
    "nome": "Alto Paraíso",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128633,
    "nome": "Doutor Ulysses",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128658,
    "nome": "Virmond",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128708,
    "nome": "Vitorino",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4128807,
    "nome": "Xambrê",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200051,
    "nome": "Abdon Batista",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200101,
    "nome": "Abelardo Luz",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200200,
    "nome": "Agrolândia",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200309,
    "nome": "Agronômica",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200408,
    "nome": "Água Doce",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200507,
    "nome": "Águas de Chapecó",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200556,
    "nome": "Águas Frias",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200606,
    "nome": "Águas Mornas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200705,
    "nome": "Alfredo Wagner",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200754,
    "nome": "Alto Bela Vista",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200804,
    "nome": "Anchieta",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4200903,
    "nome": "Angelina",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201000,
    "nome": "Anita Garibaldi",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201109,
    "nome": "Anitápolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201208,
    "nome": "Antônio Carlos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201257,
    "nome": "Apiúna",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201273,
    "nome": "Arabutã",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201406,
    "nome": "Araranguá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201505,
    "nome": "Armazém",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201604,
    "nome": "Arroio Trinta",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201653,
    "nome": "Arvoredo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201703,
    "nome": "Ascurra",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201802,
    "nome": "Atalanta",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201901,
    "nome": "Aurora",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4201950,
    "nome": "Balneário Arroio do Silva",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202057,
    "nome": "Balneário Barra do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202073,
    "nome": "Balneário Gaivota",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202081,
    "nome": "Bandeirante",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202099,
    "nome": "Barra Bonita",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202107,
    "nome": "Barra Velha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202131,
    "nome": "Bela Vista do Toldo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202156,
    "nome": "Belmonte",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202206,
    "nome": "Benedito Novo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202438,
    "nome": "Bocaina do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202453,
    "nome": "Bombinhas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202503,
    "nome": "Bom Jardim da Serra",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202537,
    "nome": "Bom Jesus",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202578,
    "nome": "Bom Jesus do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202602,
    "nome": "Bom Retiro",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202701,
    "nome": "Botuverá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202800,
    "nome": "Braço do Norte",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202859,
    "nome": "Braço do Trombudo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4202875,
    "nome": "Brunópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203105,
    "nome": "Caibi",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203154,
    "nome": "Calmon",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203204,
    "nome": "Camboriú",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203253,
    "nome": "Capão Alto",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203303,
    "nome": "Campo Alegre",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203402,
    "nome": "Campo Belo do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203501,
    "nome": "Campo Erê",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203709,
    "nome": "Canelinha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203808,
    "nome": "Canoinhas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203907,
    "nome": "Capinzal",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4203956,
    "nome": "Capivari de Baixo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204004,
    "nome": "Catanduvas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204103,
    "nome": "Caxambu do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204152,
    "nome": "Celso Ramos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204178,
    "nome": "Cerro Negro",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204194,
    "nome": "Chapadão do Lageado",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204251,
    "nome": "Cocal do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204350,
    "nome": "Cordilheira Alta",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204400,
    "nome": "Coronel Freitas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204459,
    "nome": "Coronel Martins",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204509,
    "nome": "Corupá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204558,
    "nome": "Correia Pinto",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204707,
    "nome": "Cunha Porã",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204756,
    "nome": "Cunhataí",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204806,
    "nome": "Curitibanos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4204905,
    "nome": "Descanso",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205001,
    "nome": "Dionísio Cerqueira",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205100,
    "nome": "Dona Emma",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205159,
    "nome": "Doutor Pedrinho",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205175,
    "nome": "Entre Rios",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205191,
    "nome": "Ermo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205209,
    "nome": "Erval Velho",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205308,
    "nome": "Faxinal dos Guedes",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205357,
    "nome": "Flor do Sertão",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205431,
    "nome": "Formosa do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205456,
    "nome": "Forquilhinha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205506,
    "nome": "Fraiburgo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205555,
    "nome": "Frei Rogério",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205605,
    "nome": "Galvão",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205704,
    "nome": "Garopaba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4205803,
    "nome": "Garuva",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206009,
    "nome": "Governador Celso Ramos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206108,
    "nome": "Grão-Pará",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206207,
    "nome": "Gravatal",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206306,
    "nome": "Guabiruba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206405,
    "nome": "Guaraciaba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206603,
    "nome": "Guarujá do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206652,
    "nome": "Guatambú",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206702,
    "nome": "Herval d'Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206751,
    "nome": "Ibiam",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206801,
    "nome": "Ibicaré",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4206900,
    "nome": "Ibirama",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207106,
    "nome": "Ilhota",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207205,
    "nome": "Imaruí",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207403,
    "nome": "Imbuia",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207577,
    "nome": "Iomerê",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207601,
    "nome": "Ipira",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207650,
    "nome": "Iporã do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207684,
    "nome": "Ipuaçu",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207700,
    "nome": "Ipumirim",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207759,
    "nome": "Iraceminha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207809,
    "nome": "Irani",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207858,
    "nome": "Irati",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4207908,
    "nome": "Irineópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208005,
    "nome": "Itá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208104,
    "nome": "Itaiópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208401,
    "nome": "Itapiranga",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208450,
    "nome": "Itapoá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208500,
    "nome": "Ituporanga",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208609,
    "nome": "Jaborá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208708,
    "nome": "Jacinto Machado",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208807,
    "nome": "Jaguaruna",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4208955,
    "nome": "Jardinópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209003,
    "nome": "Joaçaba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209151,
    "nome": "José Boiteux",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209177,
    "nome": "Jupiá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209201,
    "nome": "Lacerdópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209409,
    "nome": "Laguna",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209458,
    "nome": "Lajeado Grande",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209508,
    "nome": "Laurentino",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209607,
    "nome": "Lauro Müller",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209706,
    "nome": "Lebon Régis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209805,
    "nome": "Leoberto Leal",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209854,
    "nome": "Lindóia do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4209904,
    "nome": "Lontras",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210001,
    "nome": "Luiz Alves",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210035,
    "nome": "Luzerna",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210050,
    "nome": "Macieira",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210209,
    "nome": "Major Gercino",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210308,
    "nome": "Major Vieira",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210407,
    "nome": "Maracajá",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210506,
    "nome": "Maravilha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210555,
    "nome": "Marema",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210605,
    "nome": "Massaranduba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210704,
    "nome": "Matos Costa",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210803,
    "nome": "Meleiro",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210852,
    "nome": "Mirim Doce",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4210902,
    "nome": "Modelo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211009,
    "nome": "Mondaí",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211058,
    "nome": "Monte Carlo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211108,
    "nome": "Monte Castelo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211207,
    "nome": "Morro da Fumaça",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211256,
    "nome": "Morro Grande",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211405,
    "nome": "Nova Erechim",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211454,
    "nome": "Nova Itaberaba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211504,
    "nome": "Nova Trento",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211603,
    "nome": "Nova Veneza",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211652,
    "nome": "Novo Horizonte",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211702,
    "nome": "Orleans",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211751,
    "nome": "Otacílio Costa",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211801,
    "nome": "Ouro",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211850,
    "nome": "Ouro Verde",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211876,
    "nome": "Paial",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4211892,
    "nome": "Painel",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212007,
    "nome": "Palma Sola",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212056,
    "nome": "Palmeira",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212106,
    "nome": "Palmitos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212205,
    "nome": "Papanduva",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212239,
    "nome": "Paraíso",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212254,
    "nome": "Passo de Torres",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212270,
    "nome": "Passos Maia",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212304,
    "nome": "Paulo Lopes",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212403,
    "nome": "Pedras Grandes",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212502,
    "nome": "Penha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212601,
    "nome": "Peritiba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212650,
    "nome": "Pescaria Brava",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212700,
    "nome": "Petrolândia",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212809,
    "nome": "Balneário Piçarras",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4212908,
    "nome": "Pinhalzinho",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213005,
    "nome": "Pinheiro Preto",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213104,
    "nome": "Piratuba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213153,
    "nome": "Planalto Alegre",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213302,
    "nome": "Ponte Alta",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213351,
    "nome": "Ponte Alta do Norte",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213401,
    "nome": "Ponte Serrada",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213500,
    "nome": "Porto Belo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213609,
    "nome": "Porto União",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213708,
    "nome": "Pouso Redondo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213807,
    "nome": "Praia Grande",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4213906,
    "nome": "Presidente Castello Branco",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214003,
    "nome": "Presidente Getúlio",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214102,
    "nome": "Presidente Nereu",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214151,
    "nome": "Princesa",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214201,
    "nome": "Quilombo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214300,
    "nome": "Rancho Queimado",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214409,
    "nome": "Rio das Antas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214508,
    "nome": "Rio do Campo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214607,
    "nome": "Rio do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214706,
    "nome": "Rio dos Cedros",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4214904,
    "nome": "Rio Fortuna",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215000,
    "nome": "Rio Negrinho",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215059,
    "nome": "Rio Rufino",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215075,
    "nome": "Riqueza",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215109,
    "nome": "Rodeio",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215208,
    "nome": "Romelândia",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215307,
    "nome": "Salete",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215356,
    "nome": "Saltinho",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215406,
    "nome": "Salto Veloso",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215455,
    "nome": "Sangão",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215505,
    "nome": "Santa Cecília",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215554,
    "nome": "Santa Helena",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215604,
    "nome": "Santa Rosa de Lima",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215653,
    "nome": "Santa Rosa do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215679,
    "nome": "Santa Terezinha",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215687,
    "nome": "Santa Terezinha do Progresso",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215695,
    "nome": "Santiago do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215703,
    "nome": "Santo Amaro da Imperatriz",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215752,
    "nome": "São Bernardino",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4215901,
    "nome": "São Bonifácio",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216008,
    "nome": "São Carlos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216057,
    "nome": "São Cristóvão do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216107,
    "nome": "São Domingos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216255,
    "nome": "São João do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216305,
    "nome": "São João Batista",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216354,
    "nome": "São João do Itaperiú",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216404,
    "nome": "São João do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216503,
    "nome": "São Joaquim",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216701,
    "nome": "São José do Cedro",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216800,
    "nome": "São José do Cerrito",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4216909,
    "nome": "São Lourenço do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217006,
    "nome": "São Ludgero",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217105,
    "nome": "São Martinho",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217154,
    "nome": "São Miguel da Boa Vista",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217204,
    "nome": "São Miguel do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217253,
    "nome": "São Pedro de Alcântara",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217303,
    "nome": "Saudades",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217402,
    "nome": "Schroeder",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217501,
    "nome": "Seara",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217550,
    "nome": "Serra Alta",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217600,
    "nome": "Siderópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217709,
    "nome": "Sombrio",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217758,
    "nome": "Sul Brasil",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217808,
    "nome": "Taió",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217907,
    "nome": "Tangará",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4217956,
    "nome": "Tigrinhos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218103,
    "nome": "Timbé do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218202,
    "nome": "Timbó",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218251,
    "nome": "Timbó Grande",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218301,
    "nome": "Três Barras",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218350,
    "nome": "Treviso",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218400,
    "nome": "Treze de Maio",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218509,
    "nome": "Treze Tílias",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218608,
    "nome": "Trombudo Central",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218756,
    "nome": "Tunápolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218806,
    "nome": "Turvo",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218855,
    "nome": "União do Oeste",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218905,
    "nome": "Urubici",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4218954,
    "nome": "Urupema",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219002,
    "nome": "Urussanga",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219101,
    "nome": "Vargeão",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219150,
    "nome": "Vargem",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219176,
    "nome": "Vargem Bonita",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219200,
    "nome": "Vidal Ramos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219358,
    "nome": "Vitor Meireles",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219408,
    "nome": "Witmarsum",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219606,
    "nome": "Xavantina",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219705,
    "nome": "Xaxim",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4219853,
    "nome": "Zortéa",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4220000,
    "nome": "Balneário Rincão",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300034,
    "nome": "Aceguá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300059,
    "nome": "Água Santa",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300109,
    "nome": "Agudo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300208,
    "nome": "Ajuricaba",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300307,
    "nome": "Alecrim",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300406,
    "nome": "Alegrete",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300455,
    "nome": "Alegria",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300471,
    "nome": "Almirante Tamandaré do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300505,
    "nome": "Alpestre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300554,
    "nome": "Alto Alegre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300570,
    "nome": "Alto Feliz",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300638,
    "nome": "Amaral Ferrador",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300646,
    "nome": "Ametista do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300661,
    "nome": "André da Rocha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300703,
    "nome": "Anta Gorda",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300802,
    "nome": "Antônio Prado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300851,
    "nome": "Arambaré",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300877,
    "nome": "Araricá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4300901,
    "nome": "Aratiba",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301008,
    "nome": "Arroio do Meio",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301057,
    "nome": "Arroio do Sal",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301073,
    "nome": "Arroio do Padre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301107,
    "nome": "Arroio dos Ratos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301206,
    "nome": "Arroio do Tigre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301305,
    "nome": "Arroio Grande",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301404,
    "nome": "Arvorezinha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301503,
    "nome": "Augusto Pestana",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301552,
    "nome": "Áurea",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301636,
    "nome": "Balneário Pinhal",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301651,
    "nome": "Barão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301701,
    "nome": "Barão de Cotegipe",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301750,
    "nome": "Barão do Triunfo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301800,
    "nome": "Barracão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301859,
    "nome": "Barra do Guarita",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301875,
    "nome": "Barra do Quaraí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301909,
    "nome": "Barra do Ribeiro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301925,
    "nome": "Barra do Rio Azul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4301958,
    "nome": "Barra Funda",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302006,
    "nome": "Barros Cassal",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302055,
    "nome": "Benjamin Constant do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302154,
    "nome": "Boa Vista das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302204,
    "nome": "Boa Vista do Buricá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302220,
    "nome": "Boa Vista do Cadeado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302238,
    "nome": "Boa Vista do Incra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302253,
    "nome": "Boa Vista do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302303,
    "nome": "Bom Jesus",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302352,
    "nome": "Bom Princípio",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302378,
    "nome": "Bom Progresso",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302402,
    "nome": "Bom Retiro do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302451,
    "nome": "Boqueirão do Leão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302501,
    "nome": "Bossoroca",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302584,
    "nome": "Bozano",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302600,
    "nome": "Braga",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302659,
    "nome": "Brochier",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302709,
    "nome": "Butiá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302808,
    "nome": "Caçapava do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4302907,
    "nome": "Cacequi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303202,
    "nome": "Cacique Doble",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303301,
    "nome": "Caibaté",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303400,
    "nome": "Caiçara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303558,
    "nome": "Camargo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303608,
    "nome": "Cambará do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303673,
    "nome": "Campestre da Serra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303707,
    "nome": "Campina das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4303806,
    "nome": "Campinas do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304002,
    "nome": "Campo Novo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304101,
    "nome": "Campos Borges",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304200,
    "nome": "Candelária",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304309,
    "nome": "Cândido Godói",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304358,
    "nome": "Candiota",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304408,
    "nome": "Canela",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304507,
    "nome": "Canguçu",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304614,
    "nome": "Canudos do Vale",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304622,
    "nome": "Capão Bonito do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304630,
    "nome": "Capão da Canoa",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304655,
    "nome": "Capão do Cipó",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304663,
    "nome": "Capão do Leão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304671,
    "nome": "Capivari do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304689,
    "nome": "Capela de Santana",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304697,
    "nome": "Capitão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304713,
    "nome": "Caraá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304853,
    "nome": "Carlos Gomes",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304903,
    "nome": "Casca",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4304952,
    "nome": "Caseiros",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305009,
    "nome": "Catuípe",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305116,
    "nome": "Centenário",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305124,
    "nome": "Cerrito",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305132,
    "nome": "Cerro Branco",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305157,
    "nome": "Cerro Grande",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305173,
    "nome": "Cerro Grande do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305207,
    "nome": "Cerro Largo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305306,
    "nome": "Chapada",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305355,
    "nome": "Charqueadas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305371,
    "nome": "Charrua",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305405,
    "nome": "Chiapetta",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305439,
    "nome": "Chuí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305447,
    "nome": "Chuvisca",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305454,
    "nome": "Cidreira",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305504,
    "nome": "Ciríaco",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305587,
    "nome": "Colinas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305603,
    "nome": "Colorado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305702,
    "nome": "Condor",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305801,
    "nome": "Constantina",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305835,
    "nome": "Coqueiro Baixo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305850,
    "nome": "Coqueiros do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305871,
    "nome": "Coronel Barros",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305900,
    "nome": "Coronel Bicaco",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305934,
    "nome": "Coronel Pilar",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305959,
    "nome": "Cotiporã",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4305975,
    "nome": "Coxilha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306007,
    "nome": "Crissiumal",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306056,
    "nome": "Cristal",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306072,
    "nome": "Cristal do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306130,
    "nome": "Cruzaltense",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306205,
    "nome": "Cruzeiro do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306304,
    "nome": "David Canabarro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306320,
    "nome": "Derrubadas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306353,
    "nome": "Dezesseis de Novembro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306379,
    "nome": "Dilermando de Aguiar",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306403,
    "nome": "Dois Irmãos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306429,
    "nome": "Dois Irmãos das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306452,
    "nome": "Dois Lajeados",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306502,
    "nome": "Dom Feliciano",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306551,
    "nome": "Dom Pedro de Alcântara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306601,
    "nome": "Dom Pedrito",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306700,
    "nome": "Dona Francisca",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306734,
    "nome": "Doutor Maurício Cardoso",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306759,
    "nome": "Doutor Ricardo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306767,
    "nome": "Eldorado do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306809,
    "nome": "Encantado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306908,
    "nome": "Encruzilhada do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306924,
    "nome": "Engenho Velho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306932,
    "nome": "Entre-Ijuís",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306957,
    "nome": "Entre Rios do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4306973,
    "nome": "Erebango",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307054,
    "nome": "Ernestina",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307104,
    "nome": "Herval",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307203,
    "nome": "Erval Grande",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307302,
    "nome": "Erval Seco",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307401,
    "nome": "Esmeralda",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307450,
    "nome": "Esperança do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307500,
    "nome": "Espumoso",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307559,
    "nome": "Estação",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307609,
    "nome": "Estância Velha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307807,
    "nome": "Estrela",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307815,
    "nome": "Estrela Velha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307831,
    "nome": "Eugênio de Castro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4307864,
    "nome": "Fagundes Varela",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308003,
    "nome": "Faxinal do Soturno",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308052,
    "nome": "Faxinalzinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308078,
    "nome": "Fazenda Vilanova",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308102,
    "nome": "Feliz",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308250,
    "nome": "Floriano Peixoto",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308300,
    "nome": "Fontoura Xavier",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308409,
    "nome": "Formigueiro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308433,
    "nome": "Forquetinha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308458,
    "nome": "Fortaleza dos Valos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308508,
    "nome": "Frederico Westphalen",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308656,
    "nome": "Garruchos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308706,
    "nome": "Gaurama",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308805,
    "nome": "General Câmara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308854,
    "nome": "Gentil",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4308904,
    "nome": "Getúlio Vargas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309001,
    "nome": "Giruá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309050,
    "nome": "Glorinha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309126,
    "nome": "Gramado dos Loureiros",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309159,
    "nome": "Gramado Xavier",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309258,
    "nome": "Guabiju",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309407,
    "nome": "Guaporé",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309506,
    "nome": "Guarani das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309555,
    "nome": "Harmonia",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309571,
    "nome": "Herveiras",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309654,
    "nome": "Hulha Negra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309704,
    "nome": "Humaitá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309753,
    "nome": "Ibarama",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309803,
    "nome": "Ibiaçá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309902,
    "nome": "Ibiraiaras",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4309951,
    "nome": "Ibirapuitã",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310009,
    "nome": "Ibirubá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310108,
    "nome": "Igrejinha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310306,
    "nome": "Ilópolis",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310330,
    "nome": "Imbé",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310363,
    "nome": "Imigrante",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310405,
    "nome": "Independência",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310413,
    "nome": "Inhacorá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310439,
    "nome": "Ipê",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310462,
    "nome": "Ipiranga do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310504,
    "nome": "Iraí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310538,
    "nome": "Itaara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310553,
    "nome": "Itacurubi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310579,
    "nome": "Itapuca",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310603,
    "nome": "Itaqui",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310652,
    "nome": "Itati",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310702,
    "nome": "Itatiba do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310751,
    "nome": "Ivorá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310801,
    "nome": "Ivoti",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310850,
    "nome": "Jaboticaba",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310876,
    "nome": "Jacuizinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4310900,
    "nome": "Jacutinga",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311007,
    "nome": "Jaguarão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311106,
    "nome": "Jaguari",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311122,
    "nome": "Jaquirana",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311130,
    "nome": "Jari",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311155,
    "nome": "Jóia",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311205,
    "nome": "Júlio de Castilhos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311239,
    "nome": "Lagoa Bonita do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311254,
    "nome": "Lagoão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311270,
    "nome": "Lagoa dos Três Cantos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311304,
    "nome": "Lagoa Vermelha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311429,
    "nome": "Lajeado do Bugre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311502,
    "nome": "Lavras do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311601,
    "nome": "Liberato Salzano",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311627,
    "nome": "Lindolfo Collor",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311643,
    "nome": "Linha Nova",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311700,
    "nome": "Machadinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311718,
    "nome": "Maçambará",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311734,
    "nome": "Mampituba",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311759,
    "nome": "Manoel Viana",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311775,
    "nome": "Maquiné",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311791,
    "nome": "Maratá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311908,
    "nome": "Marcelino Ramos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4311981,
    "nome": "Mariana Pimentel",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312005,
    "nome": "Mariano Moro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312054,
    "nome": "Marques de Souza",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312104,
    "nome": "Mata",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312138,
    "nome": "Mato Castelhano",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312153,
    "nome": "Mato Leitão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312179,
    "nome": "Mato Queimado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312203,
    "nome": "Maximiliano de Almeida",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312252,
    "nome": "Minas do Leão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312302,
    "nome": "Miraguaí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312351,
    "nome": "Montauri",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312377,
    "nome": "Monte Alegre dos Campos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312385,
    "nome": "Monte Belo do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312427,
    "nome": "Mormaço",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312443,
    "nome": "Morrinhos do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312450,
    "nome": "Morro Redondo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312476,
    "nome": "Morro Reuter",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312500,
    "nome": "Mostardas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312609,
    "nome": "Muçum",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312617,
    "nome": "Muitos Capões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312625,
    "nome": "Muliterno",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312658,
    "nome": "Não-Me-Toque",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312674,
    "nome": "Nicolau Vergueiro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312708,
    "nome": "Nonoai",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312757,
    "nome": "Nova Alvorada",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312807,
    "nome": "Nova Araçá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312906,
    "nome": "Nova Bassano",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4312955,
    "nome": "Nova Boa Vista",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313003,
    "nome": "Nova Bréscia",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313011,
    "nome": "Nova Candelária",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313037,
    "nome": "Nova Esperança do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313060,
    "nome": "Nova Hartz",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313086,
    "nome": "Nova Pádua",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313102,
    "nome": "Nova Palma",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313201,
    "nome": "Nova Petrópolis",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313300,
    "nome": "Nova Prata",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313334,
    "nome": "Nova Ramada",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313359,
    "nome": "Nova Roma do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313375,
    "nome": "Nova Santa Rita",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313391,
    "nome": "Novo Cabrais",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313425,
    "nome": "Novo Machado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313441,
    "nome": "Novo Tiradentes",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313466,
    "nome": "Novo Xingu",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313490,
    "nome": "Novo Barreiro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313508,
    "nome": "Osório",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313607,
    "nome": "Paim Filho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313656,
    "nome": "Palmares do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313706,
    "nome": "Palmeira das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313805,
    "nome": "Palmitinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4313953,
    "nome": "Pantano Grande",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314001,
    "nome": "Paraí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314027,
    "nome": "Paraíso do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314035,
    "nome": "Pareci Novo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314050,
    "nome": "Parobé",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314068,
    "nome": "Passa Sete",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314076,
    "nome": "Passo do Sobrado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314134,
    "nome": "Paulo Bento",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314159,
    "nome": "Paverama",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314175,
    "nome": "Pedras Altas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314209,
    "nome": "Pedro Osório",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314308,
    "nome": "Pejuçara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314423,
    "nome": "Picada Café",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314456,
    "nome": "Pinhal",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314464,
    "nome": "Pinhal da Serra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314472,
    "nome": "Pinhal Grande",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314498,
    "nome": "Pinheirinho do Vale",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314506,
    "nome": "Pinheiro Machado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314548,
    "nome": "Pinto Bandeira",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314555,
    "nome": "Pirapó",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314605,
    "nome": "Piratini",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314704,
    "nome": "Planalto",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314753,
    "nome": "Poço das Antas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314779,
    "nome": "Pontão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314787,
    "nome": "Ponte Preta",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4314803,
    "nome": "Portão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315008,
    "nome": "Porto Lucena",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315057,
    "nome": "Porto Mauá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315073,
    "nome": "Porto Vera Cruz",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315107,
    "nome": "Porto Xavier",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315131,
    "nome": "Pouso Novo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315149,
    "nome": "Presidente Lucena",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315156,
    "nome": "Progresso",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315172,
    "nome": "Protásio Alves",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315206,
    "nome": "Putinga",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315305,
    "nome": "Quaraí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315313,
    "nome": "Quatro Irmãos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315321,
    "nome": "Quevedos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315354,
    "nome": "Quinze de Novembro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315404,
    "nome": "Redentora",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315453,
    "nome": "Relvado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315503,
    "nome": "Restinga Sêca",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315552,
    "nome": "Rio dos Índios",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315701,
    "nome": "Rio Pardo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315750,
    "nome": "Riozinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315800,
    "nome": "Roca Sales",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315909,
    "nome": "Rodeio Bonito",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4315958,
    "nome": "Rolador",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316006,
    "nome": "Rolante",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316105,
    "nome": "Ronda Alta",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316204,
    "nome": "Rondinha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316303,
    "nome": "Roque Gonzales",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316402,
    "nome": "Rosário do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316428,
    "nome": "Sagrada Família",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316436,
    "nome": "Saldanha Marinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316451,
    "nome": "Salto do Jacuí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316477,
    "nome": "Salvador das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316501,
    "nome": "Salvador do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316600,
    "nome": "Sananduva",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316709,
    "nome": "Santa Bárbara do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316733,
    "nome": "Santa Cecília do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316758,
    "nome": "Santa Clara do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316956,
    "nome": "Santa Maria do Herval",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4316972,
    "nome": "Santa Margarida do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317004,
    "nome": "Santana da Boa Vista",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317251,
    "nome": "Santa Tereza",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317301,
    "nome": "Santa Vitória do Palmar",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317400,
    "nome": "Santiago",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317558,
    "nome": "Santo Antônio do Palma",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317608,
    "nome": "Santo Antônio da Patrulha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317707,
    "nome": "Santo Antônio das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317756,
    "nome": "Santo Antônio do Planalto",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317806,
    "nome": "Santo Augusto",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317905,
    "nome": "Santo Cristo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4317954,
    "nome": "Santo Expedito do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318002,
    "nome": "São Borja",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318051,
    "nome": "São Domingos do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318101,
    "nome": "São Francisco de Assis",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318200,
    "nome": "São Francisco de Paula",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318309,
    "nome": "São Gabriel",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318408,
    "nome": "São Jerônimo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318424,
    "nome": "São João da Urtiga",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318432,
    "nome": "São João do Polêsine",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318440,
    "nome": "São Jorge",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318457,
    "nome": "São José das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318465,
    "nome": "São José do Herval",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318481,
    "nome": "São José do Hortêncio",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318499,
    "nome": "São José do Inhacorá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318507,
    "nome": "São José do Norte",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318606,
    "nome": "São José do Ouro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318614,
    "nome": "São José do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318622,
    "nome": "São José dos Ausentes",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318804,
    "nome": "São Lourenço do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4318903,
    "nome": "São Luiz Gonzaga",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319000,
    "nome": "São Marcos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319109,
    "nome": "São Martinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319125,
    "nome": "São Martinho da Serra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319158,
    "nome": "São Miguel das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319208,
    "nome": "São Nicolau",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319307,
    "nome": "São Paulo das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319356,
    "nome": "São Pedro da Serra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319364,
    "nome": "São Pedro das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319372,
    "nome": "São Pedro do Butiá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319406,
    "nome": "São Pedro do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319505,
    "nome": "São Sebastião do Caí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319604,
    "nome": "São Sepé",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319703,
    "nome": "São Valentim",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319711,
    "nome": "São Valentim do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319737,
    "nome": "São Valério do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319752,
    "nome": "São Vendelino",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4319802,
    "nome": "São Vicente do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320107,
    "nome": "Sarandi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320206,
    "nome": "Seberi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320230,
    "nome": "Sede Nova",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320263,
    "nome": "Segredo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320305,
    "nome": "Selbach",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320321,
    "nome": "Senador Salgado Filho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320354,
    "nome": "Sentinela do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320404,
    "nome": "Serafina Corrêa",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320453,
    "nome": "Sério",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320503,
    "nome": "Sertão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320552,
    "nome": "Sertão Santana",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320578,
    "nome": "Sete de Setembro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320602,
    "nome": "Severiano de Almeida",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320651,
    "nome": "Silveira Martins",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320677,
    "nome": "Sinimbu",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320701,
    "nome": "Sobradinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320800,
    "nome": "Soledade",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320859,
    "nome": "Tabaí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4320909,
    "nome": "Tapejara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321006,
    "nome": "Tapera",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321105,
    "nome": "Tapes",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321204,
    "nome": "Taquara",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321303,
    "nome": "Taquari",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321329,
    "nome": "Taquaruçu do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321352,
    "nome": "Tavares",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321402,
    "nome": "Tenente Portela",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321436,
    "nome": "Terra de Areia",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321451,
    "nome": "Teutônia",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321469,
    "nome": "Tio Hugo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321477,
    "nome": "Tiradentes do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321493,
    "nome": "Toropi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321501,
    "nome": "Torres",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321600,
    "nome": "Tramandaí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321626,
    "nome": "Travesseiro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321634,
    "nome": "Três Arroios",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321667,
    "nome": "Três Cachoeiras",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321709,
    "nome": "Três Coroas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321808,
    "nome": "Três de Maio",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321832,
    "nome": "Três Forquilhas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321857,
    "nome": "Três Palmeiras",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321907,
    "nome": "Três Passos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4321956,
    "nome": "Trindade do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322103,
    "nome": "Tucunduva",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322152,
    "nome": "Tunas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322186,
    "nome": "Tupanci do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322202,
    "nome": "Tupanciretã",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322251,
    "nome": "Tupandi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322301,
    "nome": "Tuparendi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322327,
    "nome": "Turuçu",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322343,
    "nome": "Ubiretama",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322350,
    "nome": "União da Serra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322376,
    "nome": "Unistalda",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322525,
    "nome": "Vale Verde",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322533,
    "nome": "Vale do Sol",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322541,
    "nome": "Vale Real",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322558,
    "nome": "Vanini",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322707,
    "nome": "Vera Cruz",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322806,
    "nome": "Veranópolis",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322855,
    "nome": "Vespasiano Corrêa",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4322905,
    "nome": "Viadutos",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323101,
    "nome": "Vicente Dutra",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323200,
    "nome": "Victor Graeff",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323309,
    "nome": "Vila Flores",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323358,
    "nome": "Vila Lângaro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323408,
    "nome": "Vila Maria",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323457,
    "nome": "Vila Nova do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323507,
    "nome": "Vista Alegre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323606,
    "nome": "Vista Alegre do Prata",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323705,
    "nome": "Vista Gaúcha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323754,
    "nome": "Vitória das Missões",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323770,
    "nome": "Westfália",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 4323804,
    "nome": "Xangri-lá",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000203,
    "nome": "Água Clara",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000252,
    "nome": "Alcinópolis",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000609,
    "nome": "Amambai",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000708,
    "nome": "Anastácio",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000807,
    "nome": "Anaurilândia",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000856,
    "nome": "Angélica",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5000906,
    "nome": "Antônio João",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5001003,
    "nome": "Aparecida do Taboado",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5001102,
    "nome": "Aquidauana",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5001243,
    "nome": "Aral Moreira",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5001508,
    "nome": "Bandeirantes",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5001904,
    "nome": "Bataguassu",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002001,
    "nome": "Batayporã",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002100,
    "nome": "Bela Vista",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002159,
    "nome": "Bodoquena",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002209,
    "nome": "Bonito",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002308,
    "nome": "Brasilândia",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002407,
    "nome": "Caarapó",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002605,
    "nome": "Camapuã",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002803,
    "nome": "Caracol",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5002902,
    "nome": "Cassilândia",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003108,
    "nome": "Corguinho",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003157,
    "nome": "Coronel Sapucaia",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003306,
    "nome": "Coxim",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003454,
    "nome": "Deodápolis",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003488,
    "nome": "Dois Irmãos do Buriti",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003504,
    "nome": "Douradina",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003751,
    "nome": "Eldorado",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003801,
    "nome": "Fátima do Sul",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5003900,
    "nome": "Figueirão",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004007,
    "nome": "Glória de Dourados",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004106,
    "nome": "Guia Lopes da Laguna",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004304,
    "nome": "Iguatemi",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004403,
    "nome": "Inocência",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004502,
    "nome": "Itaporã",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004601,
    "nome": "Itaquiraí",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004700,
    "nome": "Ivinhema",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004809,
    "nome": "Japorã",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5004908,
    "nome": "Jaraguari",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005004,
    "nome": "Jardim",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005103,
    "nome": "Jateí",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005152,
    "nome": "Juti",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005202,
    "nome": "Ladário",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005251,
    "nome": "Laguna Carapã",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005608,
    "nome": "Miranda",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005681,
    "nome": "Mundo Novo",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5005806,
    "nome": "Nioaque",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006002,
    "nome": "Nova Alvorada do Sul",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006259,
    "nome": "Novo Horizonte do Sul",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006275,
    "nome": "Paraíso das Águas",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006309,
    "nome": "Paranaíba",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006358,
    "nome": "Paranhos",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006408,
    "nome": "Pedro Gomes",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5006903,
    "nome": "Porto Murtinho",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007109,
    "nome": "Ribas do Rio Pardo",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007307,
    "nome": "Rio Negro",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007406,
    "nome": "Rio Verde de Mato Grosso",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007505,
    "nome": "Rochedo",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007554,
    "nome": "Santa Rita do Pardo",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007703,
    "nome": "Sete Quedas",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007935,
    "nome": "Sonora",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007950,
    "nome": "Tacuru",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5007976,
    "nome": "Taquarussu",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5008008,
    "nome": "Terenos",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5008404,
    "nome": "Vicentina",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100102,
    "nome": "Acorizal",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100201,
    "nome": "Água Boa",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100250,
    "nome": "Alta Floresta",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100300,
    "nome": "Alto Araguaia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100359,
    "nome": "Alto Boa Vista",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100409,
    "nome": "Alto Garças",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100508,
    "nome": "Alto Paraguai",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100607,
    "nome": "Alto Taquari",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5100805,
    "nome": "Apiacás",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101001,
    "nome": "Araguaiana",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101209,
    "nome": "Araguainha",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101258,
    "nome": "Araputanga",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101308,
    "nome": "Arenápolis",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101407,
    "nome": "Aripuanã",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101605,
    "nome": "Barão de Melgaço",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101704,
    "nome": "Barra do Bugres",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101837,
    "nome": "Boa Esperança do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101852,
    "nome": "Bom Jesus do Araguaia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5101902,
    "nome": "Brasnorte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5102504,
    "nome": "Cáceres",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5102603,
    "nome": "Campinápolis",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5102694,
    "nome": "Canabrava do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5102793,
    "nome": "Carlinda",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5102850,
    "nome": "Castanheira",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103007,
    "nome": "Chapada dos Guimarães",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103056,
    "nome": "Cláudia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103106,
    "nome": "Cocalinho",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103205,
    "nome": "Colíder",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103254,
    "nome": "Colniza",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103304,
    "nome": "Comodoro",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103353,
    "nome": "Confresa",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103361,
    "nome": "Conquista D'Oeste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103379,
    "nome": "Cotriguaçu",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103437,
    "nome": "Curvelândia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103452,
    "nome": "Denise",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103601,
    "nome": "Dom Aquino",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103700,
    "nome": "Feliz Natal",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103809,
    "nome": "Figueirópolis D'Oeste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103858,
    "nome": "Gaúcha do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103908,
    "nome": "General Carneiro",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5103957,
    "nome": "Glória D'Oeste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104104,
    "nome": "Guarantã do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104203,
    "nome": "Guiratinga",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104500,
    "nome": "Indiavaí",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104526,
    "nome": "Ipiranga do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104542,
    "nome": "Itanhangá",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104559,
    "nome": "Itaúba",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104609,
    "nome": "Itiquira",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104807,
    "nome": "Jaciara",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5104906,
    "nome": "Jangada",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105002,
    "nome": "Jauru",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105101,
    "nome": "Juara",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105150,
    "nome": "Juína",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105176,
    "nome": "Juruena",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105200,
    "nome": "Juscimeira",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105234,
    "nome": "Lambari D'Oeste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105309,
    "nome": "Luciara",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105507,
    "nome": "Vila Bela da Santíssima Trindade",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105580,
    "nome": "Marcelândia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105606,
    "nome": "Matupá",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105622,
    "nome": "Mirassol d'Oeste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5105903,
    "nome": "Nobres",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106000,
    "nome": "Nortelândia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106109,
    "nome": "Nossa Senhora do Livramento",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106158,
    "nome": "Nova Bandeirantes",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106174,
    "nome": "Nova Nazaré",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106182,
    "nome": "Nova Lacerda",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106190,
    "nome": "Nova Santa Helena",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106208,
    "nome": "Nova Brasilândia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106216,
    "nome": "Nova Canaã do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106232,
    "nome": "Nova Olímpia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106257,
    "nome": "Nova Xavantina",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106265,
    "nome": "Novo Mundo",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106273,
    "nome": "Novo Horizonte do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106281,
    "nome": "Novo São Joaquim",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106299,
    "nome": "Paranaíta",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106307,
    "nome": "Paranatinga",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106315,
    "nome": "Novo Santo Antônio",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106372,
    "nome": "Pedra Preta",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106422,
    "nome": "Peixoto de Azevedo",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106455,
    "nome": "Planalto da Serra",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106505,
    "nome": "Poconé",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106653,
    "nome": "Pontal do Araguaia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106703,
    "nome": "Ponte Branca",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106752,
    "nome": "Pontes e Lacerda",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106778,
    "nome": "Porto Alegre do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106802,
    "nome": "Porto dos Gaúchos",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106828,
    "nome": "Porto Esperidião",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5106851,
    "nome": "Porto Estrela",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107008,
    "nome": "Poxoréu",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107107,
    "nome": "São José dos Quatro Marcos",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107156,
    "nome": "Reserva do Cabaçal",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107180,
    "nome": "Ribeirão Cascalheira",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107198,
    "nome": "Ribeirãozinho",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107206,
    "nome": "Rio Branco",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107248,
    "nome": "Santa Carmem",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107263,
    "nome": "Santo Afonso",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107297,
    "nome": "São José do Povo",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107305,
    "nome": "São José do Rio Claro",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107354,
    "nome": "São José do Xingu",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107404,
    "nome": "São Pedro da Cipa",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107578,
    "nome": "Rondolândia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107701,
    "nome": "Rosário Oeste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107743,
    "nome": "Santa Cruz do Xingu",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107750,
    "nome": "Salto do Céu",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107768,
    "nome": "Santa Rita do Trivelato",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107776,
    "nome": "Santa Terezinha",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107792,
    "nome": "Santo Antônio do Leste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107800,
    "nome": "Santo Antônio de Leverger",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107859,
    "nome": "São Félix do Araguaia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107883,
    "nome": "Serra Nova Dourada",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5107941,
    "nome": "Tabaporã",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108006,
    "nome": "Tapurah",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108055,
    "nome": "Terra Nova do Norte",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108105,
    "nome": "Tesouro",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108204,
    "nome": "Torixoréu",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108303,
    "nome": "União do Sul",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108352,
    "nome": "Vale de São Domingos",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108501,
    "nome": "Vera",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108600,
    "nome": "Vila Rica",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108808,
    "nome": "Nova Guarita",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108857,
    "nome": "Nova Marilândia",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108907,
    "nome": "Nova Maringá",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5108956,
    "nome": "Nova Monte Verde",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200050,
    "nome": "Abadia de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200100,
    "nome": "Abadiânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200134,
    "nome": "Acreúna",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200159,
    "nome": "Adelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200175,
    "nome": "Água Fria de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200209,
    "nome": "Água Limpa",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200308,
    "nome": "Alexânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200506,
    "nome": "Aloândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200555,
    "nome": "Alto Horizonte",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200605,
    "nome": "Alto Paraíso de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200803,
    "nome": "Alvorada do Norte",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200829,
    "nome": "Amaralina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200852,
    "nome": "Americano do Brasil",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5200902,
    "nome": "Amorinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201207,
    "nome": "Anhanguera",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201306,
    "nome": "Anicuns",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201454,
    "nome": "Aparecida do Rio Doce",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201504,
    "nome": "Aporé",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201603,
    "nome": "Araçu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201702,
    "nome": "Aragarças",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5201801,
    "nome": "Aragoiânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5202155,
    "nome": "Araguapaz",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5202353,
    "nome": "Arenópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5202502,
    "nome": "Aruanã",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5202601,
    "nome": "Aurilândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5202809,
    "nome": "Avelinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203104,
    "nome": "Baliza",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203203,
    "nome": "Barro Alto",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203302,
    "nome": "Bela Vista de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203401,
    "nome": "Bom Jardim de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203500,
    "nome": "Bom Jesus de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203559,
    "nome": "Bonfinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203575,
    "nome": "Bonópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203609,
    "nome": "Brazabrantes",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203807,
    "nome": "Britânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203906,
    "nome": "Buriti Alegre",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203939,
    "nome": "Buriti de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5203962,
    "nome": "Buritinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204003,
    "nome": "Cabeceiras",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204102,
    "nome": "Cachoeira Alta",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204201,
    "nome": "Cachoeira de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204250,
    "nome": "Cachoeira Dourada",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204300,
    "nome": "Caçu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204409,
    "nome": "Caiapônia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204557,
    "nome": "Caldazinha",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204607,
    "nome": "Campestre de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204656,
    "nome": "Campinaçu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204706,
    "nome": "Campinorte",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204805,
    "nome": "Campo Alegre de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204854,
    "nome": "Campo Limpo de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204904,
    "nome": "Campos Belos",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5204953,
    "nome": "Campos Verdes",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205000,
    "nome": "Carmo do Rio Verde",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205059,
    "nome": "Castelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205208,
    "nome": "Caturaí",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205307,
    "nome": "Cavalcante",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205406,
    "nome": "Ceres",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205455,
    "nome": "Cezarina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205497,
    "nome": "Cidade Ocidental",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205513,
    "nome": "Cocalzinho de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205521,
    "nome": "Colinas do Sul",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205703,
    "nome": "Córrego do Ouro",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205802,
    "nome": "Corumbá de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5205901,
    "nome": "Corumbaíba",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206305,
    "nome": "Cristianópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206404,
    "nome": "Crixás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206503,
    "nome": "Cromínia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206602,
    "nome": "Cumari",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206701,
    "nome": "Damianópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206800,
    "nome": "Damolândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5206909,
    "nome": "Davinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207105,
    "nome": "Diorama",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207253,
    "nome": "Doverlândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207352,
    "nome": "Edealina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207402,
    "nome": "Edéia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207501,
    "nome": "Estrela do Norte",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207535,
    "nome": "Faina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207600,
    "nome": "Fazenda Nova",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207808,
    "nome": "Firminópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5207907,
    "nome": "Flores de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208103,
    "nome": "Formoso",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208152,
    "nome": "Gameleira de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208301,
    "nome": "Divinópolis de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208400,
    "nome": "Goianápolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208509,
    "nome": "Goiandira",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208608,
    "nome": "Goianésia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208806,
    "nome": "Goianira",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5208905,
    "nome": "Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209101,
    "nome": "Goiatuba",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209150,
    "nome": "Gouvelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209200,
    "nome": "Guapó",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209291,
    "nome": "Guaraíta",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209408,
    "nome": "Guarani de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209457,
    "nome": "Guarinos",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209606,
    "nome": "Heitoraí",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209705,
    "nome": "Hidrolândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209804,
    "nome": "Hidrolina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209903,
    "nome": "Iaciara",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209937,
    "nome": "Inaciolândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5209952,
    "nome": "Indiara",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210000,
    "nome": "Inhumas",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210158,
    "nome": "Ipiranga de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210208,
    "nome": "Iporá",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210307,
    "nome": "Israelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210406,
    "nome": "Itaberaí",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210562,
    "nome": "Itaguari",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210604,
    "nome": "Itaguaru",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210802,
    "nome": "Itajá",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5210901,
    "nome": "Itapaci",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211008,
    "nome": "Itapirapuã",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211206,
    "nome": "Itapuranga",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211305,
    "nome": "Itarumã",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211404,
    "nome": "Itauçu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211602,
    "nome": "Ivolândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211701,
    "nome": "Jandaia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5211800,
    "nome": "Jaraguá",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212006,
    "nome": "Jaupaci",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212055,
    "nome": "Jesúpolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212105,
    "nome": "Joviânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212204,
    "nome": "Jussara",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212253,
    "nome": "Lagoa Santa",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212303,
    "nome": "Leopoldo de Bulhões",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212600,
    "nome": "Mairipotaba",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212709,
    "nome": "Mambaí",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212808,
    "nome": "Mara Rosa",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212907,
    "nome": "Marzagão",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5212956,
    "nome": "Matrinchã",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213004,
    "nome": "Maurilândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213053,
    "nome": "Mimoso de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213087,
    "nome": "Minaçu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213400,
    "nome": "Moiporá",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213509,
    "nome": "Monte Alegre de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213707,
    "nome": "Montes Claros de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213756,
    "nome": "Montividiu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213772,
    "nome": "Montividiu do Norte",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213806,
    "nome": "Morrinhos",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213855,
    "nome": "Morro Agudo de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5213905,
    "nome": "Mossâmedes",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214002,
    "nome": "Mozarlândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214051,
    "nome": "Mundo Novo",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214101,
    "nome": "Mutunópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214408,
    "nome": "Nazário",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214507,
    "nome": "Nerópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214606,
    "nome": "Niquelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214705,
    "nome": "Nova América",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214804,
    "nome": "Nova Aurora",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214838,
    "nome": "Nova Crixás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214861,
    "nome": "Nova Glória",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214879,
    "nome": "Nova Iguaçu de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5214903,
    "nome": "Nova Roma",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215009,
    "nome": "Nova Veneza",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215207,
    "nome": "Novo Brasil",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215231,
    "nome": "Novo Gama",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215256,
    "nome": "Novo Planalto",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215306,
    "nome": "Orizona",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215405,
    "nome": "Ouro Verde de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215504,
    "nome": "Ouvidor",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215603,
    "nome": "Padre Bernardo",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215652,
    "nome": "Palestina de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215702,
    "nome": "Palmeiras de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215801,
    "nome": "Palmelo",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5215900,
    "nome": "Palminópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5216007,
    "nome": "Panamá",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5216304,
    "nome": "Paranaiguara",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5216403,
    "nome": "Paraúna",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5216452,
    "nome": "Perolândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5216809,
    "nome": "Petrolina de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5216908,
    "nome": "Pilar de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5217104,
    "nome": "Piracanjuba",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5217203,
    "nome": "Piranhas",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5217302,
    "nome": "Pirenópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5217401,
    "nome": "Pires do Rio",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5217609,
    "nome": "Planaltina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5217708,
    "nome": "Pontalina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218003,
    "nome": "Porangatu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218052,
    "nome": "Porteirão",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218102,
    "nome": "Portelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218300,
    "nome": "Posse",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218391,
    "nome": "Professor Jamil",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218607,
    "nome": "Rialma",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218706,
    "nome": "Rianápolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218789,
    "nome": "Rio Quente",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5218904,
    "nome": "Rubiataba",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219001,
    "nome": "Sanclerlândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219100,
    "nome": "Santa Bárbara de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219209,
    "nome": "Santa Cruz de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219258,
    "nome": "Santa Fé de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219308,
    "nome": "Santa Helena de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219357,
    "nome": "Santa Isabel",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219407,
    "nome": "Santa Rita do Araguaia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219456,
    "nome": "Santa Rita do Novo Destino",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219506,
    "nome": "Santa Rosa de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219605,
    "nome": "Santa Tereza de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219704,
    "nome": "Santa Terezinha de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219712,
    "nome": "Santo Antônio da Barra",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219738,
    "nome": "Santo Antônio de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219753,
    "nome": "Santo Antônio do Descoberto",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219803,
    "nome": "São Domingos",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5219902,
    "nome": "São Francisco de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220009,
    "nome": "São João d'Aliança",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220058,
    "nome": "São João da Paraúna",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220108,
    "nome": "São Luís de Montes Belos",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220157,
    "nome": "São Luiz do Norte",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220207,
    "nome": "São Miguel do Araguaia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220264,
    "nome": "São Miguel do Passa Quatro",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220280,
    "nome": "São Patrício",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220405,
    "nome": "São Simão",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220504,
    "nome": "Serranópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220603,
    "nome": "Silvânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220686,
    "nome": "Simolândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5220702,
    "nome": "Sítio d'Abadia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221007,
    "nome": "Taquaral de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221080,
    "nome": "Teresina de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221197,
    "nome": "Terezópolis de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221304,
    "nome": "Três Ranchos",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221452,
    "nome": "Trombas",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221502,
    "nome": "Turvânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221551,
    "nome": "Turvelândia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221577,
    "nome": "Uirapuru",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221601,
    "nome": "Uruaçu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221700,
    "nome": "Uruana",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221809,
    "nome": "Urutaí",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5221908,
    "nome": "Varjão",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5222005,
    "nome": "Vianópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5222054,
    "nome": "Vicentinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5222203,
    "nome": "Vila Boa",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  },
  {
    "codigoIbge": 5222302,
    "nome": "Vila Propício",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "municAnoPesquisa": 2024
  }
]
